import {
  ICON_ENGLISH,
  ICON_ENGLISH_40_30,
  ICON_THAI,
  ICON_THAI_40_30,
} from "./useIcons";
import {
  STYLE_ICON_FLAQ_DRAWER,
  STYLE_ICON_FLAQ_MODUAL,
  STYLE_IMG_LANGUAGE,
} from "./useStyle";

export const WWW = "https://mylaundrythai.com";

export const LAST_TIME_YOU_STILL_CAN_BOOK = 19;
export const TIME_THAT_STILL_SAME_DAY_SERVICE = 12;
export const RETURN_TIME = 12;
export const RETURN_SHOSE_TIME = 22;
export const START_HOUR = 8;
export const TIME_STRING_ENG = "pm";
export const RETURN_SAME_DAY = 22;

export const SYMBOL_CURRENCY = "฿";
export const TEXT_WASH = {
  EN: "Wash",
  TH: "ซัก",
};
export const TEXT_SHOES = {
  EN: "Shoes",
  TH: "รองเท้า",
};
//TYPE
export const TYPE_MYWASH = "MY WASH";
export const TYPE_MYDRY = "MY DRY";
export const TYPE_MYIRON = "MY IRON";
export const TYPE_MYSHOES = "MY SHOES";
export const TYPE_VISA = "V";
export const TYPE_MASTERCARD = "M";
export const TYPE_CASH = "CASH";
export const TYPE_CUP = "C";
export const TYPE_JCB = "J";
export const TYPE_PAYPAL = "P";
export const TYPE_ALIPAY = "AL";
export const TYPE_WECHAT = "WE";
export const TYPE_TRUEMONEY = "TM";
export const TYPE_WORK = "WORK";
export const TYPE_HOME = "HOME";
export const TYPE_OTHER = "OTHER";
export const TYPE_PROMPAY = "PP";

export const MAX_TEXT_LENGTH = 500;

//PROGRAMS
export const TEXT_ADD_PROGRAM = {
  EN: "Add Service",
  TH: "เพิ่มบริการ",
};
export const TEXT_MYORDER = {
  EN: "My Orders",
  TH: "ออเดอร์ของฉัน",
};
export const TEXT_PROGRAMS = {
  EN: "Programs",
  TH: "โปรแกรม",
};

export const TEXT_PROGRAM_MYWASH = "My Wash";
export const TEXT_PROGRAM_MYWASH_DESCRIPTION = {
  EN: "Wash & Fold – for clothes, towels and more",
  TH: "ซัก-พับ สำหรับเสื้อผ้า ผ้าเช็ดตัวและอื่นๆ",
};

export const TEXT_PROGRAM_MYIRON = "My Iron";
export const TEXT_PROGRAM_MYIRON_DESCRIPTION = {
  EN: "Iron & Fold – you wash and we iron for you",
  TH: "รีด-พับ คุณซักเอง เรารีดให้",
};

export const TEXT_PROGRAM_MYDRY = "My Dry-Clean";
export const TEXT_PROGRAM_MYDRY_DESCRIPTION = {
  EN: "For all types of regular clothes",
  TH: "ซักแห้งเสื้อผ้าทั่วไปทุกประเภท",
};

export const TEXT_PROGRAM_MYSHOES = "My Shoes";
export const TEXT_PROGRAM_MYSHOES_DESCRIPTION = {
  EN: "For all types of shoes",
  TH: "ซักรองเท้าทุกประเภท",
};
export const TEXT_CREATE_ORDER = {
  EN: "Create Order",
  TH: "สร้างออเดอร์",
};

export const TEXT_CREATE_BASKET = {
  EN: "Create Basket",
  TH: "สร้างตะกร้า",
};
export const TEXT_SELECT_SERVICE = {
  EN: "Select Service",
  TH: "เลือกบริการ",
};
export const TEXT_UPTO = {
  EN: "Up to",
  TH: "มากถึง",
};
export const TEXT_PIECES_MY_LAUNDRY = {
  EN: "pieces or 1x My Laundry Bag",
  TH: "หรือ 1 ถุงใส่ผ้า My Laudry",
};
export const TEXT_RETURNED_IN_24_HOURS = {
  EN: "Returned in 24 Hours",
  TH: "ส่งคืนภายใน 24 ชั่วโมง",
};
export const TEXT_PICKUP_AND_RETURN = {
  EN: "Pick-Up & Return",
  TH: "รับ-ส่งคืน",
};
export const TEXT_CONTACTLESS_PICKUP_RETURN = {
  EN: "Contactless Pick-Up & Return",
  TH: "รับและส่งคืนแบบไร้การสัมผัส",
};
export const TEXT_EDIT = {
  TH: "แก้ไข",
  EN: "Edit",
};

export const TEXT_PLEASE_SELECT_LOCATION = {
  TH: "กรุณาเลือกที่อยู่",
  EN: "Please select Address first",
};

export const TEXT_PICKUP = {
  EN: "Pick-Up",
  TH: "รับ",
};
export const TEXT_RETURN = {
  EN: "Return",
  TH: "ส่งคืน",
};
export const TEXT_PIECES = {
  EN: "Pieces",
  TH: "ชิ้น",
};
// export const TEXT_FOR = {
//   EN : "For",
//   TH: "สำหรับ",
// }
// export const  TEXT_PAIRS_OF_SHOES = {
//   EN: "Pairs of shoes",
//   TH: "รองเท้า",

// }

//ADDONS
export const TEXT_SELECT_ADDONS = {
  EN: "Add-Ons",
  TH: "เพิ่มเติม",
};
export const TEXT_ADDONS = {
  EN: "Add-Ons",
  TH: "เพิ่มเติม",
};
export const TEXT_IRON = {
  EN: "Iron",
  TH: "รีด",
};
export const TEXT_NOSOFTENER = "No Softner";
export const TEXT_SMOOTH_STARCH = "Smooth Starch";
export const TEXT_ANTIBACTERIAL_SANITISER = "Antibacterial Sanitiser";
export const TEXT_LAUNDRY_PERFUME = "Laundry Perfume";
export const TEXT_HIGH_TEMPERATURE_WASH = "High Temperature Wash";
export const TEXT_ORGANIC_WASH = "Organic Wash";
export const TEXT_LOW_HEAT_DRY = "Low Heat Dry";
export const TEXT_BABY_WASH = "Baby Wash";
export const TEXT_HANG = "Hang";
export const TEXT_STAIN_REMOVAL = "Stain Removal";
export const TEXT_HANG_PLUS = "Hang Plus+";
export const TEXT_PROTECTION_WATERPROOF = {
  EN: "Protection & Waterproofing",
  TH: "ผลิตภัณฑ์เคลือบและกันน้ำ",
};
export const TEXT_DEODORANT_DISINFECTION = "Deodorant & Disinfection";

//Extra
export const TEXT_EXTRAS = {
  EN: "Extras",
  TH: "เพิ่มเติม",
};

export const TEXT_BEDDING = {
  EN: "Bedding",
  TH: "เครื่องนอน",
};
export const TEXT_COMFORTER_OR_DUVET_INSERT = "Comforter or Duvet Insert";
export const TEXT_PILLOWS = "Pillows";
export const TEXT_DUVET_COVER_OR_BED_SHEET = "Duvet Cover or Bed Sheet";
export const TEXT_BLEACHING_FOR_WHITES = "Bleaching for Whites";

//DRINKING WATER
export const TEXT_DRINKING_WATER = {
  EN: "Finn Drinking Water",
  TH: "น้ำดื่มฟิน",
};
export const TEXT_DELIVERED_ON_PICKUP = {
  EN: "Delivered on Return",
  TH: "จัดส่งเวลาส่งคืนออเดอร์",
};
export const TEXT_BOTTLE = {
  EN: "bottle",
  TH: "ขวด",
};

//LOCATIONS
export const TEXT_LOCATIONS = {
  EN: "Locations",
  TH: "ที่ตั้ง",
};
export const TEXT_BANGKOK = {
  EN: "Bangkok",
  TH: "กรุงเทพ",
};
export const TEXT_PATTAYA = {
  EN: "Pattaya",
  TH: "พัทยา",
};

//LANGUAGE
export const TEXT_LANGUAGE = {
  EN: "Language",
  TH: "ภาษา",
};
export const TEXT_ENGLISH = "English";
export const TEXT_THAI = {
  EN: "Thai",
  TH: "ไทย",
};
export const CONSTANT_LANGUAGE_FULL = {
  EN: "English",
  TH: "ไทย",
};
export const CONSTANT_LANGUAGE = {
  EN: "EN",
  TH: "TH",
};

export const CONSTANT_LANGUAGE_IMAGE = {
  TH: <ICON_THAI className={STYLE_IMG_LANGUAGE} />,
  EN: <ICON_ENGLISH className={STYLE_IMG_LANGUAGE} />,
};

export const CONSTANT_LANGUAGE_IMAGE_MODAL = {
  TH: <ICON_THAI_40_30 className={STYLE_ICON_FLAQ_MODUAL} />,
  EN: <ICON_ENGLISH_40_30 className={STYLE_ICON_FLAQ_MODUAL} />,
};
export const CONSTANT_LANGUAGE_IMAGE_DRAWER = {
  TH: <ICON_ENGLISH className={STYLE_ICON_FLAQ_DRAWER} />,
  EN: <ICON_THAI className={STYLE_ICON_FLAQ_DRAWER} />,
};

//PROFILE
export const TEXT_MY_PROFILE = {
  EN: "My Profile",
  TH: "โปรไฟล์",
};
export const TEXT_LOG_IN = {
  EN: "Log In",
  TH: "เข้าสู่ระบบ",
};
export const TEXT_LOG_OUT = {
  EN: "Log Out",
  TH: "ออกจากระบบ",
};
export const TEXT_COUNTRY_CODE = {
  EN: "Country Code",
  TH: "รหัสประเทศ",
};
export const TEXT_OTP = {
  EN: "Enter OTP",
  TH: "ใส่รหัส OTP",
};
export const TEXT_OTP_SENT_SMS = {
  EN: "An OTP code was sent via SMS to",
  TH: "ส่งรหัส OTP ผ่าน SMS ไปที่",
};
export const TEXT_DIDNT_RECIEVE_SMS = {
  EN: "Didn’t receive an SMS?",
  TH: "ยังไม่ได้รับ SMS?",
};
export const TEXT_TRY_AGAIN = {
  EN: "Try Again",
  TH: "ลองอีกครั้ง",
};
export const TEXT_IN_SECOND = {
  EN: "in [value] seconds",
  TH: "หลัง [value] วินาที",
};
export const TEXT_COMPLETE_PROFILE = {
  EN: "Complete Profile",
  TH: "กรอกข้อมูลส่วนตัว",
};
export const TEXT_PHONE_NUMBER = {
  EN: "Phone Number",
  TH: "เบอร์โทรศัพท์",
};
export const TEXT_EMAIL = {
  EN: "E-Mail",
  TH: "อีเมล",
};
export const TEXT_FULL_NAME = {
  EN: "Full Name",
  TH: "ชื่อ-นามสกุล",
};
export const TEXT_PLEASE = {
  EN: "Please",
  TH: "กรุณา",
};
export const TEXT_TO_YOUR_PROFILE = {
  EN: " to see your profile.",
  TH: "เพื่อดูโปรไฟล์ของคุณ",
};

export const TEXT_SAVE = {
  EN: "Save",
  TH: "บันทึก",
};

export const TEXT_NEXT = {
  EN: "Next",
  TH: "ต่อไป",
};

//FOOTER
export const TEXT_OUR_SERVICE = {
  EN: "Our Services",
  TH: "บริการของเรา",
};
export const TEXT_FAQ = {
  EN: "FAQ",
  TH: "คำถามที่พบบ่อย",
};
export const TEXT_PRICING = {
  EN: "Pricing",
  TH: "ราคา",
};

export const TEXT_PRICING_SERVICE = {
  EN: "Pricing & Services",
  TH: "ราคาและบริการ",
};

export const TEXT_GLOSSARY = {
  EN: "Glossary",
  TH: "อภิธานศัพท์",
};

export const TEXT_CONTACT_US = {
  EN: "Contact Us",
  TH: "ติดต่อเรา",
};
export const TEXT_ABOUT_US = {
  EN: "About Us",
  TH: "เกี่ยวกับเรา",
};
export const TEXT_MY_ORDERS = {
  EN: "My Orders",
  TH: "ออเดอร์ของฉัน",
};
export const TEXT_NO_ORDER = {
  EN: "You did not create an order yet.",
  TH: " คุณยังไม่ได้ทำออเดอร์",
};

export const TEXT_NO_BUSKET = {
  EN: "You did not select a service yet.",
  TH: "คุณยังไม่ได้เลือกบริการ",
};
export const TEXT_SEND_OTP = {
  EN: " We will send an OTP code via SMS to verify your phone number.",
  TH: "เราจะส่งรหัส OTP ไปทาง SMS เพื่อยืนยันเบอร์โทรศัพท์ของคุณ",
};
export const TEXT_SEND_OTP_MB = {
  EN: "We will send an OTP code via SMS to verify your phone",
  TH: "เราจะส่งรหัส OTP ไปทาง SMS เพื่อยืนยัน",
};
export const TEXT_CHANGE_COUTRY_CODE = {
  EN: " You can change the Country Code by clicking on the flag icon.",
  TH: "ซึ่งคุณสามารถเปลี่ยนรหัสประเทศโดยคลิกที่สัญลักษณ์รูปธง",
};
export const TEXT_CHANGE_COUTRY_CODE_MB = {
  EN: "You can change the Country Code by clicking",
  TH: "ซึ่งคุณสามารถเปลี่ยนรหัสประเทศโดยคลิกที่สัญลักษณ์รูปธง",
};
export const TEXT_ON_THE_FLAG_ICON_MB = {
  EN: "on the flag icon. By logging in, you agree to the My",
  TH: "การเข้าสู่ระบบแสดงว่าคุณได้ตกลงยอมรับ",
};

export const TEXT_LOGGING_IN = {
  EN: "By logging in, you agree to the My Laundry",
  TH: "การเข้าสู่ระบบแสดงว่าคุณได้ตกลงยอมรับ",
};
export const TEXT_LOGGING_IN_MB = {
  EN: "Laundry",
  TH: "",
};
export const TEXT_REDUCE_REUSE_RECYCLE = {
  EN: "Reduce, Reuse & Recycle",
  TH: "ลด ใช้ซ้ำ นำกลับมาใช้ใหม่",
};

//ADDRESS
export const TEXT_FIND_YOUR_ADDRESS = {
  EN: "Find Your Address",
  TH: "ค้นหาที่อยู่",
};
export const TEXT_ADDRESS_SEARCH = {
  EN: "Address Search",
  TH: "ค้นหาที่อยู่",
};
export const TEXT_ADDRESS = {
  EN: "Address",
  TH: "ที่อยู่",
};
export const TEXT_ADDRESSES = {
  EN: "Addresses",
  TH: "ที่อยู่",
};

export const STATUS_ORDER_PROCESSING = "PROCESSING";
export const STATUS_ORDER_COMPLETED = "COMPLETED";
export const STATUS_ORDER_CANCELED = "CANCELED";
export const TEXT_PAYMENT = {
  EN: "Payment Methods",
  TH: "วิธีการชำระเงิน",
};
export const TEXT_TO_ADD_AN_ADDRESS = {
  EN: "to add an address.",
  TH: "เพื่อเพิ่มที่อยู่",
};
export const TEXT_ADDRESS_EMPTY = {
  EN: "You did not add an address yet.",
  TH: "คุณยังไม่ได้เพิ่มที่อยู่",
};
export const TEXT_ADD_ADRESS = {
  EN: "Add Address",
  TH: "เพิ่มที่อยู่",
};
export const TEXT_ADDRESS_NOTFOUND = {
  EN: "Enter your address above and find a match. You can also choose an address from the map. ",
  TH: " ค้นหาที่อยู่ด้านบน โดยคุณจะเห็นคำแนะนำที่อยู่ต่างๆ ให้เลือกหรือสามารถเลือกที่อยู่จากแผนที่เองก็ได้",
};
export const TEXT_ADDRESS_DATA_NOTFOUND = {
  EN: "Enter your address above and find a match. You can also choose an address from the map. ",
  TH: "ป้อนที่อยู่ของคุณด้านบนและค้นหาที่ตรงกัน คุณยังสามารถเลือกที่อยู่จากแผนที่",
};
export const TEXT_CHOOSE_ADDRESS = {
  EN: "Choose from Map",
  TH: "เลือกจากแผนที่",
};
export const TEXT_PRIMARY_ADDRESS = {
  EN: "Primary Address",
  TH: "ที่อยู่หลัก",
};
export const TEXT_CONFIRM = {
  EN: "Confirm",
  TH: "ยืนยัน",
};
export const TEXT_CANCEL = {
  EN: "Cancel",
  TH: "ยกเลิก",
};
export const TEXT_REMOVE = {
  EN: "Remove",
  TH: "ลบ",
};
export const TEXT_SAVE_ADDRESS = {
  EN: " SAVE ADRRESS",
  TH: " บันทึกที่อยู่",
};
export const TEXT_PRIMARY = {
  EN: "Set as Primary ",
  TH: "ตั้งเป็นที่อยู่หลัก",
};
export const TEXT_YOUR_LOCATION_IS_NOT_AVAILABLE = {
  EN: "Your location is not available",
  TH: "ตำแหน่งของคุณไม่เปิดให้บริการ",
};
export const TEXT_SAVED_ADDRESSES = {
  EN: "Saved Addresses",
  TH: "ที่อยู่ที่บันทึกไว้",
};
export const TEXT_SEARCH_AGAIN = {
  EN: "Search Again",
  TH: "ค้นหาอีกครั้ง",
};

//PRIVACY-MORE
export const TEXT_PRIVACY_POLICY = {
  EN: "Privacy Notice",
  // TH: "นโยบายความเป็นส่วนตัว",
  TH: "ประกาศความเป็นส่วนตัว",
};
export const TEXT_TERM_AND_CONDITION = {
  EN: "Terms & Conditions",
  TH: "ข้อกำหนดและเงื่อนไข",
};

export const TEXT_MORE = {
  EN: "More",
  TH: "อื่นๆ",
};

export const TEXT_SELECT_PROGRAM = {
  EN: "Select Your Service",
  TH: "เลือกบริการ",
};

export const TEXT_OPTIONAL = {
  EN: "optional",
  TH: "ถ้ามี",
};

export const TEXT_AND_LOGIN = {
  EN: "and",
  TH: "รวมถึง",
};

//ORDER - BUSKET
export const TEXT_ORDER = {
  EN: "Order",
  TH: "ออเดอร์",
};
export const TEXT_BUSKET = {
  EN: "Basket",
  TH: "ตะกร้า",
};
export const TEXT_ADDRESS_DETAILS = {
  EN: "Address Details",
  TH: "รายละเอียดที่อยู่",
};
export const TEXT_SAMEDAY_SERVICE = {
  EN: "Same Day Express Service",
  TH: "บริการส่งคืนด่วนในวันเดียวกัน",
};
export const TEXT_DATE_AND_TIME = {
  EN: "Date",
  TH: "วันที่",
};
export const TEXT_PLEASE_SELECT_DATE = {
  EN: "Please select Date",
  TH: "กรุณาเลือกวันที่",
};
export const TEXT_ORDER_SUMMARY = {
  EN: "Order Summary",
  TH: "สรุปออเดอร์",
};
export const TEXT_SPECIAL_REQUEST = {
  EN: "Special Request",
  TH: "ความต้องการพิเศษ",
};
export const TEXT_TAX_INVOICE = {
  EN: "Tax Invoice",
  TH: "ใบกำกับภาษี",
};
export const TEXT_CREDIT_DEBITCARD = "Credit / Debit Card";
export const TEXT_DELETE = {
  EN: "Delete",
  TH: "ลบ",
};

export const TEXT_DELETE_ADDRESS = {
  EN: "Delete Address?",
  TH: "ลบที่อยู่?",
};
export const TEXT_QUESTION_DELETE = {
  EN: "Are you sure you want to delete this address?",
  TH: "คุณต้องการลบที่อยู่นี้ใช่ไหม?",
};
export const TEXT_DELETE_PROGRAM = {
  EN: "Delete Service?",
  TH: "ลบบริการ?",
};
export const TEXT_ARE_YOU_SURE = {
  EN: "Are you sure you want to delete this Service?",
  TH: "คุณต้องการลบบริการนี้ใช่ไหม?",
};
export const TEXT_TOTAL = {
  EN: "Total",
  TH: "ยอดทั้งหมด",
};
export const TEXT_INCL_VAT = "incl. VAT";
export const TEXT_INPROCESS = {
  EN: "In Process",
  TH: "ดำเนินการอยู่",
};
export const TEXT_COMPLETED = {
  EN: "Completed",
  TH: "ออเดอร์สำเร็จ",
};
export const TEXT_CANCELLED = {
  EN: "Cancelled",
  TH: "ยกเลิกแล้ว",
};
// export const TEXT_SAVE_TO_GALLERY = {
//   EN: "Save to Gallery",
//   TH: "บันทึกในแกลเลอรี่",
// };
export const TEXT_SAVE_TO_GALLERY = {
  EN: "Download as PDF",
  TH: "ดาวน์โหลดเป็น PDF",
};
export const TEXT_SUBTOTAL = {
  EN: "Sub-Total ",
  TH: "ยอดรวม ",
};
export const TEXT_VAT = "VAT 0% ";
export const TEXT_ORDER_RECIEVED = {
  EN: "Order Received",
  TH: "ได้รับออเดอร์แล้ว",
};
export const ARRAY_DATE = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

export const TEXT_HOME = {
  EN: "Home",
  TH: "หน้าหลัก",
};
export const TEXT_ADD_TO_BASKET = {
  EN: "Add to Basket",
  TH: "เพิ่มไปยังตะกร้า",
};
export const TEXT_QUESTION_ABOUT_YOUR_ORDER = {
  EN: "  Questions about your order?",
  TH: "มีคำถามเกี่ยวกับออเดอร์ของคุณไหม?",
};
export const TEXT_TO_SEE_YOUR_ORDER = {
  EN: "to see your orders",
  TH: "เพื่อดูรายการสั่งซื้อของคุณ",
};
export const TEXT_ACTIVE = {
  EN: "Active",
  TH: "ออเดอร์ปัจจุบัน",
};

export const TEXT_PAST = {
  EN: "Past",
  TH: "ออเดอร์ก่อนหน้า",
};
export const TEXT_WE_RECIVED_YOUR_ORDER = {
  EN: " We received your order and will process it now. You can rely on us: we will pick-up and return your order on time!",
  TH: "เราได้รับออเดอร์ของคุณแล้ว และจะดำเนินการทันที ให้คุณแน่ใจว่าเราจะไปรับและส่งคืนตรงเวลา!",
};

export const TEXT_IF_YOU_HAVE_ANY_QUESTIONS = {
  EN: "If you have any questions about your order you can",
  TH: "หากมีคำถามอื่นๆเกี่ยวกับออเดอร์ของคุณ",
};
export const TEXT_TELL_US = {
  EN: "Tell us about your laundry and shoes.",
  TH: "กรุณาบอกเราเกี่ยวกับเสื้อผ้าและรองเท้าของคุณ",
};
export const TEXT_CHOOSE_DATE_AND_TIME = {
  EN: "Change Dates",
  TH: "เลือกวันที่",
};
export const TEXT_PICKUP_DATE_AND_TIME = {
  EN: "Pick-Up Date",
  TH: "วันที่รับ",
};
export const TEXT_RETURN_DATE_AND_TIME = {
  EN: "Return Date",
  TH: "วันที่ส่งคืน",
};
export const TEXT_PLACE_ORDER = {
  EN: "Place Order",
  TH: "สั่งออเดอร์",
};

//HOME
export const TEXT_ARE_YOU_SURE_LOGOUT = {
  EN: "Are you sure you want to Log Out?",
  TH: "คุณต้องการออกจากระบบใช่ไหม?",
};

export const TEXT_CHOOSE_AND_CUSTOMIZE = {
  EN: "Choose & Customize",
  TH: "เลือกและเพิ่ม",
};

export const TEXT_CHOOSE_AND_CUSTOMIZE_DESCRIPTION = {
  EN: "Choose one or more of our signature ",
  TH: "แค่เลือกโปรแกรมและเพิ่มสิ่งที่คุณต้องการ",
};

export const TEXT_CHOOSE_AND_CUSTOMIZE_MB = {
  EN: "Choose one or more of our signature laundry",
  TH: "แค่เลือกโปรแกรมและเพิ่มสิ่ง",
};

export const TEXT_LAUDRY_PROGRAMS_AND_CUSTOMIZE = {
  EN: "laundry programs and customize as  ",
  TH: "ที่คุณต้องการ",
};
export const TEXT_LAUDRY_PROGRAMS_AND_CUSTOMIZE_MB = {
  EN: "programs and customize",
  TH: "จากนั้นเลือกวันและเวลารับ-",
};

export const TEXT_AS_NEEDED_MB = {
  EN: "as needed Then select",
  TH: "ส่งคืนผ้า",
};

export const TEXT_THEN_SELECT_YOUR_PREFERRED = {
  EN: "needed. Then select your preferred ",
  TH: " จากนั้นเลือกวันและเวลารับ-ส่งคืนผ้า",
};

export const TEXT_YOUR_PREFERRED_MB = {
  EN: "your preferred",
  TH: "",
};

export const TEXT_SELECT_YOUR_PROGRAM = {
  EN: "Select Your Service",
  TH: "เลือกบริการ",
};

export const TEXT_PICK_UP_RETURN_DATE_TIME_SLOT = {
  EN: "pick-up and return date and a time slot.",
  TH: "",
};

export const TEXT_PICK_UP_AND_RETURN_DATE_MB = {
  EN: "pick-up and return date",
  TH: "",
};

export const TEXT_AND_TIME_SLOT_MB = {
  EN: "and a time slot.",
  TH: "",
};

export const TEXT_WE_TAKE_CARE = {
  EN: "We take care of everything",
  TH: "ยินดีให้บริการ",
};
export const TEXT_WE_TAKE_CARE_DESCRIPTION_ALL = {
  EN: `We GUARANTEE next-day return for all orders: Laundry by ${RETURN_TIME}:00 noon, shoes or combined shoes & laundry orders by ${RETURN_SHOSE_TIME}:00 - fast & easy! Our service is fully CONTACTLESS to save your valuable time - you never need to wait for us, neither for pick up nor for return!`,
  TH: `เรารับประกันว่าจะส่งคืนทุกออเดอร์ในวันถัดไป: เสื้อผ้าและเครื่องนอนภายใน ${RETURN_TIME}:00 น. รองเท้าหรือออเดอร์รวมผ้ากับรองเท้าภายใน ${RETURN_SHOSE_TIME}:00 น. สะดวกและรวดเร็ว! บริการไร้การสัมผัสของเราช่วยคุณประหยัดเวลา - คุณไม่ต้องรอการรับส่งคืนออเดอร์เลย!`,
};

export const TEXT_WE_TAKE_CARE_DESCRIPTION = {
  EN: "We pick up the laundry and shoes at your ",
  TH: "เราจะไปรับผ้าและรองเท้าของคุณตามที่อยู่ที่ระบุไว้ ",
};
export const TEXT_WE_TAKE_CARE_MB = {
  EN: "We pick up the laundry",
  TH: "เราจะไปรับผ้าและรองเท้าของ",
};
export const TEXT_AND_SHOES_AT_YOUR_MB = {
  EN: "and shoes at your",
  TH: "คุณตามที่อยู่ที่ระบุไว้ และ",
};

export const TEXT_DESIGNATED_ADDRESS_AND_RETURN = {
  EN: "designated address and return it to the same ",
  TH: "",
};
export const TEXT_DESIGNATED_ADDRESS_MB = {
  EN: "designated address and",
  TH: "",
};
export const TEXT_RETURN_IT_TO_THE_SAME_MB = {
  EN: "return it to the same",
  TH: "",
};

export const TEXT_PLCE_IN_JUST = {
  EN: "place in just 24 hours – freshly washed and ",
  TH: "และส่งคืนที่เดิมภายใน 24 ชั่วโมง",
};
export const TEXT_PLACE_IN_24_HOURS_MB = {
  EN: "place in just 24 hours –",
  TH: "ส่งคืนที่เดิมภายใน 24 ชั่วโมง",
};
export const TEXT_FRESHLY_WASHED_AND_MB = {
  EN: "freshly washed and",
  TH: "",
};
export const TEXT_TREATED_WITH_CARE_BY_OUR_DEDECATED = {
  EN: "treated with care by our dedicated laundry team. ",
  TH: " รับประกันความสะอาดหอมสดชื่น ดูแลอย่างพิถีพิถัน",
};
export const TEXT_TREATED_WITH_CARE_MB = {
  EN: "treated with care by our",
  TH: "รับประกันความสะอาด",
};

export const TEXT_DEDICATED_LAUNDRY_TEAM_MB = {
  EN: "dedicated laundry team.",
  TH: "หอมสดชื่นดูแลอย่างพิถีพิถัน",
};
export const TEXT_A_SAME_DAY_ERVICE = {
  EN: "A Same-Day Service is also available.",
  TH: " พร้อมทั้งมีบริการส่งคืนในวันเดียวกัน",
};
export const TEXT_A_SAME_DAY_SERVICE_MB = {
  EN: "A Same-Day Service is",
  TH: "พร้อมทั้งมีบริการส่งคืนใน",
};
export const TEXT_ALSO_AVAILABLE_MB = {
  EN: " also available.",
  TH: "วันเดียวกัน",
};
export const TEXT_EASY_AND_CONVENTIENT = {
  EN: "Easy & Convenient",
  TH: "ง่ายและสะดวก",
};
export const TEXT_EASY = {
  EN: "Easy & Convenient",
  TH: "ง่ายและ",
};
export const TEXT_CONVENIENT = {
  EN: "",
  TH: "สะดวก",
};
export const TEXT_EASY_AND_CONVENIENT_ALL = {
  EN: "All our prices are fully inclusive – no delivery fees and no hidden charges. After your first order, you will even receive our original My Laundry Bags for free which you can use to make all subsequent laundry service orders easier and more convenient. ",
  TH: "ราคาของเรารวมทุกอย่างแล้วไม่มีค่าส่งหรือค่าบริการอื่นๆเพิ่มเติม หลังจากสั่งออเดอร์ครั้งแรกคุณจะได้รับถุงใส่ผ้ามายลอนดรี้ฟรี ซึ่งใช้ได้กับ",
};
export const TEXT_EASIER_AND_MORE_CONVENIENT = {
  EN: "",
  TH: "ออเดอร์ครั้งต่อไป ง่ายและสะดวกจริงๆ",
};
export const TEXT_EASY_AND_CONVENTIENT_DESCRIPTION = {
  EN: "Laundry and shoe-cleaning services that ",
  TH: "ให้การซักผ้าและทำความสะอาดรองเท้าง่าย ",
};
export const TEXT_EASY_AND_CONVENTIENT_MB = {
  EN: "All our prices are fully inclusive – no delivery fees",
  TH: "ราคาของเรารวมทุกอย่างแล้ว ",
};
export const TEXT_SERVICE_THAT_MB = {
  EN: "and no hidden charges.",
  TH: "ไม่มีค่าส่ง หรือค่าบริการอื่นๆเพิ่มเติม",
};

export const TEXT_EASY_ORDERING = {
  EN: "are as easy as ordering food online. ",
  TH: "เหมือนสั่งอาหารด้วยราคาที่รวมทุกอย่างแล้ว",
};
export const TEXT_ORDERING_FOOD_MB = {
  EN: "After your first order, you will even receive our original My Laundry Bags for free",
  TH: "หลังจากสั่งออเดอร์ครั้งแรก คุณจะได้รับถุงใส่ผ้ามายลอนดรี้ฟรี",
};
export const TEXT_ALL_OUR_PRICES_ARE_FULLY_INCLUSIVE = {
  EN: "All our prices are fully inclusive – no delivery ",
  TH: "ราคาของเรารวมทุกอย่างแล้ว ไม่มีค่าส่ง ไม่มีค่าบริการอื่นๆเพิ่มเติม",
};
export const TEXT_PRICE_ARE_FULLY_MB = {
  EN: "which you can use to make all subsequent laundry service orders easier and more convenient.",
  TH: "ซึ่งใช้ได้กับออเดอร์ครั้งต่อไป ง่ายและสะดวกจริงๆ",
};
export const TEXT_FEES_AND_NO_HIDDEN_CHARGES = {
  EN: "fees and no hidden charges. After your first order,  ",
  TH: "หลังจากสั่งออเดอร์ครั้งแรก คุณจะได้รับถุงใส่ผ้ามายลอนดรี้ฟรี",
};
export const TEXT_DELIVERY_FEES_NO_HIDDEN_MB = {
  EN: "delivery fees and no hidden",
  TH: "ไม่มีค่าบริการอื่นๆ พิเศษ! ",
};

export const TEXT_AFTR_YOUR_FIST_ORDER = {
  EN: "you will even receive our original My Laundry Bags  ",
  TH: "",
};
export const TEXT_AFTER_YOUR_FIRST_MB = {
  EN: "charges. After your first ",
  TH: "",
};
export const TEXT_ORDER_YOU_WILL_EVEN_MB = {
  EN: "order, you will even receive ",
  TH: "",
};
export const TEXT_OG_MY_LAUNDRY_BAGS = {
  EN: " ",
  TH: " ซึ่งใช้ได้กับออเดอร์ครั้งต่อไป ง่ายและสะดวกจริงๆ",
};
export const TEXT_WHICH_YOU_CAN_USE = {
  EN: "for free  which you can use to make all subsequent laundry service orders easier and more convenient.",
  TH: "",
};

export const TEXT_OUR_OG_MB = {
  EN: "our original My Laundry Bags",
  TH: "รับถุงใส่ผ้าฟรี ",
};
export const TEXT_FOR_FREE_MB = {
  EN: "for free!",
  TH: "หลังใช้บริการครั้งแรก",
};
export const TEXT_LISENCE = "© 2022 My Laundry";
export const TEXT_LISENCE_TITLE = {
  EN: "We wash with",
  TH: "เราซักด้วย",
};

export const TEXT_PLACEHOLDER_ADDRESS_DETAIL = {
  EN: "Contactless Pick-Up & Return is our standard. Please tell us where exactly we can pick and return your order (e.g. the drop-off point of your condo, the lobby of your hotel or from the receptionist or security guard)",
  TH: "บริการรับและส่งคืนแบบไร้การสัมผัสเป็นมาตรฐานของเรา กรุณาบอกจุดรับและส่งคืนออเดอร์ให้ชัดเจน (เช่น จุดรับส่งของคอนโด ล็อบบี้หรือประชาสัมพันธ์ของโรงแรม หรือ รปภ.)",
};

export const TEXT_NOMORE_OPTION = "No more options";
export const TEXT_NO_CREDITCARD = "No credit card";
export const TEXT_TAX_INVOICE_FILL =
  "Please enter your Full Name/Company Name, Address and Tax ID in order to receive a Tax Invoice via E-Mail.";
export const TEXT_HOW_IT_WORKS = {
  EN: "How It Works",
  TH: "ใช้งานอย่างไร",
};
export const TEXT_DES_HOW_IT_WORKS_DESKTOP = {
  EN: "Our professional laundry service and shoe cleaning service are as easy as ordering food or shopping online and come at",
  TH: "ร้านซักผ้าและทำความสะอาดรองเท้ามายลอนดรี้ให้คุณใช้บริการง่ายเหมือนสั่งอาหารหรือสั่งสินค้าออนไลน์",
};
export const TEXT_DES_HOW_IT_WORKS_IPAD = {
  EN: "Our professional laundry service and shoe cleaning service are as easy as ordering food or",
  TH: "ร้านซักผ้าและทำความสะอาดรองเท้ามายลอนดรี้ให้คุณใช้บริการง่ายเหมือนสั่งอาหารหรือสั่งสินค้าออนไลน์ ด้วย",
};
export const TEXT_DES_HOW_IT_WORKS_IPAD_2 = {
  EN: "shopping online and come at",
  TH: "",
};
export const TEXT_DES_HOW_IT_WORKS_2 = {
  EN: " fixed",
  TH: "",
};
export const TEXT_PRICES = {
  EN: "prices",
  TH: "ราคา",
};
export const TEXT_PRICE_NO_S = {
  EN: "price",
  TH: "ราคา",
};
export const TEXT_NO_SURPRIZE = {
  EN: "with no surprises.",
  TH: "แน่นอน ให้คุณแน่ใจ",
};
export const TEXT_TRY_IT_ONCE = {
  EN: " Try them once and you will use them every time!",
  TH: " ลองสักครั้ง แล้วคุณจะติดใจ!",
};
export const TEXT_DES_HOW_IT_WORKS_MB = {
  EN: " Our laundry and shoe-cleaning services are ",
  TH: "บริการซักผ้าและทำความสะอาดรองเท้า",
};
export const TEXT_DES_QUICK_AND_EASY = {
  EN: "as quick and easy as ordering food and come at",
  TH: "ของเราง่าย เหมือนสั่งอาหารหรือ",
};
export const TEXT_TRY_IT_ONCE_MB = {
  EN: "fixed ",
  TH: "สั่งสินค้าออนไลน์ ด้วย",
};
export const TEXT_NO_PRICE_MB = {
  EN: "with no surprises. ",
  TH: "ที่แน่นอน ",
};
export const TEXT_TRY_IT_ONCE_MB_2 = {
  EN: "Try it once and you",
  TH: "ให้คุณแน่ใจ ลองสักครั้ง",
};
export const TEXT_WILL_USE_IT_MB = {
  EN: " will use it every time!",
  TH: "แล้วคุณจะติดใจตลอดไป",
};
export const TEXT_OUR_ANSWER = {
  EN: "Here are the answers to your most frequently asked questions about our laundry service and our shoe cleaning service in Bangkok.",
  TH: "นี่คือคำตอบสำหรับคำถามที่พบบ่อยเกี่ยวกับร้านซักผ้าและทำความสะอาดรองเท้า",
};
export const TEXT_OUR_ANSWER_2 = {
  TH: "มายลอนดรี้ในกรุงเทพ",
};
export const TEXT_OUR_ANSWER_MB = {
  EN: "Here are the answers to your most frequently asked questions about our laundry service and our shoe cleaning service in",
  TH: "นี่คือคำตอบสำหรับคำถามที่พบบ่อยเกี่ยวกับร้านซักผ้าและทำความสะอาดรองเท้ามายลอนดรี้ใน",
};
export const TEXT_BKK_AND_PTY = {
  EN: "Bangkok.",
  TH: "กรุงเทพ",
};
export const TEXT_HAVE_MORE_QUESTION = {
  EN: " Have more questions?",
  TH: "คุณยังมีคำถามอีกใช่ไหม?",
};
export const TEXT_SHOW_MORE = {
  EN: "Show More",
  TH: "แสดงเพิ่ม",
};

export const TEXT_SHOW_LESS = {
  EN: "Show Less",
  TH: "แสดงน้อยลง",
};
export const TEXT_GO_TO_FAQ = {
  EN: "Go to FAQ",
  TH: "ไปหน้า คำถามที่พบบ่อย",
};
export const TEXT_WASH_IRON_CLEAN = {
  EN: " Wash • Iron • Clean Shoes",
  TH: "ซัก • รีด • ซักรองเท้า",
};
export const TEXT_AVAILABLE = {
  EN: "Available in",
  TH: "ให้บริการใน",
};
export const TEXT_AVAILABLE_POLICY = {
  EN: "available ",
  TH: "ดูข้อมูลเพิ่มเติม ",
};
export const TEXT_AND = {
  EN: "&",
  TH: "และ",
};
export const TEXT_AND_WORD = {
  EN: " and ",
  TH: " และ ",
};
export const TEXT_FIXED_PRICE = {
  EN: "Fixed Price – No Surprises",
  TH: "ราคาแน่นอน ให้คุณแน่ใจ",
};
export const TEXT_FIXED_PRICE_MB = {
  EN: "Fixed Price – No Surprises. Our fixed-price packages ",
  TH: "ราคาแน่นอน ให้คุณแน่ใจด้วยแพ็กเกจราคาที่แน่นอนของเรา",
};
export const TEXT_OUR_CONFIXED = {
  EN: " Our fixed-price packages cover all your ",
  TH: "ด้วยแพ็กเกจราคาที่แน่นอนของเราตอบสนองความต้องการซักรีดของคุณ",
};
export const TEXT_COVER_ALL_YOUR_MB = {
  EN: "cover all your laundry requirements, from small to big",
  TH: "ตอบสนองความต้องการซักรีดของคุณ ",
};
export const TEXT_FROM_SMALL_TO_BIG = {
  EN: " laundry requirementsfrom small to big loads, from basic to purely ",
  TH: "ตั้งแต่ปริมาณการซักรีดขนาดเล็กไปจนถึงขนาดใหญ่ จากมาตรฐานไปจนถึงออร์แกนิค",
};
export const TEXT_LOADS_FROM_MB = {
  EN: "loads, from basic to purely organic wash, with or without",
  TH: "ตั้งแต่ปริมาณการซักรีดขนาดเล็กไปจนถึงขนาดใหญ่ ",
};
export const TEXT_WITHOUT_IRONING = {
  EN: "organic wash with or without ironing, and much more. For the cleanest",
  TH: "ทั้งแบบรีดหรือไม่รีด และอื่นๆอีกมากมาย",
};
export const TEXT_IRONING_AND_MUCH_MORE_MB = {
  EN: "ironing, and much more. For the cleanest washing ",
  TH: "จากมาตรฐานไปจนถึงออร์แกนิค ทั้งแบบรีดหรือไม่รีด",
};
export const TEXT_FOR_THEBEST_WASH = {
  EN: " washing results",
  TH: "นอกจากนี้เพื่อให้การซักผ้าสะอาดมากที่สุด",
};
export const TEXT_RESULT_MB = {
  EN: "results, we use only the best Bosch washing machines. If ",
  TH: "และอื่นๆอีกมากมาย นอกจากนี้เพื่อให้การซักผ้าสะอาดมากที่สุด ",
};
export const TEXT_WASH_MACHINE_TH = {
  EN: "",
  TH: "เราใช้เครื่องซักผ้าดีที่สุดของยี่ห้อ บ๊อช",
};
export const TEXT_BEST_MACHINE = {
  EN: "we use only the best Bosch washing machines. If you",
  TH: "เราใช้เครื่องซักผ้าดีที่สุดของยี่ห้อ บ๊อช จากประเทศเยอรมนีเท่านั้น",
};

export const TEXT_WASH_BY_YOURSELF = {
  EN: " prefer to wash by yourself, we can just iron for you!",
  TH: "หากคุณต้องการซักด้วยตัวเอง เรายินดีให้บริการรีดผ้าเพียงอย่างเดียว",
};
export const TEXT_YOU_PREFER_MB = {
  EN: "you prefer to wash by yourself, we can just iron for you!",
  TH: "จากประเทศเยอรมนีเท่านั้น หากคุณต้องการซักด้วยตัวเอง ",
};
export const TEXT_WASH_BY_YOURSELF_TH = {
  TH: "เรายินดีให้บริการรีดผ้าเพียงอย่างเดียว ",
  EN: "",
};

export const TEXT_WASH_YOUR_SHOES = {
  EN: "We also clean all ",
  TH: "และยังมีบริการทำความสะอาดรองเท้าทุกประเภทให้ด้วย",
};
export const TEXT_TYPES_OF_SHOES = {
  EN: "types of shoes.",
  TH: "",
};
export const TEXT_SELECT = {
  EN: "Select",
  TH: "เลือก",
};
export const TEXT_YOUR_PROGRAM_NOW = {
  EN: "your Programs now!",
  TH: "โปรแกรมที่คุณต้องการได้เลย",
};
export const TEXT_WELCOME = {
  EN: "Welcome!",
  TH: "ยินดีต้อนรับ ",
};

export const TEXT_LAUNDRY_SERVICE = {
  EN: "Do you have a laundry service near me?",
  TH: "คุณรู้จักร้านซักผ้าใกล้ฉันไหม? ",
};
export const TEXT_LAUNDRY_SERVICE_MB = {
  EN: "Do you have a laundry service near me?",
  TH: "คุณรู้จักร้านซักผ้า",
};

//DOYOUKNOW
export const TEXT_LAUNDRY_SERVICE_BKK = {
  EN: "#LaundryServiceBangkok",
  TH: "#LaundryServiceBangkok",
};
export const TEXT_LAUNDRY_SERVICE_PTY = {
  EN: "#LaundryServicePattaya",
  TH: "#LaundryServicePattaya",
};

//SELECT YOUR SERVICE
export const TEXT_JUST_CLICK_ON = {
  EN: "Just click on one of our fully-customisable services below to start. Our promise: we only use highly energy-efficient washing and drying machines from Germany which not only deliver the best washing results but are also friendly to the environment.",
  TH: "เริ่มต้นง่ายๆ แค่เลือกบริการที่คุณต้องการด้านล่าง มายลอนดรี้ให้คุณมั่นใจว่าเราใช้เครื่องซักอบผ้าที่ประหยัดพลังงานสูงสุดจากประเทศเยอรมนี ซึ่งให้ผลลัพธ์ในการซักผ้าดีที่สุดและเป็นมิตรต่อสิ่งแวดล้อมด้วย",
};
export const TEXT_OUR_ON_DEMAND = {
  EN: "right below to create an order! Our on-demand laundry service and our shoe cleaning service are both fully customisable to meet all your requirements in a one-stop solution. My Laundry is committed to protecting the environment. Part of our sustainability strategy involves using highly energy-efficient washing and drying machines from Germany, which are not only friendly to the environment but also deliver the best washing results for you",
  TH: "ด้านล่างเพื่อสร้างออเดอร์! ร้านซักผ้าและทำความสะอาดรองเท้ามายลอนดรี้ให้คุณเลือกและเพิ่มตามความต้องการแบบครบวงจร ด้วยความมุ่งมั่นเพื่อสิ่งแวดล้อมที่ยั่งยืน เราเลือกใช้เครื่องซักผ้าและเครื่องอบผ้าที่มีประสิทธิภาพประหยัดพลังงานสูงสุดจากประเทศเยอรมนี นอกจากจะเป็นมิตรต่อสิ่งแวดล้อมแล้ว ยังให้ผลลัพธ์ในการซักอบแห้งที่ยอดเยี่ยมที่สุดด้วย",
};

//HOW IT WORKS

export const TEXT_ALL_CHOOSE_1 = {
  EN: `All our services can be customised to create a one-stop laundry service and shoe cleaning service solution. We also provide value-added services such as delivering bottled drinking water when returning your order.`,
  TH: `คุณสามารถเลือกและเพิ่มบริการซักผ้าและทำความสะอาดรองเท้าของเราตามความต้องการแบบครบวงจรนอกจากนี้เราขอแนะนำบริการส่งน้ำดื่มแบบขวดเมื่อส่งคืนออเดอร์ให้คุณ`,
};

export const TEXT_ALL_OUR_SERVICE = {
  EN: "All our services can be customised as needed",
  TH: "คุณสามารถเลือกและเพิ่มบริการซักผ้าและทำความสะอาดรองเท้า",
};
export const TEXT_TO_MEET_REQUIREMENT = {
  EN: "to meet your requirements as a one-stop  laundry",
  TH: "ของเราตามความต้องการแบบครบวงจร จากนั้นเลือกวัน",
};
export const TEXT_TO_MEET_REQUIREMENT_MB = {
  EN: "to meet your requirements as a one-stop  laundry",
  TH: "ของเราตามความต้องการแบบครบวงจร จากนั้นเลือกวันและเวลารับส่งคืน ",
};
export const TEXT_SERVICE_AND_SHOES = {
  EN: "service and shoe cleaning service solution. Next, just",
  TH: "และเวลารับส่งคืน เท่านี้ก็พร้อมเริ่มต้นได้เลย",
};
export const TEXT_SERVICE_AND_SHOES_MB = {
  EN: "service and shoe cleaning service solution. Next, just select your preferred pick-up and return date and a time slot and you are ready to go.",
  TH: "เท่านี้ก็พร้อมเริ่มต้นได้เลย",
};

export const TEXT_THEN_SELECT_YOUR_PREFERRED_PICKUP = {
  EN: "select your preferred pick-up and return date and a",
  TH: "",
};
export const TEXT_TIME_SLOT_FYSV = {
  EN: "time slot and you are ready to go.",
  TH: "",
};

//WELCOME
export const TEXT_WELCOME_AND_SAWASDEE = {
  EN: "Welcome & Sawasdee",
  TH: "ยินดีต้อนรับ & สวัสดี",
};

export const TEXT_WELCOME_DES_ALL = {
  EN: "As a professional laundry service and premium shoe cleaning service, our policy is Fixed Price – No Surprises. Our fixed-price packages cover all your laundry requirements, from small to big loads, from basic to purely organic washes, with or without ironing, and much more. For the cleanest washing results, we use only the best Bosch washing machines from Germany! With our shoe cleaning service, we clean shoes of all colours and types, from sneakers to leather shoes, while we specialise in white sneakers made from leather or other modern fabrics.",
  TH: "ร้านซักผ้าและทำความสะอาดรองเท้ามายลอนดรี้มีนโยบายคือ ราคาแน่นอน ให้คุณแน่ใจ ด้วยแพ็กเกจราคาที่แน่นอนตอบสนองความต้องการซักรีดทั้งหมดของคุณ ตั้งแต่ปริมาณการซักผ้าขนาดเล็กไปจนถึงใหญ่ จากการซักผ้ามาตรฐานไปจนถึงออร์แกนิค ทั้งแบบรีดและไม่รีด และอื่นๆ เพื่อให้การซักผ้าสะอาดมากที่สุด เราใช้เครื่องซักผ้าดีที่สุดยี่ห้อบ๊อชจากประเทศเยอรมนีเท่านั้น นอกจากนี้เรามีบริการทำความสะอาดรองเท้าทุกสีทุกประเภท ตั้งแต่รองเท้าผ้าใบไปจนถึงรองเท้าหนัง โดยเฉพาะรองเท้าผ้าใบสีขาวที่ทำจากหนังหรือวัสดุทันสมัย  ",
};

export const TEXT_AS_PRO_WELCOME = {
  EN: "As a professional laundry service and premium shoe cleaning service, our policy is",
  TH: "ร้านซักผ้าและทำความสะอาดรองเท้ามายลอนดรี้มีนโยบายคือ",
};

export const TEXT_TO_PRO_MB = {
  EN: "As a professional laundry service ",
  TH: "ร้านซักผ้าและทำความสะอาดรองเท้ามายลอนดรี้มีนโยบายคือ",
};
export const TEXT_TO_PRO_MB_2 = {
  EN: " and premium shoe cleaning service, our policy is",
  TH: "",
};
//FAQ
export const TEXT_CREATE = {
  EN: "Create",
  TH: "สร้างออเดอร์",
};
export const TEXT_AN_ORDER_NOW = {
  EN: "an order now!",
  TH: "ตอนนี้เลย!",
};
export const TEXT_AN_ORDER_NOW_2 = {
  EN: "an order now.",
  TH: "ตอนนี้เลย!",
};
export const TEXT_MY_FIRST_ORDER = {
  EN: " My First Order",
  TH: "ออเดอร์แรกของฉัน ",
};
export const TEXT_WHAT_BAGS_SHOULD_I_USE = {
  EN: "What bags should I use for my first laundry service order? ",
  TH: "ฉันควรใช้ถุงอะไรเวลาสั่งออเดอร์ครั้งแรก? ",
};

export const TEXT_FOR_YOUR_ORDER_YOU_CAN_USE = {
  EN: "For your first laundry service order, you can use any bag which you have readily available! ",
  TH: "สำหรับการสั่งออเดอร์ครั้งแรกกับร้านซักผ้ามายลอนดรี้ คุณสามารถใช้ถุงอะไรก็ได้ที่คุณมี!",
};
export const TEXT_GOOD_TO_KNOW_FIRST_ORDER = {
  EN: "Good to know: After your first order, you will receive our original My Laundry Bags for free. For all subsequent orders, you don’t need to count the pieces anymore as you can just fill up the original My Laundry Bag until it’s full regardless of how many pieces are inside or how much it weighs as long as you can still close the bag properly. This applies for both My Wash and My Iron. One full My Laundry Bag is equal to the S Package; two full My Laundry Bags are equal to the M Package, and three full My Laundry Bags are equal to the L Package. The My Laundry Service is that easy.",
  TH: " ข้อมูลน่ารู้ หลังจากสั่งออเดอร์ครั้งแรกแล้ว คุณจะได้รับถุงใส่ผ้ามายลอนดรี้ฟรี จากนั้นในการสั่งออเดอร์ครั้งต่อไป คุณไม่จำเป็นต้องนับจำนวนผ้าว่ามีกี่ชิ้นหรือน้ำหนักเท่าไหร่ แค่คุณต้องปิดถุงใส่ผ้ามายลอนดรี้ให้เรียบร้อย สำหรับบริการ My Wash และ My Iron ร้านซักผ้ามายลอนดรี้ทำให้คุณสะดวกและง่าย หนึ่งถุงใส่ผ้ามายลอนดรี้เทียบเท่ากับแพ็กเกจ S สองถุงใส่ผ้ามายลอนดรี้เทียบเท่ากับแพ็กเกจ M และสามถุงใส่ผ้ามายลอนดรี้เทียบเท่ากับแพ็กเกจ L มายลอนดรี้ทำให้รู้สึกเหมือนมีร้านซักอบแห้งใกล้ฉันจริงๆ!",
};
export const TEXT_DO_I_NEED_FIRST_ORDER = {
  EN: "Do I need to sort my clothes into colours and whites?",
  TH: "ฉันต้องแยกผ้าสีกับผ้าขาวไหม?",
};
export const TEXT_AS_PART_OF_OUR_FIRST_ORDER = {
  EN: "NO. As part of our professional laundry service, we will sort them for you as standard!",
  TH: "ไม่ต้อง ทีมซักอบรีดของเราจะแยกเสื้อผ้าให้คุณเอง!",
};
export const TEXT_DO_I_NEED_WEIGH_FIRST_ORDER = {
  EN: "Do I need to weigh the laundry and inform you?",
  TH: "ฉันต้องชั่งน้ำหนักของผ้าแล้วบอกคุณไหม?",
};
export const TEXT_NO_YOU_DONT_NEED_TO_FIRST_ORDER = {
  EN: "NO. You don´t need to weigh your laundry and inform us!",
  TH: "ไม่ต้อง คุณไม่ต้องชั่งน้ำหนักของผ้าแล้วบอกเรา",
};

export const TEXT_OUR_PROFESSINAL_FIRST_ORDER = {
  EN: " Our professional laundry service policy is Fixed Price – No Surprises. This is what sets us apart from other laundry service providers who charge you by weight so you never know in advance how much you will really pay in the end. As part of our premium laundry service and shoe cleaning service in Bangkok, we are here to change the laundry service in Thailand for good! At My Laundry, you can be confident that you know the price you will pay for your laundry or shoes before we come to pick them up, as easy as ordering food or shopping online!",
  TH: `ร้านซักผ้ามายลอนดรี้มีนโยบายคือ ราคาแน่นอน ให้คุณแน่ใจ สิ่งนี้ทำให้เราแตกต่างจากร้านซักผ้ารายอื่นๆ ที่เรียกเก็บเงินตามน้ำหนักเป็นกิโล โดยที่คุณไม่เคยรู้ราคาล่วงหน้าเลยว่าสุดท้ายแล้วคุณต้องจ่ายเท่าไหร่ ร้านซักผ้าและทำความสะอาดรองเท้าของเราในกรุงเทพ จึงมาเพื่อเปลี่ยนแปลงรูปแบบของร้านรับซักผ้าเดลิเวอร์รี่ให้ดีขึ้น! มายลอนดรี้ทำให้คุณมั่นใจได้ว่าคุณจะรู้ราคาที่ต้องชำระก่อนเราไปรับผ้าหรือรองเท้าของคุณ ทุกอย่างจึงง่ายเหมือนการสั่งอาหารหรือซื้อสินค้าออนไลน์`,
};
export const TEXT_MY_OUR_PRO_FIEST_ORDER = {
  EN: "At My Laundry, you can be confident that you know the price you will pay for your laundry or shoes before we come to pick them up, as easy as ordering food or shopping online!",
  TH: "มายลอนดรี้ทำให้คุณมั่นใจได้ว่าคุณจะรู้ราคาที่ต้องชำระก่อนเราไปรับผ้าหรือรองเท้าของคุณ ทุกอย่างจึงง่ายเหมือนการสั่งอาหารหรือซื้อสินค้าออนไลน์",
};
export const TEXT_YOUR_SERVICE_SHOE_FIRST_ORDER = {
  EN: "your desired laundry service or shoe cleaning service now to see our",
  TH: "บริการซักรีดหรือซักรองเท้าที่คุณต้องการตอนนี้เพื่อดู",
};
export const TEXT_OK_KA = {
  EN: "",
  TH: "ได้เลย",
};
export const TEXT_WHEN_WILL_MY_ORDER_FIRST_ORDER = {
  EN: "When will my order be returned? ",
  TH: "คุณจะส่งคืนออเดอร์ของฉันเมื่อไหร่? ",
};
export const TEXT_YOUR_ORDER_WILL_FIRST_ORDER = {
  EN: `As a professional laundry service and shoe cleaning service, we guarantee that all orders placed by ${LAST_TIME_YOU_STILL_CAN_BOOK}:00 will be picked up on the same day and returned by ${RETURN_TIME}:00 the next day - fast & easy!`,
  TH: `ในฐานะที่เราเป็นร้านซักผ้าและทำความสะอาดรองเท้าแบบมืออาชีพ เรารับประกันว่าทุกออเดอร์ที่สั่งภายใน ${LAST_TIME_YOU_STILL_CAN_BOOK}:00 น. เราจะไปรับในวันเดียวกันและส่งคืนภายใน ${RETURN_TIME}:00 น. ของวันถัดไป สะดวกและรวดเร็ว!`,
};
export const TEXT_AS_PROFESSIONAL_LAUNDRY_FIRST_ORDER = {
  EN: "As a professional laundry service and shoe cleaning service, our standard turnaround time is 24 hours. For example: If you have chosen the time-slot 14:00-16:00 for the Pick-Up of your order on Monday, then your order will be returned between 14:00-16:00 on Tuesday. We also offer a Same Day Express Laundry Service and Same Day Express Shoe Cleaning Service where your order is picked up between 10:00-12:00 in the morning and will be returned between 16:00-19:00 in the early evening of the same day. Note: our Same Day Express Laundry Service and Same Day Express Shoe Cleaning Service are only available in Bangkok and can be booked before and until 11:30 am on the same day you wish to use the service. For all orders, we will return it on or before the scheduled time if we finish it earlier. In the rare case you wish your order returned later than 24 hours, you can also always choose a later return time-slot for your utmost convenience.",
  TH: "ร้านซักผ้าและทำความสะอาดรองเท้ามายลอนดรี้มีเวลารับส่งคืนแบบมาตรฐานภายใน 24 ชั่วโมง เช่น หากคุณเลือกเวลาไปรับออเดอร์วันจันทร์ 14:00-16:00 น. เราจะส่งคืนออเดอร์วันอังคาร 14:00-16:00 น. นอกจากนี้เรายังมีบริการส่งคืนด่วนในวันเดียวกัน ซึ่งจะไปรับออเดอร์ในช่วงเวลา 10:00-12:00 น. และส่งคืนในช่วงเวลา 16:00-19:00 น. ของวันเดียวกัน หมายเหตุ บริการส่งคืนด่วนในวันเดียวกันมีเฉพาะในกรุงเทพเท่านั้น และสามารถจองได้จนถึง 11:30 น. ของวันที่คุณต้องการใช้บริการ ร้านซักผ้าและทำความสะอาดรองเท้ามายลอนดรี้จะส่งคืนทุกออเดอร์ตรงเวลาหรือก่อนเวลาหากออเดอร์เรียบร้อยเร็วกว่าที่กำหนด ในบางกรณีหากคุณต้องการให้ส่งคืนช้ากว่า 24 ชั่วโมง คุณสามารถเลือกช่วงเวลาส่งคืนอื่นๆได้ เพื่อความสะดวกสูงสุดของคุณ",
};
export const TEXT_ONE_PAIRS_EQUAL_ONE_PIECE = {
  EN: "Is 1 pair of socks equal to 1 piece?",
  TH: "ถุงเท้า 1 คู่ เท่ากับ 1 ชิ้น ใช่ไหม? ",
};
export const TEXT_YES_ONE_PARIS_EQUAL_ONE_PIECE = {
  EN: "YES. 1 pair of socks is equal to 1 piece. ",
  TH: "ใช่ เรานับถุงเท้า 1 คู่ เป็น 1 ชิ้น ",
};
export const TEXT_MY_LAUNDRY_IS_FAIR_FIRST = {
  EN: "The My Laundry Service is that fair and easy.",
  TH: "ร้านซักผ้ามายลอนดรี้ ยุติธรรมและง่ายจริงๆ!",
};
export const TEXT_WHY_CHOOSE_MY_LAUNDRY = {
  EN: "Why choose My Laundry?",
  TH: "ทำไมเลือก มายลอนดรี้?",
};

export const TEXT_CHECKOUT_FAQ = {
  EN: "Check out",
  Th: "เช็คดู",
};
export const TEXT_GOT_A_QUESTION = {
  EN: "Got a question? Get your answer!",
  TH: "คุณถามมา เราตอบไป!",
};
export const TEXT_FAQ_HAVE_MORE_QUESTIONS = {
  EN: "Here are the answers to your most frequently asked questions about our laundry service",
  TH: "นี่คือคำตอบสำหรับคำถามที่พบบ่อยเกี่ยวกับร้านซักผ้า",
};
export const TEXT_FAQ_HAVE_MORE_QUESTIONS_BKK = {
  EN: " and our shoe cleaning service in ",
  TH: "และทำความสะอาดรองเท้าของเราใน",
};
export const TEXT_PRICING_AND_PAYMENT = {
  EN: "Pricing & Payment",
  TH: "ราคาและการชำระเงิน",
};
export const TEXT_IS_THERE_ANY_MINIMUM_ORDER = {
  EN: "Is there any minimum order charge? ",
  TH: "มีค่าสั่งออเดอร์ขั้นต่ำไหม? ",
};
export const TEXT_NO_MINIMUM_ORDER = {
  EN: "NO. There is no minimum order charge. ",
  TH: "ไม่มี ไม่มีค่าสั่งออเดอร์ขั้นต่ำ",
};
export const TEXT_ALL_OUR_PRICE_PRICING = {
  EN: " All our prices are fully inclusive – no delivery fees or hidden charges. ",
  TH: " ราคาของเรารวมทุกอย่างแล้ว ไม่มีค่าส่งหรือค่าบริการอื่นๆเพิ่มเติม ร้านซักผ้าและทำความสะอาดรองเท้ามายลอนดรี้มีนโยบายคือ ราคาแน่นอน ให้คุณแน่ใจ สิ่งนี้ทำให้เราแตกต่างจากร้านซักผ้ารายอื่นๆ ที่เรียกเก็บเงินตามน้ำหนักเป็นกิโล โดยที่คุณไม่เคยรู้ราคาล่วงหน้าเลยว่าสุดท้ายแล้วคุณต้องจ่ายเท่าไหร่ ร้านซักผ้าและทำความสะอาดรองเท้าของเราในกรุงเทพ จึงมาเพื่อเปลี่ยนแปลงรูปแบบของร้านรับซักผ้าเดลิเวอร์รี่ให้ดีขึ้น! มายลอนดรี้ทำให้คุณมั่นใจได้ว่าคุณจะรู้ราคาที่ต้องชำระก่อนเราไปรับผ้าหรือรองเท้าของคุณ ทุกอย่างจึงง่ายเหมือนการสั่งอาหารหรือซื้อสินค้าออนไลน์",
};
export const TEXT_ALL_OUR_PRICE_PRICING_2 = {
  EN: "Our professional laundry service policy is Fixed Price – No Surprises. This is what sets us apart from other laundry service providers who charge you by weight so you never know in advance how much you will really pay in the end. As part of our premium laundry service and shoe cleaning service in Bangkok, we are here to change the laundry service in Thailand for good! At My Laundry, you can be confident that you know the price you will pay for your laundry or shoes before we come to pick them up, as easy as ordering food or shopping online!",
  TH: "",
};
export const TEXT_YOUR_DESIRED_LAUNDRY_PRICING =
  TEXT_YOUR_SERVICE_SHOE_FIRST_ORDER;
export const TEXT_ARE_THEY_HIDDEN_FEES = {
  EN: "Are there any hidden fees? ",
  TH: "มีค่าบริการอื่นๆเพิ่มเติมไหม? ",
};
export const TEXT_NO_ALL_OUR_LAUNDRY_RE_FULLY_INCLUSIVE = {
  EN: "NO. All our laundry service and shoe cleaning service prices are fully inclusive – no delivery fees or hidden charges.",
  TH: "ไม่มี ราคาของเรารวมทุกอย่างแล้ว ไม่มีค่าส่งหรือค่าบริการอื่นๆเพิ่มเติม",
};
export const TEXT_OUR_PROFESSION_PRICING = {
  EN: " Our professional laundry service policy is Fixed Price – No Surprises. This is what sets us apart from other laundry service providers who charge you by weight so you never know in advance how much you will really pay in the end. As part of our premium laundry service and shoe cleaning service in Bangkok, we are here to change the laundry service in Thailand for good! At My Laundry, you can be confident that you know the price you will pay for your laundry or shoes before we come to pick them up, as easy as ordering food or shopping online!",
  TH: " ร้านซักผ้าและทำความสะอาดรองเท้า มายลอนดรี้มีนโยบายคือ ราคาแน่นอน ให้คุณแน่ใจ สิ่งนี้ทำให้เราแตกต่างจากร้านซักผ้ารายอื่นๆ ที่เรียกเก็บเงินตามน้ำหนักเป็นกิโล โดยที่คุณไม่เคยรู้ราคาล่วงหน้าเลยว่าสุดท้ายแล้วคุณต้องจ่ายเท่าไหร่ ร้านซักผ้าและทำความสะอาดรองเท้าของเราในกรุงเทพ จึงมาเพื่อเปลี่ยนแปลงรูปแบบของร้านรับซักผ้าเดลิเวอร์รี่ให้ดีขึ้น! มายลอนดรี้ทำให้คุณมั่นใจได้ว่าคุณจะรู้ราคาที่ต้องชำระก่อนเราไปรับผ้าหรือรองเท้าของคุณ ทุกอย่างจึงง่ายเหมือนการสั่งอาหารหรือซื้อสินค้าออนไลน์",
};
export const TEXT_HOW_CAN_I_KNOW_HOW_MUCH = {
  EN: "How can I know how much my order amount is?",
  TH: "ฉันจะรู้ได้อย่างไรว่าออเดอร์ของฉันราคาเท่าไหร่?",
};
export const TEXT_THIS_IS_WHAT_SETS_UP_PRICING = {
  EN: " This is what sets us apart from other laundry service providers who charge you by weight so you never know in advance how much you will really pay in the end. As part of our premium laundry service and shoe cleaning service in Bangkok, we are here to change the laundry service in Thailand for good! At My Laundry, you can be confident that you know the price you will pay for your laundry or shoes before we come to pick them up, as easy as ordering food or shopping online!",
  TH: `สิ่งนี้ทำให้ร้านซักผ้ามายลอนดรี้แตกต่างจากร้านซักผ้ารายอื่นๆ ที่เรียกเก็บเงินตามน้ำหนักเป็นกิโล โดยที่คุณไม่เคยรู้ราคาล่วงหน้าเลยว่าสุดท้ายแล้วคุณต้องจ่ายเท่าไหร่ ร้านซักผ้าและทำความสะอาดรองเท้าของเราในกรุงเทพ`,
};
export const TEXT_THIS_IS_WHAT_SETS_UP_PRICING_2 = {
  EN: "",
  TH: "จึงมาเพื่อเปลี่ยนแปลงรูปแบบของร้านรับซักผ้าเดลิเวอร์รี่ให้ดีขึ้น! มายลอนดรี้ทำให้คุณมั่นใจได้ว่าคุณจะรู้ราคาที่ต้องชำระก่อนเราไปรับผ้าหรือรองเท้าของคุณ ทุกอย่างจึงง่ายเหมือนการสั่งอาหารหรือซื้อสินค้าออนไลน์",
};
export const TEXT_WHAT_IS_PRICING_STRATEGY = {
  EN: "What is the pricing strategy for My Laundry Services? ",
  TH: "มายลอนดรี้มีการกำหนดราคาอย่างไร? ",
};
export const TEXT_THIS_IS_WHAT_SETS_UP_FROM_OTHER_LAUNDRY = {
  EN: " This is what sets us apart from other laundry service providers who charge you by weight so you never know in advance how much you will really pay in the end. As part of our premium laundry service and shoe cleaning service in Bangkok, we are here to change the laundry service in Thailand for good! At My Laundry, you can be confident that you know the price you will pay for your laundry or shoes before we come to pick them up, as easy as ordering food or shopping online!",
  TH: " สิ่งนี้ทำให้ร้านซักผ้ามายลอนดรี้แตกต่างจากร้านซักผ้ารายอื่นๆ ที่เรียกเก็บเงินตามน้ำหนักเป็นกิโล โดยที่คุณไม่เคยรู้ราคาล่วงหน้าเลยว่าสุดท้ายแล้วคุณต้องจ่ายเท่าไหร่ ร้านซักผ้าและทำความสะอาดรองเท้าของเราในกรุงเทพ จึงมาเพื่อเปลี่ยนแปลงรูปแบบของร้านรับซักผ้าเดลิเวอร์รี่ให้ดีขึ้น! มายลอนดรี้ทำให้คุณมั่นใจได้ว่าคุณจะรู้ราคาที่ต้องชำระก่อนเราไปรับผ้าหรือรองเท้าของคุณ ทุกอย่างจึงง่ายเหมือนการสั่งอาหารหรือซื้อสินค้าออนไลน์",
};
export const TEXT_WHEN_AND_HOW_DO_I_PAY = {
  EN: "When & how do I pay? ",
  TH: "ฉันจะจ่ายเงินเมื่อไหร่และอย่างไร? ",
};
export const TEXT_YOU_PAY_FOR_YOUR_ORDER_PRICING = {
  EN: "You pay for your order when you place your order - the same as when ordering food or shopping online. ",
  TH: "คุณจะจ่ายเงินเมื่อทำการสั่งออเดอร์ เช่นเดียวกับการสั่งอาหารหรือซื้อสินค้าออนไลน์",
};
export const TEXT_AS_OUR_STANDARD = {
  EN: "As our standard and recommendation, the default payment method for our laundry service and shoe cleaning service is Credit/Debit Card. However, we also offer you alternative payment methods which range from local bank transfers to QR Code Payments or Cash Advance (Cash Advance is only available for personal orders via our messenger channels - Please [Contact Us,/ContactUs]). We are also hoping to add Wallet Payments soon!",
  TH: ` ร้านซักผ้าและทำความสะอาดรองเท้า  มายลอนดรี้มีวิธีการชำระเงินแบบมาตรฐานคือบัตรเครดิต/เดบิต อย่างไรก็ตามเรามีตัวเลือกการชำระเงินอื่นๆ ตั้งแต่การโอนเงินผ่านธนาคาร ไปจนถึงการชำระเงินผ่าน QR Code หรือชำระเงินสดล่วงหน้า และจะเพิ่มช่องทางการชำระเงินผ่าน Wallet เร็วๆนี้!`,
};
export const TEXT_WHAT_IF_I_PUT_IN_MORE_LAUNDRY = {
  EN: "What if I put in more laundry or shoes than I booked? ",
  TH: "ถ้าฉันใส่ผ้าหรือรองเท้าในถุงมากกว่าที่เลือกไว้แล้วล่ะ? ",
};
export const TEXT_SHOULD_YOU_FIND_PRICING = {
  EN: "Should you find you have more laundry or shoes to clean after you already booked a laundry service or shoe cleaning service, we will automatically upgrade you to the next higher package. ",
  TH: "หากคุณพบว่ามีผ้าหรือรองเท้าที่ต้องซักมากกว่าที่จองแพ็กเกจไปแล้ว เราจะอัพเกรดคุณเป็นแพ็กเกจถัดไปที่สูงกว่าโดยอัตโนมัติ",
};
// export const TEXT_GOOD_TO_KNOW_PRICING = {
//   EN: "Good to know: After your first order, you will receive our original My Laundry Bags for free. For all subsequent orders, you don’t need to count the pieces anymore as you can just fill up the original My Laundry Bag until it’s full regardless of how many pieces are inside or how much it weighs as long as you can still close the bag properly. This applies for both My Wash and My Iron. One full My Laundry Bag is equal to the S Package; two full My Laundry Bags are equal to the M Package, and three full My Laundry Bags are equal to the L Package. The My Laundry Service is that easy.",
//   TH: " ข้อมูลน่ารู้ หลังจากสั่งออเดอร์ครั้งแรกแล้ว คุณจะได้รับถุงใส่ผ้ามายลอนดรี้ฟรี จากนั้นในการสั่งออเดอร์ครั้งต่อไป คุณไม่จำเป็นต้องนับจำนวนผ้าว่ามีกี่ชิ้นหรือน้ำหนักเท่าไหร่ เพียงแค่คุณต้องปิดถุงใส่ผ้ามายลอนดรี้ให้เรียบร้อย สำหรับบริการ My Wash และ My Iron ร้านซักผ้ามายลอนดรี้ทำให้คุณสะดวกและง่าย หนึ่งถุงใส่ผ้ามายลอนดรี้เทียบเท่ากับแพ็กเกจ S สองถุงใส่ผ้ามายลอนดรี้เทียบเท่ากับแพ็กเกจ M และสามถุงใส่ผ้ามายลอนดรี้เทียบเท่ากับแพ็กเกจ L มายลอนดรี้ทำให้รู้สึกเหมือนมีร้านซักอบแห้งใกล้ฉันจริงๆ!",
// };
export const TEXT_GOOD_TO_KNOW_PRICING = {
  EN: "Good to know: After your first order, you will receive our original My Laundry Bags for free. For all subsequent orders, you don’t need to count the pieces anymore as you can just fill up the original My Laundry Bag until it’s full regardless of how many pieces are inside or how much it weighs as long as you can still close the bag properly.",
  TH: " ข้อมูลน่ารู้ หลังจากสั่งออเดอร์ครั้งแรกแล้ว คุณจะได้รับถุงใส่ผ้ามายลอนดรี้ฟรี จากนั้นในการสั่งออเดอร์ครั้งต่อไป คุณไม่จำเป็นต้องนับจำนวนผ้าว่ามีกี่ชิ้นหรือน้ำหนักเท่าไหร่ เพียงแค่คุณต้องปิดถุงใส่ผ้ามายลอนดรี้ให้เรียบร้อย",
};
export const TEXT_DOES_MY_LAUNDRY_STORE_MY_CREDIT_CARD = {
  EN: "Does My Laundry store my credit/debit card data?",
  TH: "มายลอนดรี้เก็บข้อมูลบัตรเครดิต/เดบิตของฉันไหม? ",
};
export const TEXT_NO_AS_A_PROFESSIONAL_LAUNDRY_SERVICE = {
  EN: "NO. As a professional and reliable laundry service and shoe cleaning service, My Laundry does not store your credit/debit card data!",
  TH: "ไม่ ในฐานะที่เราเป็นร้านซักผ้าและทำความสะอาดรองเท้าแบบมืออาชีพที่เชื่อถือได้ มายลอนดรี้จะไม่เก็บข้อมูลบัตรเครดิต/เดบิตของคุณ",
};
export const TEXT_PICKUP_AND_RETURN_FAQ = {
  EN: "Pick-Up & Return",
  TH: "รับและส่งคืน",
};
export const TEXT_DO_I_HAVE_TO_BE_AT_HOME = {
  EN: "Do I have to be at home for Pick-Up & Return? ",
  TH: "ฉันต้องอยู่ที่บ้านเวลารับและส่งคืนออเดอร์ไหม? ",
};
export const TEXT_CONTACTLESS_PICK_UP = {
  EN: "NO. As part of our professional laundry service and shoe cleaning service, contactless Pick-Up & Return is our standard. ",
  TH: "ไม่ต้อง ร้านซักผ้าและทำความสะอาดรองเท้ามายลอนดรี้มีมาตรฐานการรับและส่งคืนออเดอร์แบบไร้การสัมผัส",
};
export const TEXT_BEFORE_PLACING_ORDER_PICKUP = {
  EN: "Before placing your order, simply tell us in the RED BOX in the basket where exactly we can pick up and return your order (e.g. your front door, hotel reception, security office, lobby, mailroom, etc.). We can pick up and return your laundry service or shoe cleaning service order to any place that is readily accessible to us and safe to protect your order from rain or other natural hazards.",
  TH: " ก่อนการสั่งออเดอร์ เพียงแค่แจ้งในกล่องสีแดงในตะกร้าและบอกจุดรับส่งคืนผ้าที่ชัดเจน (เช่น ประตูด้านหน้า แผนกต้อนรับของโรงแรม รปภ. ล็อบบี้ ห้องรับจดหมาย เป็นต้น) เราสามารถไปรับและส่งคืนออเดอร์ของคุณทุกที่ที่เข้าถึงได้ และยินดีดูแลออเดอร์ของคุณให้ปลอดภัยจากฝนหรือภัยธรรมชาติต่างๆ",
};
export const TEXT_OFFER_CONTACTLESS_PICKUP = {
  EN: "Do you offer Contactless Pick-Up & Return? ",
  TH: "คุณมีการรับและส่งคืนออเดอร์แบบไร้การสัมผัสไหม? ",
};
export const TEXT_YES_CONTACTLESS_PICKUP = {
  EN: "YES. As part of our professional laundry service and shoe cleaning service, contactless Pick-Up & Return is our standard. ",
  TH: "มี ร้านซักผ้าและทำความสะอาดรองเท้ามายลอนดรี้มีมาตรฐานการรับและส่งคืนออเดอร์แบบไร้การสัมผัส ",
};
export const TEXT_BEFORE_PLACING_YOUR_ORDER_PICKUP = {
  EN: "Before placing your order, simply tell us in the RED BOX in the basket where exactly we can pick up and return your order (e.g. your front door, hotel reception, security office, lobby, mailroom, etc.). We can pick up and return your laundry service or shoe cleaning service order to any place that is readily accessible to us and safe to protect your order from rain or other natural hazards.",
  TH: "ก่อนการสั่งออเดอร์ เพียงแค่แจ้งในกล่องสีแดงในตะกร้าและบอกจุดรับส่งคืนผ้าที่ชัดเจน (เช่น ประตูด้านหน้า แผนกต้อนรับของโรงแรม รปภ. ล็อบบี้ ห้องรับจดหมาย เป็นต้น) เราสามารถไปรับและส่งคืนออเดอร์ของคุณทุกที่ที่เข้าถึงได้ และยินดีดูแลออเดอร์ของคุณให้ปลอดภัยจากฝนหรือภัยธรรมชาติต่างๆ",
};
export const TEXT_DO_YOU_PICKUP_AND_RETURN_DOORSTEP = {
  EN: "Do you pick up and return my laundry or shoes from my doorstep? ",
  TH: "คุณรับส่งคืนออเดอร์ถึงหน้าบ้านไหม? ",
};
export const TEXT_ENSURE_THAT_YOUR_ORDERS = {
  EN: "YES. As part of our professional laundry service and shoe cleaning service we ensure that your orders will be picked up and returned at your designated address. ",
  TH: "ใช่ ร้านซักผ้าและทำความสะอาดรองเท้ามายลอนดรี้มีบริการไปรับและส่งคืนออเดอร์ของคุณตามที่อยู่ที่ระบุไว้",
};
export const TEXT_BEFORE_PLACING_ALL_PICKUP = {
  EN: "Before placing your order, simply tell us in the RED BOX in the basket where exactly we can pick up and return your order (e.g. your front door, hotel reception, security office, lobby, mailroom, etc.). We can pick up and return your laundry service or shoe cleaning service order to any place that is readily accessible to us and safe to protect your order from rain or other natural hazards.",
  TH: " ก่อนการสั่งออเดอร์ เพียงแค่แจ้งในกล่องสีแดงในตะกร้าและบอกจุดรับส่งคืนผ้าที่ชัดเจน (เช่น ประตูด้านหน้า แผนกต้อนรับของโรงแรม รปภ. ล็อบบี้ ห้องรับจดหมาย เป็นต้น) เราสามารถไปรับและส่งคืนออเดอร์ของคุณทุกที่ที่เข้าถึงได้ และยินดีดูแลออเดอร์ของคุณให้ปลอดภัยจากฝนหรือภัยธรรมชาติต่างๆ",
};
export const TEXT_WHAT_ARE_YOUR_SERVICE_HOURS = {
  EN: "What are your service hours for Pick-Up & Return?",
  TH: "คุณมีบริการรับและส่งคืนออเดอร์เวลาใดบ้าง? ",
};
export const TEXT_OUR_SERVICE_HOURS_FOR_PICKUP_RETURN = {
  EN: `We guarantee: All orders placed by ${LAST_TIME_YOU_STILL_CAN_BOOK}:00 will be picked up on the same day and returned by ${RETURN_TIME}:00 the next day - fast & easy!`,
  TH: `เรารับประกันว่าทุกออเดอร์ที่สั่งภายใน ${LAST_TIME_YOU_STILL_CAN_BOOK}:00 น. เราจะไปรับในวันเดียวกันและส่งคืนภายใน ${RETURN_TIME}:00 น. ของวันถัดไป สะดวกและรวดเร็ว!`,
};
export const TEXT_WE_DIVIDE_OUR_SERVICE = {
  EN: ` Please ensure your items are ready immediately after placing your order as we will pick up your order as soon as possible, mostly within minutes. With our Contactless Service, you do not need to be present for either pick-up or return. We can pick up your order from any place you specify e.g. the drop-off point of your condo, the lobby of your hotel or from the receptionist or security guard. When placing your order, kindly inform us in the Address Details box where you will leave it to ensure a smooth contactless pick-up and return to the same spot. We will send you an e-mail with your receipt immediately after dropping off your order so that you know it has been returned. You want it faster? In Bangkok only - Activate our Same Day Express Service before ${TIME_THAT_STILL_SAME_DAY_SERVICE}:00 ${TIME_STRING_ENG}, and your items will be picked up and returned by ${RETURN_SAME_DAY}:00 on the same day.`,
  TH: ` หลังจากสั่งออเดอร์แล้วเราจะไปรับให้เร็วที่สุด โดยปกติทันที กรุณาเตรียมออเดอร์ให้เรียบร้อยก่อนเราไปถึง ด้วยบริการแบบไร้การสัมผัส คุณไม่ต้องรอรับและส่งคืนออเดอร์ด้วยตนเอง เราไปรับได้ทุกที่ที่คุณต้องการ ไม่ว่าจะเป็น จุดรับส่งของคอนโด ล็อบบี้หรือประชาสัมพันธ์ของโรงแรม หรือ รปภ. เมื่อสั่งออเดอร์ กรุณาแจ้งจุดวางออเดอร์ให้ชัดเจนในช่องรายละเอียดที่อยู่ เพื่อการรับและส่งคืนแบบไร้การสัมผัสอย่างแท้จริง หลังจากส่งคืนออเดอร์เรียบร้อยแล้ว เราจะส่งอีเมลพร้อมใบเสร็จให้คุณทันที เร็วกว่านี้ได้ไหม? เฉพาะในกรุงเทพฯ แค่เลือกบริการส่งคืนด่วนในวันเดียวกันก่อน ${TIME_THAT_STILL_SAME_DAY_SERVICE}:00 น. เราจะไปรับและส่งคืนออเดอร์ภายใน ${RETURN_SAME_DAY}:00 น. ของวันเดียวกัน`,
};
export const TEXT_WHERE_DO_I_CHOOSE_THE_DATE = {
  EN: `Where do I choose the date for Pick-Up & Return?`,
  TH: `ฉันจะเลือกวันรับส่งคืนออเดอร์ได้ที่ไหน?`,
};
export const TEXT_YOU_CAN_CHOOSE_YOUR_PREFERRED = {
  EN: `You can choose your preferred date for Pick-Up and Return in the Basket before placing your order.`,
  TH: `คุณสามารถเลือกวันรับส่งคืนออเดอร์ในตะกร้าก่อนทำการสั่งออเดอร์`,
};
export const TEXT_INTIALLY_OUR_SYSTEM_WILL_AUTOMATICALLY = {
  EN: ` We guarantee: All orders placed by ${LAST_TIME_YOU_STILL_CAN_BOOK}:00 will be picked up on the same day and returned by ${RETURN_TIME}:00 the next day - fast & easy! Please ensure your items are ready immediately after placing your order as we will pick up your order as soon as possible, mostly within minutes. With our Contactless Service, you do not need to be present for either pick-up or return. We can pick up your order from any place you specify e.g. the drop-off point of your condo, the lobby of your hotel or from the receptionist or security guard. When placing your order, kindly inform us in the Address Details box where you will leave it to ensure a smooth contactless pick-up and return to the same spot. We will send you an e-mail with your receipt immediately after dropping off your order so that you know it has been returned. You want it faster? In Bangkok only - Activate our Same Day Express Service before ${TIME_THAT_STILL_SAME_DAY_SERVICE}:00 ${TIME_STRING_ENG}, and your items will be picked up and returned by ${RETURN_SAME_DAY}:00 on the same day.`,
  TH: ` เรารับประกันว่าทุกออเดอร์ที่สั่งภายใน ${LAST_TIME_YOU_STILL_CAN_BOOK}:00 น. เราจะไปรับในวันเดียวกันและส่งคืนภายใน ${RETURN_TIME}:00 น. ของวันถัดไป สะดวกและรวดเร็ว! หลังจากสั่งออเดอร์แล้วเราจะไปรับให้เร็วที่สุด โดยปกติทันที กรุณาเตรียมออเดอร์ให้เรียบร้อยก่อนเราไปถึง ด้วยบริการแบบไร้การสัมผัส คุณไม่ต้องรอรับและส่งคืนออเดอร์ด้วยตนเอง เราไปรับได้ทุกที่ที่คุณต้องการ ไม่ว่าจะเป็น จุดรับส่งของคอนโด ล็อบบี้หรือประชาสัมพันธ์ของโรงแรม หรือ รปภ. เมื่อสั่งออเดอร์ กรุณาแจ้งจุดวางออเดอร์ให้ชัดเจนในช่องรายละเอียดที่อยู่ เพื่อการรับและส่งคืนแบบไร้การสัมผัสอย่างแท้จริง หลังจากส่งคืนออเดอร์เรียบร้อยแล้ว เราจะส่งอีเมลพร้อมใบเสร็จให้คุณทันที เร็วกว่านี้ได้ไหม? เฉพาะในกรุงเทพฯ แค่เลือกบริการส่งคืนด่วนในวันเดียวกันก่อน ${TIME_THAT_STILL_SAME_DAY_SERVICE}:00 น. เราจะไปรับและส่งคืนออเดอร์ภายใน ${RETURN_SAME_DAY}:00 น. ของวันเดียวกัน`,
};
export const TEXT_WHREN_WILL_MY_ORDER = {
  EN: `When will my order be picked up? `,
  TH: `คุณจะมารับออเดอร์ของฉันเมื่อไหร่`,
};
export const TEXT_YOR_ORDER_WILLBE_PICKED_UP_DURING = {
  EN: `We guarantee: All orders placed by ${LAST_TIME_YOU_STILL_CAN_BOOK}:00 will be picked up on the same day and returned by ${RETURN_TIME}:00 the next day - fast & easy!`,
  TH: `เรารับประกันว่าทุกออเดอร์ที่สั่งภายใน ${LAST_TIME_YOU_STILL_CAN_BOOK}:00 น. เราจะไปรับในวันเดียวกันและส่งคืนภายใน ${RETURN_TIME}:00 น. ของวันถัดไป สะดวกและรวดเร็ว!`,
};
export const TEXT_AS_PART_BE_PICKED_UP = {
  EN: ` Please ensure your items are ready immediately after placing your order as we will pick up your order as soon as possible, mostly within minutes. With our Contactless Service, you do not need to be present for either pick-up or return. We can pick up your order from any place you specify e.g. the drop-off point of your condo, the lobby of your hotel or from the receptionist or security guard. When placing your order, kindly inform us in the Address Details box where you will leave it to ensure a smooth contactless pick-up and return to the same spot. We will send you an e-mail with your receipt immediately after dropping off your order so that you know it has been returned. You want it faster? In Bangkok only - Activate our Same Day Express Service before ${TIME_THAT_STILL_SAME_DAY_SERVICE}:00 ${TIME_STRING_ENG}, and your items will be picked up and returned by ${RETURN_SAME_DAY}:00 on the same day.`,
  TH: ` หลังจากสั่งออเดอร์แล้วเราจะไปรับให้เร็วที่สุด โดยปกติทันที กรุณาเตรียมออเดอร์ให้เรียบร้อยก่อนเราไปถึง ด้วยบริการแบบไร้การสัมผัส คุณไม่ต้องรอรับและส่งคืนออเดอร์ด้วยตนเอง เราไปรับได้ทุกที่ที่คุณต้องการ ไม่ว่าจะเป็น จุดรับส่งของคอนโด ล็อบบี้หรือประชาสัมพันธ์ของโรงแรม หรือ รปภ. เมื่อสั่งออเดอร์ กรุณาแจ้งจุดวางออเดอร์ให้ชัดเจนในช่องรายละเอียดที่อยู่ เพื่อการรับและส่งคืนแบบไร้การสัมผัสอย่างแท้จริง หลังจากส่งคืนออเดอร์เรียบร้อยแล้ว เราจะส่งอีเมลพร้อมใบเสร็จให้คุณทันที เร็วกว่านี้ได้ไหม? เฉพาะในกรุงเทพฯ แค่เลือกบริการส่งคืนด่วนในวันเดียวกันก่อน ${TIME_THAT_STILL_SAME_DAY_SERVICE}:00 น. เราจะไปรับและส่งคืนออเดอร์ภายใน ${RETURN_SAME_DAY}:00 น. ของวันเดียวกัน`,
};
export const TEXT_AS_PART_BE_PICKED_UP_TH_1 = {
  // EN: `As part of our professional laundry service and shoe cleaning service, our standard turnaround time is 24 hours. For example: If you have chosen the time-slot 14:00-16:00 for the Pick-Up of your order on Monday, then your order will be returned between 14:00-16:00 on Tuesday. We also offer a Same Day Express Laundry Service and Same Day Express Shoe Cleaning Service where your order is picked up between 10:00-12:00 in the morning and will be returned between 16:00-19:00 in the early evening of the same day. Note: our Same Day Express Laundry Service and Same Day Express Shoe Cleaning Service are only available in Bangkok and can be booked before and until 11:30 am on the same day you wish to use the service. For all orders, we will return it on or before the scheduled time, if completed earlier than the guaranteed 24 hours. In the rare case you wish your order returned later than 24 hours, you can also always choose a later return time-slot for your utmost convenience.`,
  TH: ` ร้านซักผ้าและทำความสะอาดรองเท้ามายลอนดรี้มีเวลารับส่งคืนแบบมาตรฐานภายใน 24 ชั่วโมง เช่น หากคุณเลือกเวลาไปรับออเดอร์วันจันทร์ 14:00-16:00 น. เราจะส่งคืนออเดอร์วันอังคาร 14:00-16:00 น. นอกจากนี้เรายังมีบริการส่งคืนด่วนในวันเดียวกัน ซึ่งจะไปรับออเดอร์ในช่วงเวลา 10:00-12:00 น. และส่งคืนในช่วงเวลา 16:00-19:00 น. ของวันเดียวกัน หมายเหตุ บริการส่งคืนด่วนในวันเดียวกันมีเฉพาะในกรุงเทพเท่านั้น และสามารถจองได้จนถึง 11:30 น. ของวันที่คุณต้องการใช้บริการ ร้านซักผ้าและทำความสะอาดรองเท้าของเราจะส่งคืนทุกออเดอร์ตามเวลาที่กำหนดหรือก่อนเวลา`,
};
export const TEXT_AS_PART_BE_PICKED_UP_TH_2 = {
  // EN: `As part of our professional laundry service and shoe cleaning service, our standard turnaround time is 24 hours. For example: If you have chosen the time-slot 14:00-16:00 for the Pick-Up of your order on Monday, then your order will be returned between 14:00-16:00 on Tuesday. We also offer a Same Day Express Laundry Service and Same Day Express Shoe Cleaning Service where your order is picked up between 10:00-12:00 in the morning and will be returned between 16:00-19:00 in the early evening of the same day. Note: our Same Day Express Laundry Service and Same Day Express Shoe Cleaning Service are only available in Bangkok and can be booked before and until 11:30 am on the same day you wish to use the service. For all orders, we will return it on or before the scheduled time, if completed earlier than the guaranteed 24 hours. In the rare case you wish your order returned later than 24 hours, you can also always choose a later return time-slot for your utmost convenience.`,
  TH: `หากออเดอร์เรียบร้อยเร็วกว่า 24 ชั่วโมงตามที่เรารับประกันไว้ ในบางกรณีหากคุณต้องการให้ส่งคืนช้ากว่า 24 ชั่วโมง คุณสามารถเลือกช่วงเวลาส่งคืนอื่นๆได้ เพื่อความสะดวกสูงสุดของคุณ`,
};
export const TEXT_WHEN_WILL_MY_ORDER_BE_RETURNED = {
  EN: `When will my order be returned? `,
  TH: `คุณจะส่งคืนออเดอร์ของฉันเมื่อไหร่? `,
};
export const TEXT_YOUR_ORDER_WILLBE_RETURNED = {
  EN: `We guarantee: All orders placed by ${LAST_TIME_YOU_STILL_CAN_BOOK}:00 will be picked up on the same day and returned by ${RETURN_TIME}:00 the next day - fast & easy!`,
  TH: `เรารับประกันว่าทุกออเดอร์ที่สั่งภายใน ${LAST_TIME_YOU_STILL_CAN_BOOK}:00 น. เราจะไปรับในวันเดียวกันและส่งคืนภายใน ${RETURN_TIME}:00 น. ของวันถัดไป สะดวกและรวดเร็ว!`,
};
export const TEXT_YOUR_ORDER_WILLBE_RETURNED_1 = {
  EN: ` Please ensure your items are ready immediately after placing your order as we will pick up your order as soon as possible, mostly within minutes. With our Contactless Service, you do not need to be present for either pick-up or return. We can pick up your order from any place you specify e.g. the drop-off point of your condo, the lobby of your hotel or from the receptionist or security guard. When placing your order, kindly inform us in the Address Details box where you will leave it to ensure a smooth contactless pick-up and return to the same spot. We will send you an e-mail with your receipt immediately after dropping off your order so that you know it has been returned. You want it faster? In Bangkok only - Activate our Same Day Express Service before ${TIME_THAT_STILL_SAME_DAY_SERVICE}:00 ${TIME_STRING_ENG}, and your items will be picked up and returned by ${RETURN_SAME_DAY}:00 on the same day.`,
  TH: ` หลังจากสั่งออเดอร์แล้วเราจะไปรับให้เร็วที่สุด โดยปกติทันที กรุณาเตรียมออเดอร์ให้เรียบร้อยก่อนเราไปถึง ด้วยบริการแบบไร้การสัมผัส คุณไม่ต้องรอรับและส่งคืนออเดอร์ด้วยตนเอง เราไปรับได้ทุกที่ที่คุณต้องการ ไม่ว่าจะเป็น จุดรับส่งของคอนโด ล็อบบี้หรือประชาสัมพันธ์ของโรงแรม หรือ รปภ. เมื่อสั่งออเดอร์ กรุณาแจ้งจุดวางออเดอร์ให้ชัดเจนในช่องรายละเอียดที่อยู่ เพื่อการรับและส่งคืนแบบไร้การสัมผัสอย่างแท้จริง หลังจากส่งคืนออเดอร์เรียบร้อยแล้ว เราจะส่งอีเมลพร้อมใบเสร็จให้คุณทันที เร็วกว่านี้ได้ไหม? เฉพาะในกรุงเทพฯ แค่เลือกบริการส่งคืนด่วนในวันเดียวกันก่อน ${TIME_THAT_STILL_SAME_DAY_SERVICE}:00 น. เราจะไปรับและส่งคืนออเดอร์ภายใน ${RETURN_SAME_DAY}:00 น. ของวันเดียวกัน`,
};
export const TEXT_AS_PAST_WILLBE_RETURNED = {
  EN: `As part of our professional laundry service and shoe cleaning service, our standard turnaround time is 24 hours. For example: If you have chosen the time-slot 14:00-16:00 for the Pick-Up of your order on Monday, then your order will be returned between 14:00-16:00 on Tuesday. We also offer a Same Day Express Laundry Service and Same Day Express Shoe Cleaning Service where your order is picked up between 10:00-12:00 in the morning and will be returned between 16:00-19:00 in the early evening of the same day. Note: our Same Day Express Laundry Service and Same Day Express Shoe Cleaning Service are only available in Bangkok and can be booked before and until 11:30 am on the same day you wish to use the service. For all orders, we will return it on or before the scheduled time, if completed earlier than the guaranteed 24 hours. In the rare case you wish your order returned later than 24 hours, you can also always choose a later return time-slot for your utmost convenience.`,
  TH: ` ร้านซักผ้าและทำความสะอาดรองเท้ามายลอนดรี้มีเวลารับส่งคืนแบบมาตรฐานภายใน 24 ชั่วโมง เช่น หากคุณเลือกเวลาไปรับออเดอร์วันจันทร์ 14:00-16:00 น. เราจะส่งคืนออเดอร์วันอังคาร 14:00-16:00 น. นอกจากนี้เรายังมีบริการส่งคืนด่วนในวันเดียวกัน ซึ่งจะไปรับออเดอร์ในช่วงเวลา 10:00-12:00 น. และส่งคืนในช่วงเวลา 16:00-19:00 น. ของวันเดียวกัน หมายเหตุ บริการส่งคืนด่วนในวันเดียวกันมีเฉพาะในกรุงเทพเท่านั้น และสามารถจองได้จนถึง 11:30 น. ของวันที่คุณต้องการใช้บริการ ร้านซักผ้าและทำความสะอาดรองเท้าของเราจะส่งคืนทุกออเดอร์ตามเวลาที่กำหนด หรือก่อนเวลาหากออเดอร์เรียบร้อยเร็วกว่า 24 ชั่วโมงตามที่เรารับประกันไว้ ในบางกรณีหากคุณต้องการให้ส่งคืนช้ากว่า 24 ชั่วโมง คุณสามารถเลือกช่วงเวลาส่งคืนอื่นๆได้ เพื่อความสะดวกสูงสุดของคุณ`,
};
export const TEXT_WILLBE_I_ALERTED_WHEN_ORDER_IS_RETURNED = {
  EN: `Will I be I alerted when my order is returned? `,
  TH: `ฉันจะได้รับการแจ้งเตือนเวลาส่งคืนออเดอร์ไหม? `,
};
export const TEXT_WE_WILL_SEND_YOU_AN_EMAIL = {
  EN: `YES. We will send you an e-mail with your receipt at the moment your order is returned.`,
  TH: `ใช่ หลังจากการส่งคืนออเดอร์เรียบร้อยแล้ว เราจะส่งอีเมลพร้อมใบเสร็จไปให้คุณ`,
};
export const TEXT_WHEN_YOU_USE_OUR_PROFESIONAL_LAUNDRY_SERVICE = {
  EN: ` When you use our professional laundry service and shoe cleaning service, you can always track the status of your order in the My Orders section of our website, just as you can do with food delivery websites and applications.`,
  TH: ` ร้านซักผ้าและทำความสะอาดรองเท้ามายลอนดรี้ยังมีบริการให้คุณดูสถานะออเดอร์ได้ที่ ออเดอร์ของฉัน ในเว็บไซต์ของเรา เช่นเดียวกับการสั่งอาหารบนเว็บไซต์หรือแอปพลิเคชั่นต่างๆ`,
};
export const TEXT_CAN_I_REQUEST_PICKUP_AND_RETURN = {
  EN: `Can I request Pick-Up & Return at different locations?`,
  TH: `สถานที่รับและส่งคืนออเดอร์เป็นคนละที่ได้ไหม? `,
};
export const TEXT_NO_AT_THE_MOMENT_WE_ARE_ONLY_PICK_UP = {
  EN: `NO. At the moment we are only able to pick up & return your order at the same location. `,
  TH: `ไม่ได้ ขณะนี้เราให้บริการรับและส่งคืนออเดอร์ในสถานที่เดียวกันเท่านั้น`,
};
export const TEXT_AS_A_PROFESSIONAL_LAUNDRY_SERVICE_SHOE = {
  EN: `As a professional laundry service and shoe cleaning service, we continuously look at ways of improving the customer experience and we are exploring the possibility of offering Pick-Up and Return at different locations in the future.`,
  // TH: ` อย่างไรก็ตาม ร้านซักผ้าและทำความสะอาดรองเท้ามายลอนดรี้กำลังพัฒนาบริการลูกค้าให้ดีที่สุด และจะจัดให้มีการรับและส่งคืนออเดอร์ในสถานที่ที่แตกต่างกันได้ในอนาคต`,
};

export const TEXT_AS_A_PROFESSIONAL_LAUNDRY_SERVICE_SHOE_TH_1 = {
  // EN: `As a professional laundry service and shoe cleaning service, we continuously look at ways of improving the customer experience and we are exploring the possibility of offering Pick-Up and Return at different locations in the future.`,
  TH: ` อย่างไรก็ตาม ร้านซักผ้าและทำความสะอาดรองเท้า`,
};
export const TEXT_AS_A_PROFESSIONAL_LAUNDRY_SERVICE_SHOE_TH_2 = {
  // EN: `As a professional laundry service and shoe cleaning service, we continuously look at ways of improving the customer experience and we are exploring the possibility of offering Pick-Up and Return at different locations in the future.`,
  TH: `มายลอนดรี้กำลังพัฒนาบริการลูกค้าให้ดีที่สุด และจะจัดให้มีการรับและส่งคืนออเดอร์ในสถานที่ที่แตกต่างกันได้ในอนาคต`,
};
export const TEXT_IS_THERE_ANY_EXTRA_CHARGE = {
  EN: `Is there any extra charge for Pick-Up & Return? `,
  TH: `มีค่าบริการอื่นๆเพิ่มเติมสำหรับการรับและส่งคืนออเดอร์ไหม? `,
};
export const TEXT_NO_DELIVERY_FEES_OR_HIDDEN_CHARGES = {
  EN: `NO. All our laundry service and shoe cleaning service prices are fully inclusive – no delivery fees or hidden charges.`,
  TH: ` ไม่มี ค่าบริการซักผ้าและทำความสะอาดรองเท้าเป็นราคาที่รวมทุกอย่างแล้ว ไม่มีค่าส่งหรือค่าบริการอื่นๆเพิ่มเติม`,
};
export const TEXT_GENERAL = {
  EN: `General`,
  TH: `ทั่วไป`,
};
export const TEXT_HOW_DO_I_MAKE_AN_ORDER = {
  EN: `How do I make an order?`,
  TH: `ฉันจะสร้างออเดอร์ได้ยังไง? `,
};
export const TEXT_THE_MOST_RECOMMENDED = {
  EN: "The most recommended and easiest way is to make the order on our website!",
  TH: "ขอแนะนำวิธีง่ายที่สุดคือ สร้างออเดอร์บนเว็บไซต์ของเรา",
};
export const TEXT_APART_FROM_THAT_GENERAL = {
  EN: " Apart from that, we offer you a variety of ways to make an order. You can for instance make the order via our Line Official Account ",
  TH: " ขอแนะนำวิธีง่ายที่สุดคือ สร้างออเดอร์บนเว็บไซต์ของเรา นอกจากนี้ร้านซักผ้าและทำความสะอาดรองเท้ามายลอนดรี้มีวิธีสร้างออเดอร์หลายรูปแบบ ไม่ว่าจะเป็นผ่าน Line Official Account ",
};
export const TEXT_OR_VIA_WHATSAPP_WECHAT = {
  EN: "or via WhatsApp, WeChat, Facebook Messenger, Telegram, Viber, Signal or KakaoTalk after you add us by Thai phone number (+66) 092-516-5458 or our ID mylaundrythai.",
  TH: "หรือผ่าน WhatsApp, WeChat, Facebook Messenger, Telegram, Viber, Signal หรือ KakaoTalk โดยเพิ่มเบอร์โทรศัพท์ 092-516-5458 หรือ ID mylaundrythai",
};
export const TEXT_WHAT_SERVICES_DOES_MYLAUNDRY_PROVIDE = {
  EN: "What services does My Laundry provide? ",
  TH: "มายลอนดรี้มีบริการอะไรบ้าง? ",
};
export const TEXT_MYLAUNDRY_PROVIDES_PROFESSIONAL = {
  EN: "My Laundry provides professional, reliable and convenient washing, ironing and shoe cleaning services which are fully customisable to meet your requirements as a one-stop laundry service and shoe cleaning service solution in Bangkok.",
  TH: "มายลอนดรี้เป็นร้านซักผ้าและทำความสะอาดรองเท้าแบบมืออาชีพ ให้บริการสะดวกและเชื่อถือได้ อีกทั้งตอบสนองความต้องการของคุณแบบครบวงจรทั้งในกรุงเทพ",
};
export const TEXT_WHAT_IS_YOUR_TURNAROUND_TIME = {
  EN: "What is your turnaround time and do you offer an Express Service? ",
  TH: "ช่วงเวลารับส่งคืนมีเวลาไหนบ้างและมีบริการส่งคืนด่วนไหม? ",
};
export const TEXT_OUR_STANDARD_TURNAROUND_TIME_24_HOURS = {
  EN: `We guarantee: All orders placed by ${LAST_TIME_YOU_STILL_CAN_BOOK}:00 will be picked up on the same day and returned by ${RETURN_TIME}:00 the next day - fast & easy!`,
  TH: `เรารับประกันว่าทุกออเดอร์ที่สั่งภายใน ${LAST_TIME_YOU_STILL_CAN_BOOK}:00 น. เราจะไปรับในวันเดียวกันและส่งคืนภายใน ${RETURN_TIME}:00 น. ของวันถัดไป สะดวกและรวดเร็ว!`,
};
export const TEXT_FOR_EXAMPLE_IF_YOU_CHOSEN = {
  EN: ` Please ensure your items are ready immediately after placing your order as we will pick up your order as soon as possible, mostly within minutes. With our Contactless Service, you do not need to be present for either pick-up or return. We can pick up your order from any place you specify e.g. the drop-off point of your condo, the lobby of your hotel or from the receptionist or security guard. When placing your order, kindly inform us in the Address Details box where you will leave it to ensure a smooth contactless pick-up and return to the same spot. We will send you an e-mail with your receipt immediately after dropping off your order so that you know it has been returned.`,
  TH: ` หลังจากสั่งออเดอร์แล้วเราจะไปรับให้เร็วที่สุด โดยปกติทันที กรุณาเตรียมออเดอร์ให้เรียบร้อยก่อนเราไปถึง ด้วยบริการแบบไร้การสัมผัส คุณไม่ต้องรอรับและส่งคืนออเดอร์ด้วยตนเอง เราไปรับได้ทุกที่ที่คุณต้องการ ไม่ว่าจะเป็น จุดรับส่งของคอนโด ล็อบบี้หรือประชาสัมพันธ์ของโรงแรม หรือ รปภ. เมื่อสั่งออเดอร์ กรุณาแจ้งจุดวางออเดอร์ให้ชัดเจนในช่องรายละเอียดที่อยู่ เพื่อการรับและส่งคืนแบบไร้การสัมผัสอย่างแท้จริง หลังจากส่งคืนออเดอร์เรียบร้อยแล้ว เราจะส่งอีเมลพร้อมใบเสร็จให้คุณทันที`,
};
export const TEXT_FOR_EXAMPLE_IF_YOU_CHOSEN_MB = {
  EN: `For example: If you have chosen the time-slot 14:00-16:00 for the Pick-Up of your order on Monday, then your order will be returned between 14:00-16:00 on Tuesday.`,
  TH: ` เช่น หากคุณเลือกเวลาไปรับออเดอร์วันจันทร์ 14:00-16:00 น. เราจะส่งคืนออเดอร์วันอังคาร 14:00-16:00 น.`,
};
export const TEXT_WE_ALSO_OFFER_A_SAME_DAY = {
  EN: ` You want it faster? In Bangkok only - Activate our Same Day Express Service before ${TIME_THAT_STILL_SAME_DAY_SERVICE}:00 ${TIME_STRING_ENG}, and your items will be picked up and returned by ${RETURN_SAME_DAY}:00 on the same day.`,
  TH: ` เร็วกว่านี้ได้ไหม? เฉพาะในกรุงเทพฯ แค่เลือกบริการส่งคืนด่วนในวันเดียวกันก่อน ${TIME_THAT_STILL_SAME_DAY_SERVICE}:00 น. เราจะไปรับและส่งคืนออเดอร์ภายใน ${RETURN_SAME_DAY}:00 น. ของวันเดียวกัน`,
};
export const TEXT_WHERE_YOU_ORDER_IN_PICKED = {
  EN: ` where your order is picked up between 10:00-12:00 in the morning and will be returned between 16:00-19:00 in the early evening of the same day. Note: our Same Day Express Laundry Service and Same Day Express Shoe Cleaning Service are only available in Bangkok and can be booked before and until 11:30 am on the same day you wish to use the service. For all orders, we will return it on or before the scheduled time, if completed earlier than the guaranteed 24 hours. In the rare case you wish your order returned later than 24 hours, you can also always choose a later return time-slot for your utmost convenience.`,
  TH: ` ซึ่งจะไปรับออเดอร์ในช่วงเวลา 10:00-12:00 น. และส่งคืนในช่วงเวลา 16:00-19:00 น. ของวันเดียวกัน หมายเหตุ บริการส่งคืนด่วนในวันเดียวกันมีเฉพาะในกรุงเทพเท่านั้น และสามารถจองได้จนถึง 11:30 น. ของวันที่คุณต้องการใช้บริการ ร้านซักผ้าและทำความสะอาดรองเท้าของเราจะส่งคืนทุกออเดอร์ตามเวลาที่กำหนด หรือก่อนเวลาหากออเดอร์เรียบร้อยเร็วกว่า 24 ชั่วโมงตามที่เรารับประกันไว้ ในบางกรณีหากคุณต้องการให้ส่งคืนช้ากว่า 24 ชั่วโมง คุณสามารถเลือกช่วงเวลาส่งคืนอื่นๆได้ เพื่อความสะดวกสูงสุดของคุณ`,
};
export const TEXT_DO_YOU_PROVIDE_SERVICE_NEAR_ME = {
  EN: `Do you provide a laundry service near me? `,
  TH: `คุณมีบริการซักผ้าใกล้ฉันไหม? `,
};
export const TEXT_WE_PROVIDE_LAUNDRY_SERVICE_IN_BKK_PTY = {
  EN: `We provide our laundry service and shoe cleaning service in most areas of greater Bangkok, especially along the BTS and MRT lines, and nearly everywhere in Pattaya.`,
  TH: `ร้านซักผ้าและทำความสะอาดรองเท้ามายลอนดรี้ให้บริการในพื้นที่ส่วนใหญ่ของกรุงเทพฯ โดยเฉพาะตามเส้นทางรถไฟฟ้า BTS และ MRT รวมถึงพื้นที่เกือบทั้งหมดในพัทยา`,
};
export const TEXT_OUR_SYSTEMS_USE_API = {
  EN: ` Our systems use the same Google API as food and delivery apps. When searching for your location or finding it from the map, the system will automatically detect whether your location is within our service area. As our service area continues to expand, we are confident we will soon have a laundry service near you!`,
  TH: ` ระบบของเราใช้ Google API เช่นเดียวกับแอปสั่งอาหารและแอปจัดส่งสินค้าอื่นๆ เมื่อค้นหาตำแหน่งของคุณหรือค้นหาจากแผนที่ ระบบจะตรวจสอบโดยอัตโนมัติและยืนยันว่าตำแหน่งของคุณอยู่ในพื้นที่ให้บริการของเราหรือไม่ หากไม่อยู่ในพื้นที่ให้บริการก็จะแจ้งให้คุณทราบ ทั้งนี้เรากำลังขยายพื้นที่ให้บริการอย่างต่อเนื่อง จึงเชื่อมั่นว่าจะสามารถให้บริการรับซักผ้าและทำความสะอาดรองเท้าใกล้คุณในเวลาอีกไม่นานอย่างแน่นอน!`,
};
export const TEXT_I_PLACED_AN_ORDER = {
  EN: `I placed an order. What happens now? `,
  TH: `เมื่อสั่งออเดอร์แล้ว ฉันจะต้องทำอย่างไรต่อ? `,
};
export const TEXT_AFTER_PLACING_YOUR_ORDER = {
  EN: `After placing your order, you can track its status via the My Orders section of our My Laundry website. `,
  TH: `หลังจากสั่งออเดอร์แล้ว คุณสามารถติดตามสถานะออเดอร์ได้ที่ ออเดอร์ของฉัน ในเว็บไซต์ของเรา`,
};
export const TEXT_YOU_CAN_REST_ASSURED = {
  EN: `You can rest assured that we will pick up your laundry service or shoe cleaning service order during the time-slot selected for pick-up and return it during the time-slot selected for return. In case you have any questions, you can always`,
  TH: ` ให้คุณมั่นใจว่าร้านซักผ้าและทำความสะอาดรองเท้ามายลอนดรี้จะไปรับและส่งคืนออเดอร์ตามช่วงเวลาที่คุณเลือกอย่างแน่นอน หากมีคำถามอื่นๆ`,
};
export const TEXT_HOW_DO_YOU_ENSURE_QUALITY = {
  EN: `How do you ensure quality? `,
  TH: `คุณจะรับประกันคุณภาพได้อย่างไร?`,
};
export const TEXT_WE_BELIEVE_THAT_KEY = {
  EN: `As a professional laundry service and shoe cleaning service, we believe that the key to providing quality is in finding and keeping the right people. `,
  TH: `ในฐานะที่เราเป็นร้านซักผ้าและทำความสะอาดรองเท้าแบบมืออาชีพ เราเชื่อว่ากุญแจสำคัญในการให้บริการที่มีคุณภาพคือการค้นหาและรักษาพนักงานที่มีคุณสมบัติเหมาะสมไว้`,
};
export const TEXT_EVERY_MEMBER_OF_OUR_TEAM = {
  EN: "Every member of our team has been selected not only because of their experience and ability in providing reliable laundry services but also because of their attitude. Once we find the right people, we make them feel part of our family. When people feel respected and wanted, they take pride in their work. Our internal quality control measures also mean that every item of clothing or pair of shoes is also checked to make sure it meets our high standards before it is returned to you. In case you have any questions, you can always",
  TH: " สมาชิกทุกคนในทีมของเราเป็นผู้มีประสบการณ์ ความสามารถ และทัศนคติที่ดี ร้านซักผ้าและทำความสะอาดรองเท้ามายลอนดรี้ให้ความสำคัญกับพนักงานทุกคนและดูแลพวกเขาเหมือนสมาชิกในครอบครัว อีกทั้งทำให้พวกเขารู้สึกภูมิใจในการทำงาน มาตรการควบคุมคุณภาพภายใต้การทำงานของเรายังหมายถึงการตรวจสอบเสื้อผ้าทุกชิ้นและรองเท้าทุกคู่ก่อนส่งคืนลูกค้า เพื่อให้แน่ใจว่าออเดอร์ของคุณผ่านขั้นตอนตามมาตรฐานระดับสูงของเรา หากมีคำถามอื่นๆ",
};
export const TEXT_WHAT_ARE_YOUR_SERVICE_HOURS_FOR_PICKUP = {
  EN: "What are your service hours for Pick-Up & Return? ",
  TH: "คุณมีบริการรับและส่งคืนออเดอร์เวลาใดบ้าง? ",
};
export const TEXT_OUR_SERVICE_IN_THE_MORNING = {
  EN: `We guarantee: All orders placed by ${LAST_TIME_YOU_STILL_CAN_BOOK}:00 will be picked up on the same day and returned by ${RETURN_TIME}:00 the next day - fast & easy!`,
  TH: `เรารับประกันว่าทุกออเดอร์ที่สั่งภายใน ${LAST_TIME_YOU_STILL_CAN_BOOK}:00 น. เราจะไปรับในวันเดียวกันและส่งคืนภายใน ${RETURN_TIME}:00 น. ของวันถัดไป สะดวกและรวดเร็ว!`,
};
export const TEXT_WE_DEVIDE_SERVICE_INTO_TIME = {
  EN: ` Please ensure your items are ready immediately after placing your order as we will pick up your order as soon as possible, mostly within minutes. With our Contactless Service, you do not need to be present for either pick-up or return. We can pick up your order from any place you specify e.g. the drop-off point of your condo, the lobby of your hotel or from the receptionist or security guard. When placing your order, kindly inform us in the Address Details box where you will leave it to ensure a smooth contactless pick-up and return to the same spot. We will send you an e-mail with your receipt immediately after dropping off your order so that you know it has been returned. You want it faster? In Bangkok only - Activate our Same Day Express Service before ${TIME_THAT_STILL_SAME_DAY_SERVICE}:00 ${TIME_STRING_ENG}, and your items will be picked up and returned by ${RETURN_SAME_DAY}:00 on the same day.`,
  TH: ` หลังจากสั่งออเดอร์แล้วเราจะไปรับให้เร็วที่สุด โดยปกติทันที กรุณาเตรียมออเดอร์ให้เรียบร้อยก่อนเราไปถึง ด้วยบริการแบบไร้การสัมผัส คุณไม่ต้องรอรับและส่งคืนออเดอร์ด้วยตนเอง เราไปรับได้ทุกที่ที่คุณต้องการ ไม่ว่าจะเป็น จุดรับส่งของคอนโด ล็อบบี้หรือประชาสัมพันธ์ของโรงแรม หรือ รปภ. เมื่อสั่งออเดอร์ กรุณาแจ้งจุดวางออเดอร์ให้ชัดเจนในช่องรายละเอียดที่อยู่ เพื่อการรับและส่งคืนแบบไร้การสัมผัสอย่างแท้จริง หลังจากส่งคืนออเดอร์เรียบร้อยแล้ว เราจะส่งอีเมลพร้อมใบเสร็จให้คุณทันที เร็วกว่านี้ได้ไหม? เฉพาะในกรุงเทพฯ แค่เลือกบริการส่งคืนด่วนในวันเดียวกันก่อน ${TIME_THAT_STILL_SAME_DAY_SERVICE}:00 น. เราจะไปรับและส่งคืนออเดอร์ภายใน ${RETURN_SAME_DAY}:00 น. ของวันเดียวกัน`,
};
export const TEXT_DO_I_NEED_TO_SIGN_UP = {
  EN: `Do I need to sign up before placing an order? `,
  TH: `ฉันต้องเข้าสู่ระบบก่อนการสั่งออเดอร์ไหม? `,
};
export const TEXT_YES_HOWEVER_MADE = {
  EN: `YES. However, we made it very easy to sign up. `,
  TH: `ใช่ อย่างไรก็ตาม เราทำให้การเข้าสู่ระบบเป็นเรื่องง่าย`,
};
export const TEXT_YOU_JUST_NEED_TO_ENTER = {
  EN: `You just need to enter your phone number and confirm via OTP, enter your name and E-Mail address, and then you can place an order. Now you are ready to take advantage of our professional laundry service and shoe cleaning service. The My Laundry Service is that easy.`,
  TH: ` โดยคุณแค่ใส่เบอร์โทรศัพท์และยืนยันผ่าน OTP จากนั้นใส่ชื่อและอีเมล เท่านี้ก็สามารถสั่งออเดอร์กับร้านซักผ้าและทำความสะอาดรองเท้าของเราได้แล้ว ร้านซักผ้ามายลอนดรี้ทำให้คุณสะดวกและง่ายจริงๆ!`,
};
export const TEXT_CAN_I_BRING_LAUNDRY_OR_SHOES = {
  EN: `Can I bring laundry or shoes to your facilities? `,
  TH: `ฉันเอาผ้าหรือรองเท้าไปที่ร้านซักผ้ามายลอนดรี้ได้ไหม? `,
};
export const TEXT_NO_TO_ENSURE = {
  EN: `NO. To ensure we deliver a premium laundry service, we pick up your laundry or shoes and return them to your doorstep. `,
  TH: `ไม่ได้ ร้านซักผ้าและทำความสะอาดรองเท้ามายลอนดรี้ยินดีที่จะมอบความสะดวกสบายในการรับและส่งคืนผ้าหรือรองเท้าถึงหน้าบ้านคุณ`,
};
export const TEXT_ALL_LAUNDRY_PREMIUM = {
  EN: `All laundry service and shoe cleaning service orders are picked up and returned by our staff and then processed at our own facilities.`,
  TH: ` โดยพนักงานของเราจะไปรับและส่งคืนทุกออเดอร์ พร้อมทั้งดำเนินขั้นตอนต่างๆที่ร้านซักผ้ามายลอนดรี้ให้คุณเอง`,
};
export const TEXT_HOW_DO_I_CANCEL = {
  EN: `How do I cancel or reschedule my order? `,
  TH: `ฉันจะยกเลิกออเดอร์หรือเลือกวัน-เวลาใหม่ได้อย่างไร? `,
};
export const TEXT_IF_YOU_WISH_TO_CANCEL = {
  EN: `If you wish to cancel or reschedule your order, please`,
  TH: `หากคุณต้องการยกเลิกออเดอร์หรือเลือกวัน-เวลาใหม่ กรุณา `,
};
export const TEXT_DO_YOU_ACCEPT_CLOTHING = {
  EN: `Do you accept clothing donations? `,
  TH: `คุณรับบริจาคเสื้อผ้าไหม?`,
};
export const TEXT_NO_AT_THE_MOMENT_WE_DO = {
  EN: `NO. At the moment we do not accept clothing donations. `,
  TH: `ไม่รับ ขณะนี้ร้านซักผ้ามายลอนดรี้ไม่รับบริจาคเสื้อผ้าใดๆ`,
};
export const TEXT_IN_CASE_YOU_HAVE_ANYQESTION = {
  EN: `In case you have any questions, you can always`,
  TH: ` หากมีคำถามอื่นๆ`,
};
export const TEXT_WHY_CHOOES_MY_LAUNDRY = {
  EN: `Why choose My Laundry? `,
  TH: `ทำไมเลือก มายลอนดรี้? `,
};
export const TEXT_MY_LAUNDRY_WAS_ESTABLISHED = {
  EN: `My Laundry was established to offer convenient and affordable laundry, ironing and shoe cleaning services right to your doorstep. As part of our professional laundry service and shoe cleaning service, we put our full effort and care into every item you entrust to us, and we also consider the environment by using eco-friendly products that are gentle on the fabric and the wearer‘s skin. We are also committed to reducing unnecessary plastic use in our packaging to increase public awareness and participation in our efforts to reduce the use of plastic. My Laundry puts customer service first above all else and we are proud to provide a quality laundry service in Thailand that makes our customers’ lives easier. With My Laundry, you never need to worry about finding a place to wash, dry and iron your clothes or clean your shoes again. Want to know more about My Laundry? We are glad to tell you! Check out`,
  TH: `มายลอนดรี้ ให้บริการซักอบรีดเสื้อผ้าและทำความสะอาดรองเท้าส่งถึงหน้าบ้านคุณ เราทุ่มเทอย่างเต็มที่และดูแลผ้าทุกชิ้นตามที่คุณมอบความไว้วางใจให้เรา และยังคำนึงถึงผลกระทบต่อสภาพแวดล้อม จึงใช้ผลิตภัณฑ์ที่เป็นมิตรต่อสิ่งแวดล้อม ซึ่งอ่อนโยนต่อผ้าและผิวหนังของผู้สวมใส่ นอกจากนี้ร้านซักผ้ามายลอนดรี้ยังลดการใช้พลาสติกในการห่อผ้า เพื่อสร้างจิตสำนึกที่ดีต่อส่วนรวมในการลดพลาสติกให้น้อยลง ร้านซักผ้าและทำความสะอาดรองเท้า มายลอนดรี้ให้ความสำคัญกับการบริการลูกค้าเหนือสิ่งอื่นใด เราดีใจที่ทำให้ชีวิตของลูกค้าสะดวกและง่ายดายขึ้น ด้วยมายลอนดรี้ คุณไม่ต้องกังวลในการหาร้านซักอบรีดเสื้อผ้าหรือทำความสะอาดรองเท้าในกรุงเทพอีกต่อไป อยากรู้ข้อมูลเพิ่มเติมเกี่ยวกับมายลอนดรี้ไหม? เช็คดู`,
};
export const TEXT_IS_THERE_IS_ANYTHING_ELSE_YOU = {
  EN: `If there is anything else you would like to know that is not covered in the FAQs? `,
  TH: `หากมีสิ่งใดที่คุณอยากรู้ และไม่อยู่ในคำถามที่พบบ่อย? `,
};
export const TEXT_LAUDRY_SERVICE_IN_DETAL = {
  EN: `Laundry Service: In-Detail FAQs`,
  TH: `คำถามที่พบบ่อยในการซักรีด`,
};
export const TEXT_DO_I_NEED_SORT_MY_CLOTHES = {
  EN: `Do I need to sort my clothes into colours and whites? `,
  TH: `ฉันต้องแยกผ้าสีกับผ้าขาวไหม? `,
};
export const TEXT_NO_WE_WILL_SORT_THEM = {
  EN: "NO. We will sort them for you as part of our professional laundry service standard!",
  TH: "ไม่ต้อง ร้านซักผ้ามายลอนดรี้จะแยกให้คุณเอง!",
};
export const TEXT_WILL_MY_LAUNDRY_BE_WASHED = {
  EN: "Will my laundry be washed together with other customers’ laundry?",
  TH: "คุณจะซักผ้าของฉันรวมกับลูกค้าคนอื่นไหม? ",
};
export const TEXT_WE_ALWAYS_BE_WASHED_SEPARATELY = {
  EN: "NO. As a professional laundry service, we ensure that your laundry will always be washed separately!",
  TH: "ไม่ ร้านซักผ้ามายลอนดรี้จะแยกซักผ้าของคุณจากลูกค้าคนอื่นเสมอ",
};
export const TEXT_WHAT_TEMPERATURE = {
  EN: "What temperature do you wash at?",
  TH: "คุณซักผ้าที่อุณหภูมิกี่องศา?",
};
export const TEXT_WE_ALWAYS_WASH_YOUR_LAUNDRY = {
  EN: "As part of our professional laundry service, we always wash your laundry at the correct temperature ",
  TH: "ร้านซักผ้ามายลอนดรี้ใช้อุณหภูมิที่เหมาะสมในการซักผ้าเสมอ",
};
export const TEXT_ACCORDING_TO_THE_LAUNDRY = {
  EN: "according to the laundry tag on your clothes, towels and other items. In most cases, this means a washing temperature of 30-40°C.",
  TH: " โดยใช้อุณหภูมิตามฉลากระบุวิธีการดูแลเสื้อผ้า ผ้าเช็ดตัว และผ้าชนิดต่างๆ ซึ่งส่วนใหญ่เป็นการซักผ้าที่อุณหภูมิ 30-40 องศาเซลเซียส",
};
export const TEXT_HOW_DO_YOU_DRY = {
  EN: "How do you dry?",
  TH: "คุณอบผ้าให้แห้งยังไง?",
};
export const TEXT_DRIED_AT_AN_APPROPRIATE = {
  EN: "With our professional laundry service, your laundry is either dried at an appropriate fibre-gentle temperature or air-dried. ",
  TH: "ร้านซักผ้ามายลอนดรี้ใช้อุณหภูมิที่เหมาะสมในการอบแห้งเพื่อถนอมเส้นใยผ้าหรือพึ่งลมให้แห้งตามธรรมชาติ",
};
export const TEXT_YOU_CAN_CHOOSE_OUR_SPECIAL = {
  EN: "You can choose our special Low Heat Dry Add-On to have your laundry dried at a low temperature over a longer period. Use the Special Request box before placing your laundry service order if you want us to dry your laundry at a specific temperature, such as 30°C or 40°C.",
  TH: " คุณสามารถเลือกเพิ่มเติมอบแห้งด้วยอุณหภูมิต่ำ ซึ่งเราจะอบผ้าด้วยอุณหภูมิต่ำเป็นระยะเวลานานกว่าปกติ หากคุณต้องการให้เราอบแห้งที่อุณหภูมิอื่น เช่น 30 หรือ 40 องศาเซลเซียส กรุณาแจ้งในช่องความต้องการพิเศษก่อนสั่งออเดอร์กับร้านซักอบแห้งของเรา",
};
export const TEXT_WHAT_TYPES_OF_LAUNDRY_PRODUCTS = {
  EN: "What types of laundry products do you use?",
  TH: "คุณใช้ผลิตภัณฑ์ซักรีดแบบไหนบ้าง? ",
};
export const TEXT_ECO_FRENDLY_PRODUCTS = {
  EN: "As part of our professional laundry service, we use only eco-friendly products which are sourced locally as well as internationally and come from trusted brands who are committed to the environment. ",
  TH: "ร้านซักผ้ามายลอนดรี้เลือกใช้ผลิตภัณฑ์ที่เป็นมิตรกับสิ่งแวดล้อมเท่านั้น ซึ่งมาจากแหล่งผลิตทั้งในและต่างประเทศ รวมถึงแบรนด์ที่เชื่อถือได้และมีความมุ่งมั่นเพื่อสิ่งแวดล้อมที่ยั่งยืน",
};
export const TEXT_FOR_EXAMPLE_OUR_ORGANIC = {
  EN: "For example, our Organic Wash products come without dyes, fragrances or preservatives and contain only plant-based, naturally-sourced and mineral ingredients. In case you have any questions, you can always",
  TH: " เช่น ผลิตภัณฑ์ซักผ้าออร์แกนิคของร้านซักผ้ามายลอนดรี้ ไม่มีสี น้ำหอมหรือวัตถุกันเสียใดๆ และยังประกอบไปด้วยส่วนผสมจากพืชที่มาจากธรรมชาติและแร่ธาตุเท่านั้น",
};
export const TEXT_IAM_ALLERGIC_TO_CERTAIN = {
  EN: "I am allergic to certain types of detergent. What can you do about this?",
  TH: "ถ้าฉันแพ้น้ำยาซักผ้าบางประเภท คุณจะทำอย่างไร? ",
};
export const TEXT_AS_SUSTAINABLE_AND_ENVIRONMENTALLY = {
  EN: "As a sustainable and environmentally-friendly laundry service, we recommend that you choose our Organic Wash Add-On. ",
  TH: "ร้านซักผ้ามายลอนดรี้ใช้ผลิตภัณฑ์ที่เป็นมิตรกับสิ่งแวดล้อมเพื่อความยั่งยืน เราขอแนะนำให้คุณเลือกเพิ่มเติมผลิตภัณฑ์ซักผ้าออร์แกนิค",
};
export const TEXT_WITH_NO_DYES_FRAGRANCES = {
  EN: "With no dyes, fragrances or preservatives, our Organic Wash products contain only plant-based, naturally-sourced and mineral ingredients. Dermatologically tested, our organic detergents and softeners are perfectly gentle to sensitive skin but still strong in removing stains. If you do not wish us to use softener in your Organic Wash, please select the free of charge No Softener Add-On. Good to know: Organic products are especially gentle to the environment and therefore strongly recommended. PS: As part of our professional laundry service, we use a variety of locally and internationally sourced Organic Wash products. Use the Special Request box before placing your laundry service order to tell us your preferences and we will fulfil your request whenever possible. In case you have any questions, you can always",
  TH: " ซึ่งประกอบด้วยส่วนผสมจากพืชที่มาจากธรรมชาติและแร่ธาตุเท่านั้น ไม่มีสี น้ำหอมหรือวัตถุกันเสียใดๆ นอกจากนี้ยังผ่านการทดสอบโดยแพทย์ผิวหนังแล้วว่าเป็นผลิตภัณฑ์ที่อ่อนโยนต่อผิวบอบบางแพ้ง่าย  และยังคงขจัดคราบสกปรกได้ดี หากคุณไม่ต้องการให้เราใช้น้ำยาปรับผ้านุ่มในการซักผ้าออร์แกนิคของคุณ กรุณาเลือกเพิ่มเติมฟรี ไม่ใช้น้ำยาปรับผ้านุ่ม ข้อมูลน่ารู้ ผลิตภัณฑ์ออร์แกนิคเป็นมิตรต่อสิ่งแวดล้อม จึงขอแนะนำให้ใช้ในการซักผ้าอย่างยิ่ง นอกจากนี้เรามีผลิตภัณฑ์ซักผ้าออร์แกนิคทั้งในและต่างประเทศด้วย กรุณาแจ้งความประสงค์ในช่องความต้องการพิเศษก่อนสั่งออเดอร์กับร้านซักอบรีดมายลอนดรี้ หากมีคำถามอื่นๆ",
};
export const TEXT_WHAT_TYPES_OF_DEERGENTS = {
  EN: "What types of detergents and softeners can I choose from?",
  TH: "ฉันเลือกประเภทของน้ำยาซักผ้าและน้ำยาปรับผ้านุ่มได้ไหม?",
};
export const TEXT_AT_THE_MOMENT_YOU_CANNOT_CHOOSE = {
  EN: "At the moment, you cannot choose any detergent or softener brands directly on our website. ",
  TH: "ขณะนี้คุณไม่สามารถเลือกประเภทของน้ำยาซักผ้าและน้ำยาปรับผ้านุ่มในเว็บไซด์ของร้านซักผ้ามายลอนดรี้ได้",
};
export const TEXT_HOW_EVER_WE_OFFER_ORGANIC = {
  EN: "However, we offer Organic Wash or Baby Wash Add-Ons. Free from dyes, fragrances or preservatives, our Organic Wash detergents and softeners contain only plant-based, naturally-sourced and mineral ingredients. Specially designed for sensitive skin requirements and dermatologically tested to prevent allergic reactions, our Baby Wash detergents and softeners are hypoallergenic and free of dyes but still strong in removing all the stains your baby loves to make. If you wish us to use only detergent with no softener in your Organic or Baby Wash, please select the free of charge No Softener Add-On. PS: We use a variety of locally and internationally sourced Organic and Baby Wash products in our laundry service. Use the Special Request box before placing your laundry service order to tell us your preferences and we will fulfil your request whenever possible. In case you have any questions, you can always",
  TH: " อย่างไรก็ตามเราขอแนะนำให้คุณเลือกเพิ่มเติมผลิตภัณฑ์ซักผ้าออร์แกนิคหรือผลิตภัณฑ์ซักผ้าสำหรับเด็ก โดยน้ำยาซักผ้าและปรับผ้านุ่มออร์แกนิคของเราประกอบด้วยส่วนผสมจากพืชที่มาจากธรรมชาติและแร่ธาตุเท่านั้น ไม่มีสี น้ำหอม หรือวัตถุกันเสียใดๆ อีกทั้งผลิตภัณฑ์ซักผ้าและปรับผ้านุ่มสำหรับเด็กยังผ่านการทดสอบโดยแพทย์ผิวหนังแล้วว่า ป้องกันการระคายเคือง ไม่ก่อให้เกิดอาการแพ้ ใดๆ ไม่มีสี และขจัดคราบต่างๆที่เกิดจากลูกน้อยของคุณได้  หากคุณไม่ต้องการให้เราใช้น้ำยาปรับผ้านุ่มในการซักผ้าออร์แกนิคหรือซักผ้าสำหรับเด็ก กรุณาเลือกเพิ่มเติมฟรี ไม่ใช้น้ำยาปรับผ้านุ่ม นอกจากนี้เรามีผลิตภัณฑ์ซักผ้าออร์แกนิคและผลิตภัณฑ์สำหรับเด็กทั้งในและต่างประเทศด้วย กรุณาแจ้งความประสงค์ในช่องความต้องการพิเศษก่อนสั่งออเดอร์กับร้านซักอบรีดมายลอนดรี้ หากมีคำถามอื่นๆ",
};
export const TEXT_CAN_I_PROVIDE_MY_OWN_DETERGENT = {
  EN: "Can I provide my own detergent?",
  TH: "คุณใช้น้ำยาซักผ้าที่ฉันเตรียมให้ได้ไหม? ",
};
export const TEXT_WE_NOT_NOT_ALLOW_THIS_DUE_TO_HYGIENE = {
  EN: "NO. As part of our professional laundry service, we do not allow this due to hygiene reasons. ",
  TH: "ไม่ได้ เนื่องจากเหตุผลด้านสุขอนามัย ร้านซักผ้ามายลอนดรี้จึงไม่อนุญาตให้ใช้น้ำยาซักผ้าที่คุณเตรียมมา",
};
export const TEXT_CAN_YOU_REMOVE_STAINS = {
  EN: "Can you remove stains?",
  TH: "คุณขจัดคราบสกปรกได้ไหม?",
};
export const TEXT_YES_REMOVING_STAINS = {
  EN: "YES! Removing stains is something we take great pride in as part of our professional laundry service. If you specifically want us to remove any stains from your clothes, we kindly ask you to select our special Stain Removal Add-On.",
  TH: "ได้ บริการขจัดคราบคือสิ่งที่ร้านซักผ้ามายลอนดรี้ภูมิใจนำเสนอ หากคุณต้องการให้เราขจัดคราบบนผ้าของคุณแบบเฉพาะเจาะจง ขอแนะนำตัวเลือกเพิ่มเติม ขจัดคราบ",
};
export const TEXT_WHEN_YOU_CHOOSE_OUR_SPECIAL_STAIN_REMOVAL_ADD_ON = {
  EN: " When you choose our special Stain Removal Add-On, we screen every item of your laundry from head to toe and make every effort to remove any stains we find. As a fully professional laundry service, we can remove many kinds of stains, such as oil, sauces, ketchup, chocolate, mayonnaise, fat, butter, red wine, tea, coffee, fruits, vegetables, cacao, ice cream, eggs, milk, yogurt, cream, mould, blood, pus, sperm, ballpoint pen ink, felt tip pen ink, highlighter ink, coloured pencils, water colours, grass, soil, pollen, make-up, lipstick, body lotion, nail polish, grease, resin, candle wax, industrial oil, tar, chewing gum, glue, rust, deodorant and sweat. If you want us to focus on some items of your laundry in particular, you can tell us in the Special Request box before placing your laundry service order.",
  TH: " เราจะตรวจสอบเสื้อผ้าของคุณทุกจุดอย่างละเอียดเพื่อขจัดคราบออกอย่างหมดจดให้มากที่สุด ในฐานะที่ร้านซักผ้ามายลอนดรี้เป็นมืออาชีพจึงสามารถขจัดคราบได้หลายประเภท ไม่ว่าจะเป็น คราบน้ำมัน น้ำจิ้ม ซอสมะเขือเทศ ช็อกโกแลต มายองเนส คราบไขมัน เนย ไวน์แดง ชา กาแฟ ผลไม้ ผัก โกโก้ ไอศกรีม ไข่ นม โยเกิร์ต ครีม เชื้อรา คราบเลือด หนอง ปากกาลูกลื่น น้ำหมึก ปากกาเมจิ ปากกาไฮไลท์ ดินสอสี สีน้ำ หญ้า ดิน เกสรดอกไม้ เครื่องสำอาง ลิปสติก โลชั่นทาตัว ยาทาเล็บ จารบี เรซิ่น เทียนขี้ผึ้ง น้ำมันอุตสาหกรรม น้ำมันดินหรือทาร์ หมากฝรั่ง กาว สนิม ผลิตภัณฑ์ระงับกลิ่นกายและคราบเหงื่อไคล หากคุณต้องการให้เราเน้นขจัดคราบจุดใดเป็นพิเศษ กรุณาแจ้งในช่องความต้องการพิเศษก่อนสั่งออเดอร์กับร้านซักอบรีด มายลอนดรี้",
};
export const TEXT_DO_YOU_WASH_COMFORTERS = {
  EN: "Do you wash Comforters, Bed Sheets and Pillows?",
  TH: "คุณซักผ้านวม ผ้าห่ม ผ้าปูที่นอน และหมอน ไหม?",
};
export const TEXT_YES_BUT_YOU_NEED_TO_SELECT_THE_CPMFORTER = {
  EN: "YES. But you need to select the Comforter or Duvet Insert, Bed Sheet or Duvet Cover, or Pillows Add-Ons as an Extra. ",
  TH: "ใช่ เราซักเครื่องนอนให้คุณ เพียงแต่คุณต้องเลือกเพิ่มเติมพิเศษ เช่น ผ้านวมหรือผ้าห่ม ผ้าปูที่นอนหรือปลอกผ้านวม หรือหมอน",
};
export const TEXT_WE_WILL_WASH_ALL_LARGE_ITEMS = {
  EN: "As a professional laundry service, we will wash all large items separately from your regular laundry.",
  TH: " ในฐานะที่ร้านซักผ้ามายลอนดรี้เป็นมืออาชีพ เราจะแยกเครื่องนอนออกจากการซักรีดเสื้อผ้าปกติของคุณ",
};

export const TEXT_ARE_THERE_ANY_ADDITIONAL_COSTS = {
  EN: "Are there any additional costs for large items such as blankets? ",
  TH: "มีค่าใช้จ่ายเพิ่มเติมสำหรับผ้าขนาดใหญ่ เช่น ผ้าห่ม ไหม? ",
};
export const TEXT_YES_YOU_NEED_TO_SELECT_THE_COMFORTER = {
  EN: "YES. You need to select the Comforter or Duvet Insert, Bed Sheet or Duvet Cover, or Pillows Add-Ons as an Extra. ",
  TH: "มี เพียงแต่คุณต้องเลือกเพิ่มเติมพิเศษ เช่น ผ้านวมหรือผ้าห่ม ผ้าปูที่นอนหรือปลอกผ้านวม หรือหมอน",
};
export const TEXT_WE_WILL_WASH_ALL_LARGE_ITEMS_ADDIC_TH = {
  // EN: "As a professional laundry service, we will wash all large items separately from your regular laundry. ",
  TH: " ในฐานะที่ร้านซักผ้า",
};
export const TEXT_WE_WILL_WASH_ALL_LARGE_ITEMS_ADDIC_TH_2 = {
  // EN: "As a professional laundry service, we will wash all large items separately from your regular laundry. ",
  TH: "มายลอนดรี้เป็นมืออาชีพ เราจะแยกเครื่องนอนออกจากการซักรีดเสื้อผ้าปกติของคุณ",
};
export const TEXT_DO_YOU_ACCEPT_SPECIAL_REQUESTS = {
  EN: "Do you accept special requests? ",
  TH: "คุณรับความต้องการพิเศษไหม? ",
};
export const TEXT_WE_ACCEPT_SPECIAL_REQUESTS = {
  EN: "YES. As part of our professional laundry service, we accept special requests. ",
  TH: "ใช่ ร้านซักผ้ามายลอนดรี้รับความต้องการพิเศษ",
};
export const TEXT_EX_IF_YOU_USE_HIGH_TEMP = {
  EN: "As an example: if you choose our High Temperate Wash Add-On, we wash at 60°C as standard. However, you can tell us in the Special Request box before placing your order if you want us to wash your laundry at a specific temperature, such as 50°C or 90°C, or if you wish to exclude specific items from the High Temperature Wash and treat them separately. We will always make every effort to fulfil your Special Requests as part of our premium laundry service in Bangkok. In case you have any questions, you can always",
  TH: " เช่น หากคุณเลือกเพิ่มเติมซักด้วยอุณหภูมิสูง เราจะซักที่อุณหภูมิ 60 องศาเซลเซียสเป็นมาตรฐาน อย่างไรก็ตาม หากคุณต้องการให้เราซักที่อุณหภูมิอื่นๆ เช่น 50 หรือ 90 องศาเซลเซียส หรือต้องการแยกบางรายการออกจากการซักด้วยอุณหภูมิสูง กรุณาแจ้งในช่องความต้องการพิเศษก่อนสั่งออเดอร์กับร้านซักอบรีดมายลอนดรี้ เรายินดีให้บริการเต็มที่สำหรับทุกความต้องการพิเศษทั้งในกรุงเทพ หากมีคำถามอื่นๆ",
};
export const TEXT_HOW_DO_YOU_CLEAN_MY_CLOTHES = {
  EN: "How do you clean my clothes?",
  TH: "คุณซักผ้าของฉันยังไง?",
};
export const TEXT_WE_CLEAN_ALL_FABRICS = {
  EN: "As a professional and reliable laundry service, we clean all fabrics which can be washed in a washing machine and dried in a tumble dryer. ",
  TH: "ร้านซักผ้ามายลอนดรี้ซักผ้าทั้งหมดทุกประเภทที่สามารถซักด้วยเครื่องซักผ้าและอบด้วยเครื่องอบผ้าได้",
};
export const TEXT_KINDLY_MAKE_SURE = {
  EN: "Kindly make sure that all your items are machine washable and can be dried in a tumble dryer. In case you have any questions, you can always",
  TH: " กรุณาตรวจสอบผ้าของคุณเองก่อนว่าสามารถซักในเครื่องซักผ้าและอบในเครื่องอบผ้าได้หรือไม่ หากมีคำถามอื่นๆ",
};
export const TEXT_WHO_CHOOSE_THE_CLENING_METHOD = {
  EN: "Who chooses the cleaning method and temperature?",
  TH: "ใครเป็นคนเลือกวิธีและอุณหภูมิในการซักผ้า? ",
};
export const TEXT_OUR_PROFESSINAL_LANDRY_SERVICE = {
  EN: "Our professional laundry service is operated by our dedicated laundry service team who clean your laundry correctly, using the appropriate method and temperature based on their experience and any specific directions on the labels!",
  TH: "ในฐานะที่ร้านซักผ้ามายลอนดรี้เป็นมืออาชีพ ทีมซักอบรีดของเราซักผ้าของคุณอย่างถูกวิธี โดยอาศัยประสบการณ์ เลือกใช้วิธีและอุณหภูมิที่เหมาะสมตามคำแนะนำบนฉลากของเสื้อผ้า!",
};
export const TEXT_WHO_CLEANS_CLOTHES = {
  EN: "Who cleans my clothes?",
  TH: "ใครซักผ้าของฉัน?",
};

export const TEXT_CLEANED_BY_OUR_DEDICATED = {
  EN: "With our professional laundry service, your laundry is cleaned by our dedicated laundry service team at our own facilities.",
  TH: "ทีมซักอบรีดของเราซักผ้าให้คุณอย่างพิถีพิถันที่ร้านซักผ้ามายลอนดรี้ของเราเอง",
};
export const TEXT_WHERE_DO_YOU_CLEAN_MY_CLOTHES = {
  EN: "Where do you clean my clothes? ",
  TH: "คุณซักผ้าของฉันที่ไหน? ",
};
export const TEXT_CLEANED_AT_OUR_OWN_LAUNDRY = {
  EN: "With our professional laundry service, your laundry will be cleaned at our own laundry facilities in Bangkok.",
  TH: "ทีมซักอบรีดของเราซักผ้าให้คุณอย่างพิถีพิถันที่ร้านซักผ้ามายลอนดรี้ของเราเองทั้งในกรุงเทพ",
};
export const TEXT_DO_YOU_OFFER_DRY_CLEANING = {
  EN: "Do you offer dry-cleaning? ",
  TH: "คุณมีบริการซักแห้งไหม? ",
};
export const TEXT_NO_OFFER_DRY_CLEANING = {
  EN: "NO. At the moment we do not offer dry-cleaning",
  TH: "ไม่มี ขณะนี้ร้านซักผ้ามายลอนดรี้ยังไม่มีบริการซักแห้ง",
};
export const TEXT_BUT_WE_PLAN_TO_RESUME = {
  EN: " but we plan to resume this service in the near future as we also specialise in dry-cleaning as part of our comprehensive laundry service in Bangkok. There has been a delay in the delivery of the state-of-the-art dry-cleaning machines we have ordered, but we are hoping to resolve the issue in 2023 at the latest.",
  TH: " อย่างไรก็ตามด้วยความเชี่ยวชาญในการซักแห้ง เราจะกลับมาเปิดให้บริการอีกครั้งในกรุงเทพเร็วๆนี้  เนื่องจากมีความล่าช้าในการจัดส่งเครื่องอบผ้าอันทันสมัย จึงไม่สามารถเปิดให้บริการได้ ทั้งนี้เราหวังว่าจะจัดการให้เรียบร้อยภายในปี พ.ศ. 2566",
};
export const TEXT_DO_YOU_OFFER_A_HAND_WASHING = {
  EN: "Do you offer a hand wash service for clothes? ",
  TH: "คุณมีบริการซักผ้าด้วยมือไหม? ",
};
export const TEXT_NO_WASH_HAND = {
  EN: "NO. At the moment we do not offer a hand wash laundry service",
  TH: "ไม่มี ขณะนี้ร้านซักผ้ามายลอนดรี้ไม่มีบริการซักผ้าด้วยมือ",
};
export const TEXT_BUT_WE_PREPARING = {
  EN: " but we are preparing our facilities to offer this service as part of our comprehensive laundry services in the near future.",
  TH: " อย่างไรก็ตามเรากำลังเตรียมสถานที่เพื่อเปิดให้บริการในอนาคตอันใกล้นี้",
};
export const TEXT_ARE_THERE_ANY_ITEMS_OF_FABRIC = {
  EN: "Are there any items or fabrics you currently do not clean? ",
  TH: "คุณไม่ซักผ้าประเภทไหนและไม่ซักอะไรบ้าง? ",
};
export const TEXT_DO_YOU_CLEAN_WEDDINGSREESES = {
  EN: "Do you clean wedding dresses?",
  TH: "คุณมีบริการซักชุดแต่งงานด้วยไหม? ",
};
export const TEXT_NO_AT_THE_MOMENT = {
  EN: "NO. At the moment we do not clean wedding dresses. ",
  TH: "ไม่มี ขณะนี้ร้านซักผ้ามายลอนดรี้ไม่มีบริการซักชุดแต่งงาน",
};
export const TEXT_WE_DO_NOT_CLEAN_MATTRESS = {
  EN: "We do not clean mattresses, toppers, curtains, carpets, wedding dresses or dolls at the moment. ",
  TH: "ขณะนี้ร้านซักผ้ามายลอนดรี้ไม่มีบริการซักที่นอน แผ่นรองนอน ผ้าม่าน พรม ชุดแต่งงานหรือตุ๊กตา",
};
export const TEXT_HOWEVER_WE_CLEAN_ALL_FABRIC = {
  EN: "However, as a professional and reliable laundry service, we clean all fabrics which can be washed in a washing machine and dried in a tumble dryer. In case you have any questions, you can always",
  TH: " เราซักผ้าทั้งหมดทุกประเภทที่สามารถซักด้วยเครื่องซักผ้าและอบด้วยเครื่องอบผ้าได้ หากมีคำถามอื่นๆ",
};
export const TEXT_DO_YOU_CLEAN_LEATHER = {
  EN: "Do you clean leather clothes? ",
  TH: "คุณมีบริการทำความสะอาดผ้าหนังไหม? ",
};
export const TEXT_NO_CLEAN_LEATHER = {
  EN: "NO. We do not clean leather clothes as part of our laundry service at the moment. ",
  TH: "ไม่มี ขณะนี้ร้านซักผ้ามายลอนดรี้ไม่มีบริการทำความสะอาดผ้าหนัง",
};
export const TEXT_WE_CLEAN_SHOES = {
  EN: "As part of our professional shoe cleaning service, however, we clean shoes of all colours and types, from sneakers to leather shoes.",
  TH: " หากเป็นการทำความสะอาดรองเท้า เราสามารถทำได้กับรองเท้าทุกสีทุกประเภท ตั้งแต่รองเท้าผ้าใบไปจนถึงรองเท้าหนัง",
};
export const TEXT_WHAT_HAPPENS_IF_AM_NOT_HAPPY = {
  EN: "What happens if I am not happy with the washing or ironing results? ",
  TH: "ถ้าฉันไม่พอใจในการซักรีดของคุณล่ะ? ",
};
export const TEXT_IF_YOU_ARE_NOT_HAPPY = {
  EN: "If you are not entirely happy with the results of our services, we kindly ask you to",
  TH: "หากคุณไม่พอใจกับบริการของเรา กรุณา",
};
export const TEXT_AND_SEND_US = {
  EN: "and send us photos via your preferred messenger channel. As we are strongly committed to quality, we are convinced we will be able to find a good solution to make you happy! ",
  TH: "และส่งรูปถ่ายผ่านแอปแชทที่คุณสะดวก เราเชื่อว่าจะสามารถหาทางออกที่ดีเพื่อให้คุณมีความสุขได้อีกครั้ง! ",
};

export const TEXT_WHAT_HAPPENS_IN_THE_EVENT = {
  EN: "What happens in the event that my clothes are damaged or lost? ",
  TH: "ถ้าเสื้อผ้าของฉันชำรุดหรือสูญหาย คุณจะทำอย่างไร? ",
};

export const TEXT_WE_TRACK = {
  EN: "We track all items carefully and are proud to say that such an event is extremely rare. ",
  TH: "เราดูแลทุกออเดอร์อย่างระมัดระวัง จึงเชื่อมั่นว่าเหตุการณ์ดังกล่าวจะไม่เกิดขึ้น",
};
export const TEXT_IN_THE_UNLIKELY_EVENT = {
  EN: "However, in the unlikely event that your clothes or other items are damaged or lost while in our care, we will work together with you to find a fair and reasonable solution according to our",
  TH: " อย่างไรก็ตาม ในกรณีที่เสื้อผ้าของคุณชำรุดหรือสูญหายขณะที่อยู่ในความดูแลของเรา เราจะหาวิธีแก้ปัญหาที่ยุติธรรมอย่างเหมาะสมตาม",
};
export const TEXT_MY_LAUNDRY_PUTS_CUSTOMER = {
  EN: "My Laundry puts customer service above all else and is fully committed to ensuring the satisfaction of our customers is always put first. In case you have any questions, you can always",
  TH: " เพราะมายลอนดรี้ให้ความสำคัญกับการบริการลูกค้าเหนือสิ่งอื่นใดและมีความมุ่งมั่นที่จะสร้างความพึงพอใจให้ลูกค้าก่อนเสมอ หากมีคำถามอื่นๆ",
};
export const TEXT_MY_LAUNDRY_PUTS_CUSTOMER_MB = {
  EN: "My Laundry puts customer service above all else and is fully committed to ensuring the satisfaction of our customers is always put first. In case you have any questions, you can always",
  TH: "ของเรา เพราะมายลอนดรี้ให้ความสำคัญกับการบริการลูกค้าเหนือสิ่งอื่นใดและมีความมุ่งมั่นที่จะสร้างความพึงพอใจให้ลูกค้าก่อนเสมอ หากมีคำถามอื่นๆ",
};
export const TEXT_SHOE_CLEANING_FAQS = {
  EN: "Shoe Cleaning Service: In-Detail FAQs ",
  TH: "คำถามที่พบบ่อยในการทำความสะอาดรองเท้า ",
};
export const TEXT_WHAT_TYPES_AND_FABRICS = {
  EN: "What types and fabrics of shoes do you clean? ",
  TH: "คุณทำความสะอาดรองเท้าประเภทไหนและวัสดุแบบใดบ้าง? ",
};
export const TEXT_WITH_OUR_PREMIUM_SHOE = {
  EN: " With our premium shoe cleaning service, we clean shoes of all colours and types, from sneakers to leather shoes, while we specialise in white sneakers made from leather or other modern fabrics. ",
  TH: "ร้านซักรองเท้ามายลอนดรี้ทำความสะอาดรองเท้าทุกสีทุกประเภท ตั้งแต่รองเท้าผ้าใบไปจนถึงรองเท้าหนัง เรายังเชี่ยวชาญในการซักรองเท้าผ้าใบสีขาวที่ทำจากหนังหรือวัสดุทันสมัย ",
};
export const TEXT_WE_ALSO_RECCOMEND_SHOE = {
  EN: "We also recommend choosing our Add-Ons Protection & Waterproofing, Interior Shoe Cleansing and Shoe Perfume for ultimate shoe cleaning results.",
  TH: "นอกจากนี้เราขอแนะนำให้เลือกบริการเพิ่มเติมผลิตภัณฑ์เคลือบและกันน้ำ ทำความสะอาดรองเท้าด้านใน และน้ำหอมสำหรับรองเท้าด้วย เพื่อผลลัพธ์ที่ดีที่สุดในการทำความสะอาดรองเท้า ",
};
export const TEXT_DO_YOU_CLEAN_WHITE_SHOES = {
  EN: "Do you clean white shoes or white sneakers? ",
  TH: "คุณทำความสะอาดรองเท้าสีขาวหรือรองเท้าผ้าใบสีขาวไหม? ",
};
export const TEXT_YES_WE_CLEAN_SHOES = {
  EN: "YES. As a premium shoe cleaning service, we clean shoes of all colours and types, from sneakers to leather shoes, and we also specialise in cleaning white shoes and white sneakers made from leather or other modern fabrics.",
  TH: "ใช่ ร้านซักรองเท้ามายลอนดรี้ทำความสะอาดรองเท้าทุกสีทุกประเภท ตั้งแต่รองเท้าผ้าใบไปจนถึงรองเท้าหนัง เรายังเชี่ยวชาญในการซักรองเท้าสีขาวและรองเท้าผ้าใบสีขาวที่ทำจากหนังหรือวัสดุทันสมัย",
};
export const TEXT_WHEN_USE_OUR_PROFESSIONAL_SHOE = {
  EN: " When you use our professional shoe cleaning service in Bangkok or Pattaya, we also recommend choosing our Add-Ons Protection & Waterproofing, Interior Shoe Cleansing and Shoe Perfume for ultimate shoe cleaning results.",
  TH: " หากคุณเลือกบริการซักรองเท้าในกรุงเทพ เราขอแนะนำให้เลือกบริการเพิ่มเติมผลิตภัณฑ์เคลือบและกันน้ำ ทำความสะอาดรองเท้าด้านใน และน้ำหอมสำหรับรองเท้าด้วย เพื่อผลลัพธ์ที่ดีที่สุดในการทำความสะอาดรองเท้า",
};

export const TEXT_WHAT_BRANDS_AND_MODELS = {
  EN: "What brands and models of shoes and sneakers can you clean? ",
  TH: "รองเท้ายี่ห้อไหนและรุ่นอะไรที่คุณทำความสะอาดได้？",
};

export const TEXT_THE_BRANDS_AND_MODELS = {
  EN: "The brands and models of shoes and sneakers we clean include but are not limited to Birkenstock, Vans, Ultra Boost, BTS, Adidas, Crocs, Converse, Onitsuka, Timberland, Red Wing, Stan Smith, NMD, Yeez, Lacoste and New Balance. When you use our professional shoe cleaning service in Bangkok or Pattaya, we also recommend choosing our Add-Ons Protection & Waterproofing, Interior Shoe Cleansing and Shoe Perfume for ultimate shoe cleaning results.",
  TH: "ร้านซักรองเท้ามายลอนดรี้ยินดีดูแลรองเท้าและรองเท้าผ้าใบทุกยี่ห้อและทุกรุ่น ไม่ว่าจะเป็น เบอร์เคนสต๊อก แวน อัลตร้าบูท บีทีเอส อดิดาส ครอส คอนเวิร์ส โอนิซึกะ ทิมเบอร์แลนด์ เรดวิง แสตนสมิทส์ NMD Yeez ลาคอสต์ หรือ นิวบาลานซ์ หากคุณเลือกบริการซักรองเท้าในกรุงเทพ เราขอแนะนำให้เลือกบริการเพิ่มเติมผลิตภัณฑ์เคลือบและกันน้ำ ทำความสะอาดรองเท้าด้านใน และน้ำหอมสำหรับรองเท้าด้วย เพื่อผลลัพธ์ที่ดีที่สุดในการทำความสะอาดรองเท้า",
};
export const TEXT_THE_BRANDS_AND_MODELS_TH_1 = {
  TH: "ร้านซักรองเท้ามายลอนดรี้ยินดีดูแลรองเท้าและรองเท้าผ้าใบทุกยี่ห้อและทุกรุ่น ไม่ว่าจะเป็น เบอร์เคนสต๊อก แวน อัลตร้าบูท บีทีเอส ",
};
export const TEXT_THE_BRANDS_AND_MODELS_TH_2 = {
  TH: "อดิดาส ครอส คอนเวิร์ส โอนิซึกะ ทิมเบอร์แลนด์ เรดวิง แสตนสมิทส์ NMD Yeez ลาคอสต์ หรือ นิวบาลานซ์ หากคุณเลือกบริการซักรองเท้าในกรุงเทพ เราขอแนะนำให้เลือกบริการเพิ่มเติมผลิตภัณฑ์เคลือบและกันน้ำ ทำความสะอาดรองเท้าด้านใน และน้ำหอมสำหรับรองเท้าด้วย เพื่อผลลัพธ์ที่ดีที่สุดในการทำความสะอาดรองเท้า",
};
export const TEXT_THE_BRANDS_AND_MODELS_TH_MB_1 = {
  TH: "ร้านซักรองเท้ามายลอนดรี้ยินดีดูแลรองเท้าและรองเท้าผ้าใบทุกยี่ห้อและทุกรุ่น ไม่ว่าจะเป็น เบอร์เคนสต๊อก แวน อัลตร้าบูท ",
};
export const TEXT_THE_BRANDS_AND_MODELS_TH_MB_2 = {
  TH: "บีทีเอส อดิดาส ครอส คอนเวิร์ส โอนิซึกะ ทิมเบอร์แลนด์ เรดวิง แสตนสมิทส์ NMD Yeez ลาคอสต์ หรือ นิวบาลานซ์ หากคุณเลือกบริการซักรองเท้าในกรุงเทพ เราขอแนะนำให้เลือกบริการเพิ่มเติมผลิตภัณฑ์เคลือบและกันน้ำ ทำความสะอาดรองเท้าด้านใน และน้ำหอมสำหรับรองเท้าด้วย เพื่อผลลัพธ์ที่ดีที่สุดในการทำความสะอาดรองเท้า",
};

export const TEXT_DO_YOU_ALSO_CLEAN_THE_SOLE_OF_SHOES = {
  EN: "Do you also clean the sole of shoes? ",
  TH: "คุณทำความสะอาดพื้นรองเท้าด้านนอกไหม? ",
};
export const TEXT_YES_WE_HAVE_DEVELOPED = {
  EN: "YES. We have developed different ways and technologies to clean the sole of shoes and sneakers of all colours and types, especially white soles. ",
  TH: "ใช่ ร้านซักรองเท้ามายลอนดรี้พัฒนาวิธีและเทคโนโลยีที่แตกต่างเพื่อทำความสะอาดพื้นรองเท้าด้านนอก สำหรับรองเท้าและรองเท้าผ้าใบทุกสีทุกประเภท โดยเฉพาะพื้นรองเท้าด้านนอกสีขาว ",
};
export const TEXT_THE_SHOES_CLEANING_METHOD = {
  EN: "The shoe cleaning methods we use include but are not limited to dry-cleaning, wet wiping and stain removal. When you use our professional shoe cleaning service in Bangkok or Pattaya, we also recommend choosing our Add-Ons Protection & Waterproofing, Interior Shoe Cleansing and Shoe Perfume for ultimate shoe cleaning results.",
  TH: "วิธีการทำความสะอาดของสปารองเท้ามายลอนดรี้ไม่เพียงแต่รวมการซักแห้งรองเท้า เช็ดรองเท้า หรือขจัดคราบด้วยยางลบ แต่ยังมีวิธีอื่นด้วย หากคุณเลือกบริการซักรองเท้าในกรุงเทพ เราขอแนะนำให้เลือกบริการเพิ่มเติมผลิตภัณฑ์เคลือบและกันน้ำ ทำความสะอาดรองเท้าด้านใน และน้ำหอมสำหรับรองเท้าด้วย เพื่อผลลัพธ์ที่ดีที่สุดในการทำความสะอาดรองเท้า",
};
export const TEXT_DO_YOU_CLEAN_THE_INSOLES = {
  EN: "Do you clean the insoles of shoes? ",
  TH: "คุณทำความสะอาดพื้นรองเท้าด้านในไหม?",
};
export const TEXT_WE_CAN_CLEAN_BOTH = {
  EN: "YES. We can clean both the inside and the outside of your shoes, including the insoles, which we strongly recommend for hygiene reasons. ",
  TH: "ใช่ เราทำความสะอาดรองเท้าทั้งด้านในและด้านนอก รวมถึงพื้นรองเท้าด้านในด้วย ซึ่งเราขอแนะนำอย่างยิ่งเพื่อสุขอนามัยที่ดี ",
};
export const TEXT_PLEASE_SELECT_THE_INTERIOR = {
  EN: "Please select the",
  TH: "หากคุณต้องการให้เราดูแลรองเท้าของคุณทั้งภายนอกและภายในรวมถึงพื้นรองเท้าด้านในด้วย กรุณาเลือกตัวเลือกเพิ่มเติม",
};
export const TEXT_INTERIOR_CLEANING = {
  EN: " Interior Shoe Cleansing ",
  TH: " ทำความสะอาดรองเท้าด้านใน ",
};
export const TEXT_ADD_ON_IF_YOU_WOULD = {
  EN: "Add-On if you would specifically like us not only to clean the outside of your shoes but also to focus particularly on the inside of your shoes including the insole. We have developed different ways and technologies to clean the inside of shoes. The shoe cleaning methods we use include but are not limited to special washing, dry-cleaning, wet wiping and stain removal. When you use our professional shoe cleaning service in Bangkok or Pattaya, we additionally recommend choosing our Add-Ons Protection & Waterproofing and Shoe Perfume for ultimate shoe cleaning results.",
  TH: "เราพัฒนาวิธีและเทคโนโลยีที่แตกต่างเพื่อทำความสะอาดรองเท้าด้านใน วิธีการทำความสะอาดของสปารองเท้ามายลอนดรี้ไม่เพียงแต่รวมการซักแห้งรองเท้า เช็ดรองเท้า หรือขจัดคราบด้วยยางลบ แต่ยังมีวิธีอื่นๆด้วย หากคุณเลือกบริการซักรองเท้าในกรุงเทพ เราขอแนะนำให้เลือกบริการเพิ่มเติมผลิตภัณฑ์เคลือบและกันน้ำ ทำความสะอาดรองเท้าด้านใน และน้ำหอมสำหรับรองเท้าด้วย เพื่อผลลัพธ์ที่ดีที่สุดในการทำความสะอาดรองเท้า",
};
export const TEXT_CAN_LEATHER_SHOES_OR_LEATHER = {
  EN: "Can leather shoes or leather sneakers be washed in a washing machine? ",
  TH: "ซักรองเท้าหนังหรือรองเท้าผ้าใบหนังในเครื่องซักผ้าได้ไหม?",
};
export const TEXT_NO_LEATHER_SHOES_AND_SNEAKERS = {
  EN: "NO. Leather shoes and sneakers cannot be washed in a washing machine. ",
  TH: "ไม่ได้ ทั้งรองเท้าหนังและรองเท้าผ้าใบหนังไม่สามารถซักในเครื่องซักผ้าได้ ",
};
export const TEXT_AS_AN_EXPERIENCED = {
  EN: "As an experienced and professional shoe cleaning service, we have developed different ways and technologies to clean leather shoes and leather sneakers of all colours, especially white sneakers made from leather or other modern fabrics. The shoe cleaning methods we use include but are not limited to dry-cleaning, wet wiping and stain removal. When you use our professional shoe cleaning service in Bangkok or Pattaya, we also recommend choosing our Add-Ons Protection & Waterproofing, Interior Shoe Cleansing and Shoe Perfume for ultimate shoe cleaning results.",
  TH: "ในฐานะที่ร้านซักรองเท้ามายลอนดรี้เป็นมืออาชีพ เราพัฒนาวิธีและเทคโนโลยีที่แตกต่างเพื่อทำความสะอาดรองเท้าหนังและรองเท้าผ้าใบหนังทุกสี โดยเฉพาะรองเท้าผ้าใบสีขาวที่ทำจากหนังหรือวัสดุทันสมัย วิธีการทำความสะอาดของสปารองเท้ามายลอนดรี้ไม่เพียงแต่รวมการซักแห้งรองเท้า เช็ดรองเท้า หรือขจัดคราบด้วยยางลบ แต่ยังมีวิธีอื่นๆด้วย หากคุณเลือกบริการซักรองเท้าในกรุงเทพ เราขอแนะนำให้เลือกบริการเพิ่มเติมผลิตภัณฑ์เคลือบและกันน้ำ ทำความสะอาดรองเท้าด้านใน และน้ำหอมสำหรับรองเท้าด้วย เพื่อผลลัพธ์ที่ดีที่สุดในการทำความสะอาดรองเท้า",
};
export const TEXT_CAN_VELOUR_LEATHERS_SHOES = {
  EN: "Can velour leather shoes be washed in a washing machine?",
  TH: "ซักรองเท้าหนังกลับในเครื่องซักผ้าได้ไหม?",
};
export const TEXT_NO_VELOUR_LEATHERS_SHOES = {
  EN: "NO. Velour leather shoes cannot be washed in a washing machine. ",
  TH: "ไม่ได้ รองเท้าหนังกลับไม่สามารถซักในเครื่องซักผ้าได้ ",
};
export const TEXT_AS_PART_VELOUR_LEATHERS_SHOES = {
  EN: "As part of our premium shoe cleaning service, we have developed different ways and technologies to clean velour leather shoes of all colours and types. The shoe cleaning methods we use include but are not limited to dry-cleaning, wet wiping and stain removal. When you use our professional shoe cleaning service in Bangkok or Pattaya, we also recommend choosing our Add-Ons Protection & Waterproofing, Interior Shoe Cleansing and Shoe Perfume for ultimate shoe cleaning results.",
  TH: "ในฐานะที่ร้านซักรองเท้ามายลอนดรี้เป็นมืออาชีพ เราพัฒนาวิธีและเทคโนโลยีที่แตกต่างเพื่อทำความสะอาดรองเท้าหนังกลับทุกสีทุกประเภท วิธีการทำความสะอาดของสปารองเท้ามายลอนดรี้ไม่เพียงแต่รวมการซักแห้งรองเท้า เช็ดรองเท้า หรือขจัดคราบด้วยยางลบ แต่ยังมีวิธีอื่นๆด้วย หากคุณเลือกบริการซักรองเท้าในกรุงเทพ เราขอแนะนำให้เลือกบริการเพิ่มเติมผลิตภัณฑ์เคลือบและกันน้ำ ทำความสะอาดรองเท้าด้านใน และน้ำหอมสำหรับรองเท้าด้วย เพื่อผลลัพธ์ที่ดีที่สุดในการทำความสะอาดรองเท้า",
};

export const TEXT_CAN_PLATFORM_SHOES = {
  EN: "Can platform shoes be washed in a washing machine? ",
  TH: "ซักรองเท้าสตั๊ดในเครื่องซักผ้าได้ไหม? ",
};
export const TEXT_IT_DEPENDS_ON_THE_MATERIAL = {
  EN: "It depends on the material your platform shoes are made from. ",
  TH: "ขึ้นอยู่กับวัสดุของรองเท้าสตั๊ดของคุณ ",
};
export const TEXT_IF_YOUR_PLATFORM = {
  EN: "If your platform shoes are made from leather, we do not recommend washing them in a washing machine. If your platform shoes are made from other modern fabrics, it might be possible to wash them in a washing machine. We have developed different ways and technologies to clean platform shoes all colours and types, especially white stack shoes. The shoe cleaning methods we use include but are not limited to dry-cleaning, wet wiping and stain removal. When you use our professional shoe cleaning service in Bangkok or Pattaya, we also recommend choosing our Add-Ons Protection & Waterproofing, Interior Shoe Cleansing and Shoe Perfume for ultimate shoe cleaning results.",
  TH: "หากรองเท้าสตั๊ดของคุณทำจากหนัง เราไม่แนะนำให้ซักในเครื่องซักผ้า หากทำจากวัสดุทันสมัย อาจจะซักในเครื่องซักผ้าได้ ในฐานะที่ร้านซักรองเท้ามายลอนดรี้เป็นมืออาชีพ เราพัฒนาวิธีและเทคโนโลยีที่แตกต่างเพื่อทำความสะอาดรองเท้าสตั๊ดทุกสีทุกประเภท โดยเฉพาะรองเท้าสตั๊ดสีขาว วิธีการทำความสะอาดของสปารองเท้ามายลอนดรี้ไม่เพียงแต่รวมการซักแห้งรองเท้า เช็ดรองเท้า หรือขจัดคราบด้วยยางลบ แต่ยังมีวิธีอื่นๆด้วย หากคุณเลือกบริการซักรองเท้าในกรุงเทพ เราขอแนะนำให้เลือกบริการเพิ่มเติมผลิตภัณฑ์เคลือบและกันน้ำ ทำความสะอาดรองเท้าด้านใน และน้ำหอมสำหรับรองเท้าด้วย เพื่อผลลัพธ์ที่ดีที่สุดในการทำความสะอาดรองเท้า",
};
//CONTACT
export const TEXT_ADD_OUR_LINE = {
  EN: "Add our Line Official Account",
  TH: "เพิ่มบัญชี Line Official Account",
};
export const TEXT_OR = {
  EN: "or",
  TH: "หรือ",
};
export const TEXT_CONNECT_WITH_US = {
  EN: "Apart from our Line Official Account and during the abovementioned service hours, we are also online and ready to serve you on various messenger apps. Just add us by our Thai phone number",

  TH: "นอกจาก Line Official Account และช่วงเวลาให้บริการที่กล่าวข้างต้นแล้ว คุณสามารถติดต่อเราได้ผ่านทางแอปแชทต่างๆ ด้วยเบอร์โทร ",
};

export const TEXT_OR_FOR_SOME_CONTACTUS = {
  EN: " or for some apps also by ID: mylaundrythai",
  TH: " หรือ ID mylaundrythai",
};
export const TEXT_ANSWER_QUESTION = {
  EN: " We’re here to answer your questions from",
  TH: "เรายินดีให้บริการทุกวัน   ",
};
export const TEXT_FROM_TIME = {
  EN: `  10:00 - ${LAST_TIME_YOU_STILL_CAN_BOOK}:00 daily `,
  TH: `ตั้งแต่เวลา 10:00-${LAST_TIME_YOU_STILL_CAN_BOOK}:00 น.`,
};
export const TEXT_CHECK_OUT_OUR = {
  EN: "or check out our",
  TH: "หรือหากมีคำถามใดๆ สามารถดูที่หน้า",
};
export const TEXT_SECTION = {
  EN: "section.",
  TH: "ได้",
};

export const TEXT_SELECT_COUNTRY_CODE = {
  EN: "Country Code",
  TH: "รหัสประเทศ",
};

export const TEXT_SELECT_FAVORITE_ADDRESS = {
  EN: "Save Your Favourite Places",
  TH: "บันทึกที่อยู่ที่คุณชื่นชอบ",
};

export const TEXT_PLACEHOLDER_ADDRESS_NAME = {
  EN: "Name Your Address",
  TH: "ตั้งชื่อที่อยู่ของคุณ",
};

export const TEXT_ADDRESS_GPS = {
  EN: "Please allow us to access your GPS location.",
  TH: "กรุณาอนุญาตให้เราเข้าถึงตำแหน่ง GPS ของคุณ",
};

export const TEXT_GET_IN_TOUCH = {
  EN: "Get in touch",
  TH: "คุยกับเรา",
};
export const TEXT_HOW_TO_CREATE_AN_ORDER = {
  EN: "How to create an order?",
  TH: "สร้างออเดอร์ยังไง?",
};

export const TEXT_HOW_TO_CREATE_AN_ORDER_DETAIL = {
  EN: "The most recommended and easiest way to",
  TH: "วิธีง่ายและสะดวกที่สุดในการ",
};

export const TEXT_HOW_TO_CREATE_AN_ORDER_DETAIL_2 = {
  EN: "an order is to do it directly here on our My Laundry website! However, during our service hours, you can also make an order personally by contacting us through our Line Official Account or your preferred messenger app as mentioned above. ",
  TH: "คือสร้างบนเว็บไซต์มายลอนดรี้ได้เลย อย่างไรก็ตาม ในช่วงเวลาให้บริการ คุณสามารถสร้างออเดอร์โดยตรงผ่านทาง Line Official Account หรือแอปแชทต่างๆดังที่กล่าวไว้แล้วข้างต้น ",
};
export const TEXT_SERVICE_HOME = {
  EN: "Service Hours",
  TH: "ช่วงเวลาให้บริการ",
};

export const TEXT_SERVICE_HOME_BOLD = {
  EN: "You can rely on us to pick up and return your order on time!",
  TH: "ให้คุณวางใจได้ เราจะไปรับและส่งคืนออเดอร์ของคุณตรงเวลา!",
};
export const TEXT_CONTACT_US_SERVICE_HOME = {
  EN: ` You can contact us directly during our service hours from ${START_HOUR}:00 until ${LAST_TIME_YOU_STILL_CAN_BOOK}:00, 7 days per week, and nearly 365 days per year. During these times, we are also happy to answer your questions and serve you personally, while our website offers the easiest and most convenient way to`,
  TH: ` ร้านซักผ้าและทำความสะอาดรองเท้ามายลอนดรี้มีช่วงเวลาให้บริการตั้งแต่ ${START_HOUR}:00 น. ถึง ${LAST_TIME_YOU_STILL_CAN_BOOK}:00 น. 7 วันต่อสัปดาห์ 365 วันต่อปี ด้วยช่วงเวลาให้บริการนี้ เรายินดีที่จะตอบคำถามและให้บริการคุณโดยตรง นอกจากนี้เว็บไซต์ของเรายังช่วยให้คุณ`,
};
export const TEXT_CONTACT_US_SERVICE_HOME_2 = {
  EN: ` You can contact us directly during our service hours from ${START_HOUR}:00 until ${LAST_TIME_YOU_STILL_CAN_BOOK}:00,`,
  TH: ` ร้านซักผ้าและทำความสะอาดรองเท้า`,
};
export const TEXT_CONTACT_US_SERVICE_HOME_3 = {
  EN: `7 days per week, and nearly 365 days per year. During these times, we are also happy to answer your questions and serve you personally,`,
  TH: `มายลอนดรี้ให้บริการรับและส่งคืนออเดอร์ตั้งแต่เวลา ${START_HOUR}:00 น. จนถึง ${LAST_TIME_YOU_STILL_CAN_BOOK}:00 น. 7 วันต่อสัปดาห์ 365 วันต่อปี ด้วยช่วงเวลาให้บริการนี้ เรายินดีที่จะตอบคำถามและให้บริการคุณโดยตรง นอกจากนี้เว็บไซต์ของเรา`,
};
export const TEXT_CONTACT_US_SERVICE_HOME_4 = {
  EN: `while our website offers the easiest and most convenient way to`,
  TH: `ยังช่วยให้คุณ`,
};

export const TEXT_AN_ORDER_SERVICE_HOME = {
  EN: `an order 24/7. We also encourage you to check our`,
  TH: `ง่ายและสะดวกที่สุดตลอดเวลา 24 ชั่วโมง และยังมีหน้า`,
};
export const TEXT_CONTACTUS_ALSO = {
  EN: `We also encourage you to check out our`,
  TH: ``,
};
export const TEXT_FAQ_SERVICE_BKK_PTY = {
  EN: `page where we answer the most popular questions about our laundry service and shoe cleaning service in Bangkok.`,
  TH: `ซึ่งรวมคำถามที่พบบ่อยที่สุดเกี่ยวกับบริการซักผ้าและทำความสะอาดรองเท้าของมายลอนดรี้ทั้งในกรุงเทพ`,
};
//PRICING
export const TEXT_OUR_PROGRAMS = {
  EN: ` Our Programs`,
  TH: `โปรแกรมของเรา`,
};

export const TEXT_ORDER_DES_2 = {
  EN: `Each time you book our professional laundry service or shoe cleaning service, you now also have the option of ordering our family-owned Finn Drinking Water to be delivered to your doorstep `,
  TH: ``,
};
export const TEXT_ORDER_DES_3 = {
  EN: `when we return your order.`,
  TH: ``,
};

export const TEXT_WANT_TO_KNOW_MORE = {
  EN: `Do you have a laundry service near me? `,
  TH: `คุณรู้จักร้านซักผ้าใกล้ฉันไหม? `,
};
export const TEXT_CHECK_OUT_OUR_PRICING = {
  EN: "Check out our",
  TH: "ดู",
};
export const TEXT_FAQ_PRICING = {
  EN: "",
  TH: "",
};

export const TEXT_CHECK_OUT_OUR_PRICING2 = {
  EN: "Yes, right here! My Laundry is your professional laundry service and shoe cleaning service in Bangkok. For your utmost convenience, we pick up your laundry and shoes at your home or hotel and return it to you in just 24 hours. You want it faster than that? Go for our Express Laundry Service and receive your items back on the same day!",
  TH: "ใช่ อยู่นี่ไง! มายลอนดรี้ คือร้านซักผ้าและทำความสะอาดรองเท้าที่ให้บริการในกรุงเทพ เพื่อให้คุณสะดวกมากที่สุด มายลอนดรี้จะไปรับออเดอร์ที่บ้านหรือโรงแรมและส่งคืนภายใน 24 ชม. อยากให้เร็วกว่านี้ไหม ได้เลย ด้วยบริการส่งคืนด่วน มายลอนดรี้จะไปรับออเดอร์และส่งคืนภายในวันเดียวกัน!",
};
export const TEXT_SECTION_OR = {
  EN: "section or",
  TH: "หรือ",
};
export const TEXT_PRICING_FIXED = {
  EN: "Our professional laundry service policy is Fixed Price – No Surprises. This is what sets us apart from other laundry service providers who charge you by weight so you never know in advance how much you will really pay in the end. At My Laundry, you can be confident that you know the price you will pay for your laundry or shoes before we come to pick them up, as easy as ordering food or shopping online! Our price tables below give you a clear and transparent overview of the costs of our laundry service as well as our shoe cleaning service with all information and details included. It is your right to know how much you will pay and we are glad to show you. ",
  TH: "",
};
export const TEXT_PRICING_FIXED_TH = {
  EN: "",
  TH: "ร้านซักผ้ามายลอนดรี้มีนโยบายคือ ราคาแน่นอน ให้คุณแน่ใจ สิ่งนี้ทำให้เราแตกต่างจากร้านซักผ้ารายอื่นๆ ที่เรียกเก็บเงินตามน้ำหนักเป็นกิโล โดยที่คุณไม่เคยรู้ราคาล่วงหน้าเลยว่าสุดท้ายแล้วคุณต้องจ่ายเท่าไหร่ มายลอนดรี้ทำให้คุณมั่นใจได้ว่าคุณจะรู้ราคาที่ต้องชำระก่อนเราไปรับผ้าหรือรองเท้าของคุณ ทุกอย่างจึงง่ายเหมือนการสั่งอาหารหรือซื้อสินค้าออนไลน์ ตารางราคาด้านล่างระบุราคาที่ชัดเจนอย่างโปร่งใสทั้งบริการซักผ้าและทำความสะอาดรองเท้า รวมถึงรายละเอียดข้อมูลต่างๆ โดยคุณมีสิทธิ์ที่จะรู้",
};
export const TEXT_PRICING_FIXED_TH_2 = {
  EN: "",
  TH: "และเรายินดีที่จะแสดงให้เห็นชัดเจน ",
};
export const TEXT_PRICING_FIXED_MB = {
  EN: "",
  TH: "ร้านซักผ้ามายลอนดรี้มีนโยบายคือ ราคาแน่นอน ให้คุณแน่ใจ สิ่งนี้ทำให้เราแตกต่างจากร้านซักผ้ารายอื่นๆ ที่เรียกเก็บเงินตามน้ำหนักเป็นกิโล โดยที่คุณไม่เคยรู้ราคาล่วงหน้าเลยว่าสุดท้ายแล้วคุณต้องจ่ายเท่าไหร่ มายลอนดรี้ทำให้คุณมั่นใจได้ว่าคุณจะรู้ราคาที่ต้องชำระก่อนเราไปรับผ้าหรือรองเท้าของคุณ ทุกอย่างจึงง่ายเหมือนการสั่งอาหารหรือซื้อสินค้าออนไลน์ ตารางราคาด้านล่างระบุราคาที่ชัดเจนอย่างโปร่งใสทั้งบริการซักผ้าและทำความสะอาดรองเท้า รวมถึงรายละเอียดข้อมูลต่างๆ โดยคุณมีสิทธิ์ที่จะรู้",
};
export const TEXT_S_M_L_PRICING = {
  EN: "3 options - It`s your choice ",
  TH: "3 ตัวเลือก สำหรับคุณ",
};
export const TEXT_WATER_350_PRICING = {
  EN: "350 ml bottle",
  TH: "ขวด 350 มิลลิลิตร",
};
export const TEXT_DRINK_PRICING_DES = {
  EN: "We deliver 3 packs of 12 bottles (36 bottles)",
  TH: "เราส่งน้ำ 3 แพ็ก แพ็กละ 12 ขวด (36 ขวด)",
};
export const TEXT_DRINK_PRICING_DES_MB = {
  EN: "We deliver 3 packs of 12 bottles",
  TH: "เราส่งน้ำ 3 แพ็ก แพ็กละ 12 ขวด",
};
export const TEXT_DRINK_PRICING_DES_MB_2 = {
  EN: "(36 bottles)",
  TH: "(36 ขวด)",
};

export const TEXT_WATER_600_PRICING = {
  EN: "600 ml bottle",
  TH: "ขวด 600 มิลลิลิตร",
};
export const TEXT_DRINK_PRICING_DES_2 = {
  EN: "We deliver 3 packs of 12 bottles (36 bottles)",
  TH: "เราส่งน้ำ 3 แพ็ก แพ็กละ 12 ขวด (36 ขวด)",
};
export const TEXT_DRINK_PRICING_DES_2_MB = {
  EN: "We deliver 3 packs of 12 bottles",
  TH: "เราส่งน้ำ 3 แพ็ก แพ็กละ 12 ขวด",
};
export const TEXT_DRINK_PRICING_DES_2_MB_2 = {
  EN: "(36 bottles)",
  TH: "(36 ขวด)",
};
export const TEXT_WATER_1_5_PRICING = {
  EN: "1.5 l bottle",
  TH: "ขวด 1.5 ลิตร",
};
export const TEXT_DRINK_PRICING_DES_3 = {
  EN: "We deliver 3 packs of 6 bottles (18 bottles)",
  TH: "เราส่งน้ำ 3 แพ็ก แพ็กละ 6 ขวด (18 ขวด)",
};
export const TEXT_DRINK_PRICING_DES_3_MB = {
  EN: "We deliver 3 packs of 6 bottles",
  TH: "เราส่งน้ำ 3 แพ็ก แพ็กละ 6 ขวด",
};
export const TEXT_DRINK_PRICING_DES_3_MB_2 = {
  EN: "(18 bottles)",
  TH: "(18 ขวด)",
};

//BKK
export const TEXT_ALSO_AVAILABLE_IN_BKK = {
  EN: "Also available in Bangkok",
  TH: "ให้บริการในกรุงเทพด้วย",
};
export const TEXT_NEAR_YOU_IN_BKK = {
  EN: "Near You in Bangkok",
  TH: "บริการคุณในกรุงเทพ ",
};
export const TEXT_WE_PROVIDE_OUR_SERVICE_IN_BKK = {
  EN: "We provide our laundry service and shoe cleaning service in most areas of greater Bangkok, especially along the BTS and MRT lines. With Google Maps integrated into our system, you can simply search for your address by its name or choose it from the map, the same as doing it from Google Maps itself. The system will automatically detect whether your location is within our service area.",
  TH: "ร้านซักผ้าและทำความสะอาดรองเท้ามายลอนดรี้ให้บริการในพื้นที่ส่วนใหญ่ของกรุงเทพฯ โดยเฉพาะตามเส้นทางรถไฟฟ้า BTS และ MRT คุณสามารถค้นหาที่อยู่โดยพิมพ์ชื่อหรือเลือกจากแผนที่กูเกิ้ลในระบบของเรา เช่นเดียวกับการใช้กูเกิ้ลแมพ ระบบจะตรวจสอบโดยอัตโนมัติและยืนยันว่าตำแหน่งของคุณอยู่ในพื้นที่ให้บริการของเราหรือไม่",
};
export const TEXT_HOW_IT_WORKS_IN_BKK = {
  EN: "How it Works in Bangkok",
  TH: "ใช้งานอย่างไรในกรุงเทพ ",
};
export const TEXT_WHETHER_YOU_SELECT = {
  EN: "Whether you select",
  TH: "ไม่ว่าคุณจะเลือก",
};
export const TEXT_OUR_PROFSSIONAL_LAUNDRY_SERVICE = {
  EN: `our professional laundry service as well as our shoe cleaning service are fully customisable to meet all your requirements in a one-stop solution. Giving you the utmost flexibility and convenience, our services are as easy as ordering food or shopping online. We guarantee: All orders placed by ${LAST_TIME_YOU_STILL_CAN_BOOK}:00 will be picked up on the same day and returned by ${RETURN_TIME}:00 the next day - fast & easy! You want it faster? In Bangkok only - Activate our Same Day Express Service before ${TIME_THAT_STILL_SAME_DAY_SERVICE}:00 ${TIME_STRING_ENG}, and your items will be picked up and returned by ${RETURN_SAME_DAY}:00 on the same day.`,
  TH: `บริการซักผ้าและทำความสะอาดรองเท้าทั้งหมดของเราสามารถปรับเพิ่มตามความต้องการแบบครบวงจร สะดวกในการสั่งออเดอร์ รวดเร็วและง่ายเหมือนการสั่งอาหารหรือซื้อสินค้าออนไลน์ เรารับประกันว่าทุก
  ออเดอร์ที่สั่งภายใน ${LAST_TIME_YOU_STILL_CAN_BOOK}:00 น. เราจะไปรับในวันเดียวกันและส่งคืนภายใน ${RETURN_TIME}:00 น. ของวันถัดไป สะดวกและรวดเร็ว! เร็วกว่านี้ได้ไหม? เฉพาะในกรุงเทพฯ แค่เลือกบริการส่งคืนด่วนในวันเดียวกันก่อน ${TIME_THAT_STILL_SAME_DAY_SERVICE}:00 น. เราจะไปรับและส่งคืน
  ออเดอร์ภายใน ${RETURN_SAME_DAY}:00 น. ของวันเดียวกัน`,
};
export const TEXT_OUR_PROFESSINAL_LANDRY_SERVICE_2 = {
  EN: `our professional laundry service as well as our shoe cleaning service are fully customisable to meet all your requirements in a one-stop solution. Giving you the utmost flexibility and convenience, our services are as easy as ordering food or shopping online. We guarantee: All orders placed by ${LAST_TIME_YOU_STILL_CAN_BOOK}:00 will be picked up on the same day and returned by ${RETURN_TIME}:00 the next day - fast & easy! You want it faster? In Bangkok only - Activate our Same Day Express Service before ${TIME_THAT_STILL_SAME_DAY_SERVICE}:00 ${TIME_STRING_ENG}, and your items will be picked up and returned by ${RETURN_SAME_DAY}:00`,
  TH: `บริการซักผ้าและทำความสะอาดรองเท้าทั้งหมดของเราสามารถปรับเพิ่มตามความต้องการแบบครบวงจร สะดวกในการสั่งออเดอร์ รวดเร็วและง่ายเหมือนการสั่งอาหารหรือซื้อสินค้าออนไลน์ เรารับประกันว่าทุกออเดอร์ที่สั่งภายใน ${LAST_TIME_YOU_STILL_CAN_BOOK}:00 น. เราจะไปรับในวันเดียวกันและส่งคืนภายใน ${RETURN_TIME}:00 น. ของวันถัดไป สะดวกและรวดเร็ว! เร็วกว่านี้ได้ไหม? เฉพาะในกรุงเทพฯ แค่เลือกบริการส่งคืนด่วนในวันเดียวกันก่อน ${TIME_THAT_STILL_SAME_DAY_SERVICE}:00 น. เราจะไปรับและส่งคืนออเดอร์ภายใน ${RETURN_SAME_DAY}:00 น.`,
};
export const TEXT_OUR_PROFESSINAL_LANDRY_SERVICE_3 = {
  EN: `on the same day.`,
  TH: `ของวันเดียวกัน`,
};
export const TEXT_OUR_PROFSSIONAL_LAUNDRY_SERVICE_MB_DETAILS = {
  EN: `our professional laundry service as well as our shoe cleaning service are fully customisable to meet all your requirements in a one-stop solution. Giving you the utmost flexibility and convenience, our services are as easy as ordering food or shopping online. Our standard turnaround time is 24 hours. For example: If you have chosen the time-slot 14:00-16:00 for the Pick-Up of your order on Monday, then your order will be returned between 14:00-16:00 on Tuesday. We also offer a Same Day Express Laundry Service and Same Day Express Shoe Cleaning Service in Bangkok. The My Laundry Service is that easy.`,
  TH: `บริการซักผ้าและทำความสะอาดรองเท้าทั้งหมดของเราสามารถปรับเพิ่มตามความต้องการแบบครบวงจร สะดวกในการสั่งออเดอร์ รวดเร็วและง่ายเหมือนการสั่งอาหารหรือซื้อสินค้าออนไลน์ เรามีบริการรับส่งคืนผ้าแบบมาตรฐานภายใน 24 ชั่วโมง เช่น หากคุณเลือกเวลาไปรับออเดอร์วันจันทร์ 14:00-16:00 น. เราจะส่งคืนออเดอร์วันอังคาร 14:00-16:00 น. นอกจากนี้เรายังมีบริการส่งคืนด่วนในวันเดียวกันในกรุงเทพด้วย ซึ่งจะไปรับออเดอร์ในช่วงเวลา 10:00-12:00 น. และส่งคืนในช่วงเวลา 16:00-19:00 น.`,
};
export const TEXT_OUR_PROFESSINAL_LANDRY_SERVICE_MB = {
  EN: ``,
  TH: `ซึ่งจะไปรับออเดอร์ในช่วงเวลา 10:00-12:00 น.`,
};
export const TEXT_OUR_PROFESSINAL_LANDRY_SERVICE_MB_2 = {
  EN: ``,
  TH: `และส่งคืนในช่วงเวลา 16:00-19:00 น. ของวันเดียวกัน ร้านซักผ้ามายลอนดรี้ ทำให้คุณสะดวกและง่ายจริงๆ!`,
};
export const TEXT_LAUNDRY_SERVICE_BKK_HEAD = {
  EN: `Laundry Service Bangkok`,
  TH: `ร้านซักผ้ากรุงเทพ `,
};
export const TEXT_NO_SURPRIZE_BKK = {
  EN: `Our professional laundry service policy is Fixed Price – No Surprises. This is what sets us apart from other laundry service providers in Bangkok who charge you by weight so you never know in advance how much you will really pay in the end. At My Laundry, you can be confident that you know the`,
  TH: `ร้านซักผ้ามายลอนดรี้มีนโยบายคือ ราคาแน่นอน ให้คุณแน่ใจ สิ่งนี้ทำให้เราแตกต่างจากร้านซักผ้ารายอื่นๆ ในกรุงเทพ ที่เรียกเก็บเงินตามน้ำหนักเป็นกิโล โดยที่คุณไม่เคยรู้ราคาล่วงหน้าเลยว่าสุดท้ายแล้วคุณต้องจ่ายเท่าไหร่ มายลอนดรี้ทำให้คุณมั่นใจได้ว่าคุณจะรู้`,
};
export const TEXT_YES_RIGHT_HERE = {
  EN: `Yes, right here!`,
  TH: `ใช่ อยู่นี่ไง!`,
};
export const TEXT_MY_LAUNDRY = {
  EN: `My Laundry`,
  TH: `มายลอนดรี้`,
};
export const TEXT_IS_YOUR_PROFESSIONAL = {
  EN: `is your professional laundry service and shoe cleaning service in Bangkok. For your utmost convenience, we pick up your laundry and shoes at your home or hotel and return it to you in just 24 hours. You want it faster than that? Go for our Express Laundry Service and receive your items`,
  TH: `คือร้านซักผ้าและทำความสะอาดรองเท้าที่ให้บริการในกรุงเทพเพื่อให้คุณสะดวกมากที่สุด `,
};

export const TEXT_IS_YOUR_PROFESSIONAL2 = {
  EN: ``,
  TH: `มายลอนดรี้จะไปรับออเดอร์ที่บ้านหรือโรงแรมและส่งคืนภายใน 24 ชม. อยากให้เร็วกว่านี้ไหม ได้เลย ด้วยบริการส่งคืนด่วน`,
};

export const TEXT_IS_YOUR_PROFESSIONAL3 = {
  EN: `back on the same day.`,
  TH: `มายลอนดรี้จะไปรับออเดอร์และส่งคืนภายในวันเดียวกัน!`,
};

export const TEXT_MY_LAUNDRY_BACK_SAME_DAY = {
  EN: ` back on the same day!`,
  TH: ` มายลอนดรี้จะไปรับออเดอร์และส่งคืนภายในวันเดียวกัน!`,
};
export const TEXT_YOU_WILL_PAY = {
  EN: `you will pay for your laundry or shoes before we come to pick them up, as easy as ordering food or shopping online!`,
  TH: `ที่ต้องชำระก่อนเราไปรับผ้าหรือรองเท้าของคุณ ทุกอย่างจึงง่ายเหมือนการสั่งอาหารหรือซื้อสินค้าออนไลน์`,
};
export const TEXT_THE = {
  EN: `The`,
  TH: ``,
};
export const TEXT_HAVE_PACKAGES = {
  EN: ``,
  TH: `มี 3 แพ็กเกจ `,
};
export const TEXT_PACKAGES_OFFER_YOU = {
  EN: `Packages offer you three options when using our professional laundry service that includes the washing & folding of`,
  TH: `ให้คุณเลือก ซึ่งรวมการซักและพับผ้า`,
};
export const TEXT_PIECE = {
  EN: ``,
  TH: `ชิ้น`,
};
export const TEXT_ITEMS_OF_CLOTHING_TOWELS = {
  EN: " of clothing, towels, pillow cases and more at a fixed price – regardless of their combined weight – with no surprises. You can customise",
  TH: " สำหรับเสื้อผ้า ผ้าเช็ดตัว ปลอกหมอน และอื่นๆ ในราคาแน่นอน ให้คุณแน่ใจ โดยไม่คำนึงถึงน้ำหนักรวม คุณสามารถรวม",
};
export const TEXT_WITH_VARIOUS_ADD_ONS = {
  EN: "with various Add-Ons such as",
  TH: "กับตัวเลือกเพิ่มเติมอื่นๆ เช่น",
};
export const TEXT_IF_YOU_WISH_YOUR_ITEMS_MB = {
  EN: "if you wish your items to be ironed and we can also take care of your bedding items.",
  TH: "หากคุณต้องการให้เรารีดผ้าของคุณ นอกจากนี้เรายินดีดูแลเครื่องนอนของคุณด้วย หมายเหตุ ",
};
export const TEXT_IF_YOU_WISH_YOUR_ITEMS = {
  EN: "if you wish your items to be ironed and we can also take care of your bedding items.",
  TH: "หากคุณต้องการให้เรารีดผ้าของคุณ นอกจากนี้เรายินดีดูแลเครื่องนอนของคุณด้วย หมายเหตุ ถุงเท้า 1 คู่ เท่ากับ 1 ชิ้น ยุติธรรมและง่ายจริงๆ",
};
export const TEXT_IF_YOU_WISH_YOUR_ITEMS_BKK = {
  EN: "if you wish your items to be ironed and we can also take care of your bedding items. PS: 1 pair of socks is equal to 1 piece – fair and easy!",
  TH: "",
};
export const TEXT_PS_BKK = {
  EN: "",
  TH: "นอกจากนี้เรายินดีดูแลเครื่องนอนของคุณด้วย หมายเหตุ ถุงเท้า 1 คู่ เท่ากับ 1 ชิ้น ยุติธรรมและง่ายจริงๆ",
};
export const TEXT_PS_BKK_MB = {
  EN: "",
  TH: "ถุงเท้า 1 คู่ เท่ากับ 1 ชิ้น ยุติธรรมและง่ายจริงๆ",
};
export const TEXT_IF_YOU_WISH_YOUR_ITEMS2 = {
  EN: "if you wish your items to be ironed and we can also take care of your bedding items. PS: 1 pair of socks is equal to 1 piece – fair and easy!",
  TH: "หากคุณต้องการให้เรารีดผ้าของคุณ",
};
export const TEXT_GOOD_TO_KNOW = {
  EN: "Good to know: ",
  TH: "ข้อมูลน่ารู้",
};
export const TEXT_AFTERYOU_FIRST_ORDER_BKK = {
  EN: " After your first order, ",
  TH: " หลังจากสั่งออเดอร์ครั้งแรก คุณจะได้รับ",
};
export const TEXT_YOU_WILL_RECEIVE_EN = {
  EN: "you will receive our original",
  TH: "",
};
export const TEXT_YOU_WILL_RECEIVE = {
  EN: "My Laundry Bags for free. For all subsequent laundry orders, you don’t need to count the pieces anymore as",
  TH: "ถุงใส่ผ้ามายลอนดรี้ฟรี จากนั้นในการสั่งออเดอร์ครั้งต่อไป",
};
export const TEXT_YOU_CAN_JUST_FILL_UP = {
  EN: " you can just fill up the original My Laundry Bag until its full regardless of how many pieces are inside or how much it weighs ",
  TH: " คุณไม่จำเป็นต้องนับจำนวนผ้าว่ามีกี่ชิ้นหรือน้ำหนักเท่าไหร่ ",
};
export const TEXT_ASAP_CAN_STILL = {
  EN: " as long as you can still close the bag properly.",
  TH: "เพียงแค่คุณต้องปิดถุงใส่ผ้ามายลอนดรี้ให้เรียบร้อย",
};
export const TEXT_SHOES_CLEANING_BKK = {
  EN: "Shoe Cleaning Service Bangkok ",
  TH: "ร้านซักรองเท้ากรุงเทพ ",
};
export const TEXT_PAIRS = {
  EN: "pairs",
  TH: " คู่ ",
};
export const TEXT_PAIR = {
  EN: "pair",
  TH: " คู่ ",
};
export const TEXT_OFFER_YOU_TREE_SHOES = {
  EN: " offer you three options when you use our premium shoe cleaning service that includes the cleaning of",
  TH: " ให้คุณเลือก ซึ่งรวมการทำความสะอาดรองเท้า",
};
export const TEXT_PACKAGES = {
  EN: "Packages",
  TH: "",
};
export const TEXT_OF_SHOES_AT_A_FIXED = {
  EN: " of shoes at a fixed price and with no surprises. You can customise ",
  TH: " ในราคาแน่นอน ให้คุณแน่ใจ คุณสามารถรวม",
};
export const TEXT_FOR_ULTIMATE_SHOE_CLEANING = {
  EN: "for ultimate shoe cleaning results.",
  TH: "เพื่อผลลัพธ์ที่ดีที่สุดในการทำความสะอาดรองเท้า",
};
export const TEXT_AS_A_PREMIUM_SHOE_CLEANING_BKK = {
  EN: " As a premium shoe cleaning service we clean shoes of all colours and types, from sneakers to leather shoes, while we specialise in white sneakers made from leather or other modern fabrics.",
  TH: " ร้านซักรองเท้ามายลอนดรี้ทำความสะอาดรองเท้าทุกสีทุกประเภท ตั้งแต่รองเท้าผ้าใบไปจนถึงรองเท้าหนัง ",
};
export const TEXT_AS_PROFESSIONAL_SHOS_WASHING_BKK = {
  EN: "",
  TH: "เรายังเชี่ยวชาญในการซักรองเท้าผ้าใบสีขาวที่ทำจากหนังหรือวัสดุทันสมัย",
};
export const TEXT_HEY_DO_YOU_KNOW_BKK = {
  EN: "Do you have a laundry service near me in Bangkok?",
  TH: "คุณรู้จักร้านซักผ้าใกล้ฉันในกรุงเทพไหม?",
};
export const TEXT_CLEANING_SERVICE_IN_BKK = {
  EN: `is your professional laundry service and shoe cleaning service in Bangkok. We guarantee: All orders placed by ${LAST_TIME_YOU_STILL_CAN_BOOK}:00 will be picked up on the same day and returned by ${RETURN_TIME}:00 the next day - fast & easy! You want it faster? In Bangkok only - Activate our Same Day Express Service before ${TIME_THAT_STILL_SAME_DAY_SERVICE}:00 ${TIME_STRING_ENG}, and your items will be picked up and returned by ${RETURN_SAME_DAY}:00 on the same day.`,
  TH: ` คือร้านซักผ้าและทำความสะอาดรองเท้าที่ให้บริการในกรุงเทพ เรารับประกันว่าทุกออเดอร์ที่สั่งภายใน ${LAST_TIME_YOU_STILL_CAN_BOOK}:00 น. เราจะไปรับในวันเดียวกันและส่งคืนภายใน ${RETURN_TIME}:00 น. ของวันถัดไป สะดวกและรวดเร็ว! เร็วกว่านี้ได้ไหม? เฉพาะในกรุงเทพฯ แค่เลือกบริการส่งคืนด่วนในวันเดียวกันก่อน ${TIME_THAT_STILL_SAME_DAY_SERVICE}:00 น. เราจะไปรับและส่งคืน ออเดอร์ภายใน ${RETURN_SAME_DAY}:00 น. ของวันเดียวกัน`,
};
export const TEXT_CLEANING_SERVICE_IN_BKK_2 = {
  EN: `is your professional laundry service and shoe cleaning service in Bangkok. We guarantee: All orders placed by ${LAST_TIME_YOU_STILL_CAN_BOOK}:00 will be picked up on the same day and returned by ${RETURN_TIME}:00 the next day - fast & easy! You want it faster? In Bangkok only - Activate our Same Day Express Service before ${TIME_THAT_STILL_SAME_DAY_SERVICE}:00 ${TIME_STRING_ENG}, and your items will be picked up and returned by ${RETURN_SAME_DAY}:00`,
  TH: `คือร้านซักผ้าและทำความสะอาดรองเท้าที่ให้บริการในกรุงเทพ เรารับประกันว่าทุกออเดอร์ที่สั่งภายใน ${LAST_TIME_YOU_STILL_CAN_BOOK}:00 น. เราจะไปรับในวันเดียวกันและส่งคืนภายใน ${RETURN_TIME}:00 น. ของวันถัดไป สะดวกและรวดเร็ว! เร็วกว่านี้ได้ไหม? เฉพาะในกรุงเทพฯ แค่เลือกบริการส่งคืนด่วนในวันเดียวกันก่อน ${TIME_THAT_STILL_SAME_DAY_SERVICE}:00 น. เราจะไปรับและส่งคืน ออเดอร์ภายใน ${RETURN_SAME_DAY}:00 น. ของวันเดียวกัน`,
};
export const TEXT_CLEANING_SERVICE_IN_BKK_3 = {
  EN: `on the same day.`,
  TH: ``,
};

//PATTAYA
export const TEXT_ALSO_AVAILABLE_IN_PATTAYA = {
  EN: `Also available in Pattaya`,
  TH: `พร้อมให้บริการในพัทยาแล้ว`,
};
// export const TEXT_NEAR_YOU_IN_PTY = {
//   EN: `Near You in Pattaya`,
//   TH: `บริการคุณในพัทยา `,
// };
export const TEXT_NEAR_YOU_IN_PTY = {
  EN: `See you Soon in Pattaya`,
  TH: `พบกันเร็วๆ นี้ที่พัทยา`,
};
export const TEXT_OUR_PROFESSIONAL_LAUNDRY_PTY = {
  EN: `Our professional laundry service as well as our shoe cleaning service are available almost everywhere in Pattaya. This includes but is not limited to Na Kluea, Wong Amat, North, Central and South Pattaya and also extends over Pratumnak to the whole Jomtien area.`,
  TH: `ร้านซักผ้าและทำความสะอาดรองเท้ามายลอนดรี้ให้บริการในพื้นที่ส่วนใหญ่ของพัทยา ไม่ว่าจะเป็น นาเกลือ วงศ์อมาตย์ พัทยาเหนือ พัทยากลาง พัทยาใต้ ครอบคลุมไปถึงประทุมนาค ตลอดจนพื้นที่จอมเทียนทั้งหมดด้วย`,
};
export const TEXT_HOW_IT_WORK_PTY = {
  EN: `How it Works in Pattaya `,
  TH: `ใช้งานอย่างไรในพัทยา`,
};
export const TEXT_OUR_PROFESSIONAL_PTY = {
  EN: `our professional laundry service as well as our shoe cleaning service are fully customisable to meet all your requirements in a one-stop solution. Giving you the utmost flexibility and convenience, our services are as easy as ordering food or shopping online. We guarantee: All orders placed by ${LAST_TIME_YOU_STILL_CAN_BOOK}:00 will be picked up on the same day and returned by ${RETURN_TIME}:00 the next day - fast & easy!`,
  TH: `บริการซักผ้าและทำความสะอาดรองเท้าทั้งหมดของเราสามารถปรับเพิ่มตามความต้องการแบบครบวงจร สะดวกในการสั่งออเดอร์ รวดเร็วและง่ายเหมือนการสั่งอาหารหรือซื้อสินค้าออนไลน์ เรารับประกันว่าทุกออเดอร์ที่สั่งภายใน ${LAST_TIME_YOU_STILL_CAN_BOOK}:00 น. เราจะไปรับในวันเดียวกันและส่งคืนภายใน ${RETURN_TIME}:00 น. ของวันถัดไป สะดวกและรวดเร็ว!`,
};
export const TEXT_OUR_PROFESSIONAL_LAUNDRY_PTY_2 = {
  EN: `our professional laundry service as well as our shoe cleaning service are fully customisable to meet all your requirements in a one-stop solution. Giving you the utmost flexibility and convenience, our services are as easy as ordering food or shopping online. We guarantee: All orders placed by ${LAST_TIME_YOU_STILL_CAN_BOOK}:00 will be picked up on the same day and returned by ${RETURN_TIME}:00 the next day - fast & easy!`,
  TH: `บริการซักผ้าและทำความสะอาดรองเท้าทั้งหมดของเราสามารถปรับเพิ่มตามความต้องการแบบครบวงจร สะดวกในการสั่งออเดอร์ รวดเร็วและง่ายเหมือนการสั่งอาหารหรือซื้อสินค้าออนไลน์ เรารับประกันว่าทุกออเดอร์ที่สั่งภายใน ${LAST_TIME_YOU_STILL_CAN_BOOK}:00 น. เราจะไปรับในวันเดียวกันและส่งคืนภายใน ${RETURN_TIME}:00 น. ของวันถัดไป สะดวกและรวดเร็ว!`,
};
export const TEXT_OUR_PROFESSIONAL_LAUNDRY_PTY_3 = {
  TH: `ร้านซักผ้ามายลอนดรี้ทำให้คุณสะดวกและง่ายจริงๆ!`,
};
export const TEXT_OUR_PROFESSIONAL_LAUNDRY_BKK_3 = {
  TH: `ร้านซักผ้ามายลอนดรี้ทำให้คุณสะดวกและง่ายจริงๆ!`,
};
export const TEXT_LAUNDRY_SERVICE_PTY_HEAD = {
  EN: `Laundry Service Pattaya `,
  TH: `ร้านซักผ้าพัทยา `,
};
export const TEXT_NO_SURPRIZES_PTY = {
  EN: `Our professional laundry service policy is Fixed Price – No Surprises. This is what sets us apart from other laundry service providers in Pattaya who charge you by weight so you never know in advance how much you will really pay in the end. At My Laundry, you can be confident that you know the`,
  TH: `ร้านซักผ้ามายลอนดรี้มีนโยบายคือ ราคาแน่นอน ให้คุณแน่ใจ สิ่งนี้ทำให้เราแตกต่างจากร้านซักผ้ารายอื่นๆ ในพัทยา ที่เรียกเก็บเงินตามน้ำหนักเป็นกิโล โดยที่คุณไม่เคยรู้ราคาล่วงหน้าเลยว่าสุดท้ายแล้วคุณต้องจ่ายเท่าไหร่ มายลอนดรี้ทำให้คุณมั่นใจได้ว่าคุณจะรู้`,
};
export const TEXT_NO_SURPRIZES_BKK = {
  EN: `Our professional laundry service policy is Fixed Price – No Surprises. This is what sets us apart from other laundry service providers in Pattaya who charge you by weight so you never know in advance how much you will really pay in the end. At My Laundry, you can be confident that you know the`,
  TH: `ร้านซักผ้ามายลอนดรี้มีนโยบายคือ ราคาแน่นอน ให้คุณแน่ใจ สิ่งนี้ทำให้เราแตกต่างจากร้านซักผ้ารายอื่นๆ ในกรุงเทพ ที่เรียกเก็บเงินตามน้ำหนักเป็นกิโล โดยที่คุณไม่เคยรู้ราคาล่วงหน้าเลยว่าสุดท้ายแล้วคุณต้องจ่ายเท่าไหร่ มายลอนดรี้ทำให้คุณมั่นใจได้ว่าคุณจะรู้`,
};
export const TEXT_YOU_WILL_PAY_PTY = {
  EN: `you will pay for your laundry or shoes before we come to pick them up, as easy as ordering food or shopping online!`,
  TH: `ที่ต้องชำระก่อนเราไปรับผ้าหรือรองเท้าของคุณ ทุกอย่างจึงง่ายเหมือนการสั่งอาหารหรือซื้อสินค้าออนไลน์`,
};
export const TEXT_SHOES_CLEAINING_PTY = {
  EN: `Shoe Cleaning Service Pattaya `,
  TH: `ร้านซักรองเท้าพัทยา `,
};
export const TEXT_DO_YOU_KNOW_PTY = {
  EN: `Do you have a laundry service near me in Pattaya?`,
  TH: `คุณรู้จักร้านซักผ้าใกล้ฉันในพัทยาไหม?`,
};
export const TEXT_CLEANING_SERVICE_PTY = {
  EN: `is your professional laundry service and shoe cleaning service in Pattaya.`,
  TH: `คือร้านซักผ้าและทำความสะอาดรองเท้าที่ให้บริการในพัทยา เรารับประกันว่าทุกออเดอร์`,
};
export const TEXT_CLEANING_SERIVICE_PTY_2 = {
  EN: `We guarantee: All orders placed by ${LAST_TIME_YOU_STILL_CAN_BOOK}:00 will be picked up on the same day and returned by ${RETURN_TIME}:00 the next day - fast & easy!`,
  TH: `ที่สั่งภายใน ${LAST_TIME_YOU_STILL_CAN_BOOK}:00 น. เราจะไปรับในวันเดียวกันและส่งคืนภายใน ${RETURN_TIME}:00 น. ของวันถัดไป สะดวกและรวดเร็ว!`,
};
export const TEXT_CLEANING_SERVICE_PTY_MB = {
  EN: ` is your professional laundry service and shoe cleaning service `,
  TH: ` คือร้านซักผ้าและทำความสะอาดรองเท้าที่ให้บริการในพัทยา เพื่อให้คุณสะดวกมากที่สุด `,
};
export const TEXT_MY_LAUNDRY_AT_YOUR_HOME = {
  EN: ` For your utmost convenience, we pick up your laundry and shoes at your home or hotel`,
  TH: `มายลอนดรี้จะไปรับออเดอร์ที่บ้านหรือโรงแรม`,
};
export const TEXT_AND_RETURN_IN24 = {
  EN: `and return it to you in just 24 hours.`,
  TH: `และส่งคืนภายใน 24 ชม.`,
};
export const TEXT_MY_LAUNDRY_AT_YOUR_HOME_MB = {
  EN: `in Pattaya. For your utmost convenience, we pick up your laundry and shoes at your home or hotel `,
  TH: `มายลอนดรี้จะไปรับออเดอร์ที่บ้านหรือโรงแรม`,
};
//GOOGLE MAP
export const TEXT_LAUNDRY_SERVICE_FOOTER = {
  EN: ` Laundry Service `,
  TH: ` ร้านซักผ้า `,
};

export const TEXT_SHOES_CLEANING = {
  EN: ` Shoe Cleaning Service `,
  TH: ` ร้านซักรองเท้า `,
};

//GLOSSARY
export const TEXT_ALL = {
  EN: `General`,
  TH: `ทั้งหมด`,
};
export const TEXT_SPECIFIC_LAUNDRY = {
  EN: `Specific Laundry Service and Shoe Cleaning Service Terms `,
  TH: `คำศัพท์เฉพาะในบริการซักอบรีดและทำความสะอาดรองเท้า `,
};
export const TEXT_IN_ADDICTION_TO_MY_LAUNDRY = {
  EN: `In addition to My Laundry’s professional laundry service and shoe cleaning service standards, customers can select from a variety of Add-Ons and Extras to customise their laundry service and shoe cleaning service experience. This Glossary provides clear and simple definitions of the specific laundry service and shoe cleaning service terms which you will come across on our website. `,
  TH: `นอกจากมายลอนดรี้มีมาตรฐานบริการซักอบรีดและทำความสะอาดรองเท้าแบบมืออาชีพแล้ว ลูกค้าสามารถเลือกและเพิ่มตัวเลือกเพิ่มเติมต่างๆเพื่อปรับแต่งบริการซักอบรีดและทำความสะอาดรองเท้าตามความต้องการ อภิธานศัพท์นี้ให้คำจำกัดความที่ชัดเจนและเรียบง่ายในบริการซักอบรีดและทำความสะอาดรองเท้าบนเว็บไซต์ของเรา`,
};

export const TEXT_HAVE_MORE_QUESTION_GLOSSARY = {
  EN: ` In case you have any questions, you can always`,
  TH: ` หากมีคำถามอื่นๆ`,
};

//ABOUTUS
export const TEXT_LAUNDRY_SERVICE_BKK_AND_PTY = {
  EN: `Laundry Service Bangkok`, // – Laundry Service Pattaya
  TH: `ร้านซักผ้าและทำความสะอาดรองเท้าในกรุงเทพ `,
};
export const TEXT_THAI_SERVICE_GERMAN_INNOVATION = {
  EN: `Thai service. German innovation. Founded in Bangkok.`,
  TH: `บริการด้วยรอยยิ้มแบบไทย นวัตกรรมใหม่แบบเยอรมัน เริ่มต้นจากกรุงเทพ`,
};
export const TEXT_COMING_TO_OTHER = {
  EN: ` Coming to other cities and islands soon.`,
  TH: `ขยายต่อไปยังเมืองและเกาะต่างๆ เร็วๆนี้`,
};

export const TEXT_COMMITTED_TO_THE_ENVIRONMENT = {
  EN: `Committed to the environment`,
  TH: `ด้วยความมุ่งมั่นเพื่อสิ่งแวดล้อมที่ยั่งยืน`,
};

export const TEXT_WE = {
  EN: `We`,
  TH: `เรา`,
};
export const TEXT_REDUCE = {
  EN: " Reduce,",
  TH: " ลด",
};
export const TEXT_REUSE = {
  EN: " Reuse ",
  TH: " ใช้ซ้ำ",
};
export const TEXT_AND_GLOSSARY = {
  EN: "and",
  TH: " และ",
};
export const TEXT_RECYCLE = {
  EN: " Recycle. ",
  TH: " นำกลับมาใช้ใหม่ ",
};

export const TEXT_INSTEAD_OF_WRAPPING = {
  EN: "Instead of wrapping your laundry in multiple layers of non-recyclable plastic, we return it to you in our original My Laundry Bags whenever possible which you can reuse for your next order with us or for other things. We are committed to reducing the usage of plastic, non-eco friendly products and energy consumption at every step of our daily laundry service and shoe cleaning service operations. We highly recommend you try our Organic Wash as well! ",
  TH: "โดยใช้ถุงใส่ผ้ามายลอนดรี้แทนการห่อผ้าของคุณด้วยพลาสติกที่ไม่สามารถรีไซเคิลได้ ซึ่งคุณสามารถนำถุงใส่ผ้ามายลอนดรี้กลับมาใช้ใหม่ได้ในการสั่งออเดอร์ครั้งต่อไปหรือใช้ประโยชน์อื่นๆ เรามุ่งมั่นที่จะลดการใช้พลาสติก ผลิตภัณฑ์ที่ไม่เป็นมิตรต่อสิ่งแวดล้อม และยังคำนึงถึงการใช้พลังงานในทุกๆขั้นตอนการทำงานแต่ละวัน นอกจากนี้เราขอแนะนำให้คุณลองใช้บริการซักผ้าแบบออร์แกนิคด้วย ",
};
export const TEXT_DEDICATED = {
  EN: "Dedicated to Quality",
  TH: "ด้วยความพิถีพิถันในคุณภาพ ",
};
export const TEXT_OUR_TWO_PILLAR = {
  EN: "Our two pillars of quality include our ",
  TH: "เรามีสองสิ่งสำคัญที่เป็นคุณภาพหลัก ได้แก่",
};
export const TEXT_DEDICATED_TEAM = {
  EN: " dedicated laundry professionals and shoe cleaning team",
  TH: "ทีมซักรีดที่ทุ่มเทกายใจและเทคโนโลยีอันล้ำสมัยในการซักรีดเสื้อผ้าและทำความสะอาดรองเท้าให้คุณ",
};
export const TEXT_AND_THE_STATE = {
  EN: "and the state-of-the-art technology we use to wash and iron your laundry and clean your shoes. Another goal of both our quality laundry service and shoe cleaning service is to offer you the utmost level of customisation. We also offer a Same Day Express Laundry Service and Same Day Express Shoe Cleaning Service in Bangkok.",
  TH: "อีกหนึ่งเป้าหมายของมายลอนดรี้คือเราเสนอตัวเลือกให้คุณปรับเพิ่มตามความต้องการอย่างเต็มที่ นอกจากนี้เรายังมีบริการส่งคืนด่วนในวันเดียวกันเฉพาะในกรุงเทพด้วย",
};
export const TEXT_FIXED_PRICE_NO_SURPRIZE = {
  EN: "Fixed Price – No Surprises ",
  TH: "ราคาแน่นอน ให้คุณแน่ใจ",
};
export const TEXT_THIS_IS_NOT_JUST = {
  EN: "This is not just a slogan for us – it is the pricing concept we live by.",
  TH: "สิ่งนี้ไม่ได้เป็นเพียงสโลแกนของเราเท่านั้น แต่เป็นแนวคิดเรื่องราคาที่เรายึดถือมาโดยตลอด",
};

export const TEXT_THIS_IS_WHAT_SETS_US = {
  EN: "This is what sets us apart from other laundry service providers who charge you by weight so you never know in advance how much you will really pay in the end. As part of our premium laundry service and shoe cleaning service in Bangkok, we are here to change the laundry service in Thailand for good! At My Laundry, you can be confident that you know the price you will pay for your laundry or shoes before we come to pick them up, as easy as ordering food or shopping online!",
  TH: "ซึ่งทำให้เราแตกต่างจากร้านซักผ้ารายอื่นๆ ที่เรียกเก็บเงินตามน้ำหนักเป็นกิโล โดยที่คุณไม่เคยรู้ราคาล่วงหน้าเลยว่าสุดท้ายแล้วคุณต้องจ่ายเท่าไหร่ ร้านซักผ้าและทำความสะอาดรองเท้าของเราในกรุงเทพ เพื่อเปลี่ยนแปลงรูปแบบของร้านรับซักผ้าเดลิเวอร์รี่ให้ดีขึ้น! มายลอนดรี้ทำให้คุณมั่นใจได้ว่าคุณจะรู้ราคาที่ต้องชำระก่อนเราไปรับผ้าหรือรองเท้าของคุณ ทุกอย่างจึงง่ายเหมือนการสั่งอาหารหรือซื้อสินค้าออนไลน์",
};
export const TEXT_THANK_YOU_FOR_READING = {
  EN: "Thank you for reading and we hope to serve you soon!",
  TH: "ขอบคุณที่สละเวลาอ่านและเราหวังว่าจะได้ให้บริการคุณเร็วๆนี้!",
};

export const TEXT_GO_TO_BASKET = {
  EN: "Go to Basket",
  TH: "ไปที่ตะกร้า",
};

//TERM AND CONDITION
export const TEXT_MY_LAUNDRY_PROVIDE_TERM = {
  EN: `My Laundry provides professional laundry, ironing, shoe cleaning, and water delivery ("services") to our customers using our website`,
  TH: `My Laundry ให้บริการซักรีด รีดผ้า ทำความสะอาดรองเท้า และบริการจัดส่งน้ำอย่างมืออาชีพ ("บริการ") ให้แก่ลูกค้าโดยใช้เว็บไซต์`,
};
export const TEXT_WEBSITE_SEMIBOLD = {
  EN: `Website`,
  TH: `เว็บไซต์`,
};
export const TEXT_WEBSITE_INCLUDING_TERM = {
  EN: `, our accounts on social media (including, but not limited to Facebook, YouTube, Line, TikTok, Instagram, Twitter and Pinterest), or messenger apps (including but not limited to Line, WhatsApp, WeChat, Facebook Messenger, Telegram, Viber, Signal and Kakao Talk), `,
  TH: ` บัญชีบนโซเชียลมีเดียของเรา (รวมถึงแต่ไม่จำกัดเพียง Facebook , YouTube, Line, TikTok, Instagram, Twitter และ Pinterest) หรือแอป Messenger (รวมถึงแต่ไม่จำกัดเพียง Line, WhatsApp, WeChat, Facebook Messenger, Telegram, Viber, Signal และ Kakao Talk)`,
};
export const TEXT_INCLUDING_TERM = {
  EN: `(including but not limited to`,
  TH: `(รวมถึงแต่ไม่จำกัดเพียง`,
};
export const TEXT_OFFERING_QUALITY_TERM = {
  EN: "offering quality and convenience at an affordable price.",
  TH: "ด้วยคุณภาพและความสะดวกสบายในราคาย่อมเยา",
};
export const TEXT_THE_FOLLOWING_NEWLINE = {
  EN: `The following terms and conditions ("Terms") govern the use of our Services. By placing an order for our Services, you acknowledge and accept the Terms.`,
  TH: `ข้อกำหนดและเงื่อนไขต่อไปนี้ ("ข้อกำหนด") จะครอบคลุมการใช้บริการของเรา เมื่อสั่งบริการของเราจะถือว่าท่านรับทราบและยอมรับข้อกำหนด`,
};
export const TEXT_THE_FOLLOWINF_TERM = {
  EN: `References in these Terms to “we”, "our," "us" or "My Laundry" shall be taken to mean the My Laundry Company as a whole or the employees, agents, contractors of the My Laundry Company, a Sole Proprietorship of Sharunthal Vorakarnpreechavuth operating under the Commercial name of "My Laundry", having its registered address at 128/71 Soi Maensri, Khlong Maha Nak, Pom Prab Sattru Phai, Bangkok 10100, and the registration number of 1100800732810, having officially completed Commercial Registration on 9 March 2022 at Pom Prab Sattru Phai District. References to "you," "your," or "the Customer" shall be taken to mean you as a Customer and user of the Services. `,
  TH: `การอ้างอิงในข้อกำหนดเหล่านี้ว่า “เรา” “ของเรา” หรือ “My Laundry” จะหมายถึง My Laundry Company โดยรวม หรือพนักงาน ตัวแทน ผู้รับจ้างของ My Laundry Company ซึ่งเป็นกิจการเจ้าของคนเดียวโดยฌรัลย์ธาร วรการปรีชาวุฒิ ดำเนินธุรกิจโดยใช้ชื่อทางการค้าว่า “My Laundry” ที่อยู่จดทะเบียน 128/71 ซอยแม้นศรี แขวงคลองมหานาค เขตป้อมปราบศัตรูพ่าย กรุงเทพฯ 10100 เลขทะเบียนที่ 1100800732810 ได้จดทะเบียนการค้าอย่างเป็นทางการเมื่อวันที่ 9 มีนาคม 2565 ที่เขตป้อมปราบศัตรูพ่าย การอ้างอิงว่า "ท่าน" "ของท่าน" หรือ "ลูกค้า" จะหมายถึงท่านในฐานะลูกค้าและผู้ใช้บริการ `,
};
export const TEXT_THESE_TERMS = {
  EN: "These Terms apply solely in relation to interactions between the Customer and My Laundry and do not in any way constitute or imply any relationship with any other parties. As a condition to using any of My Laundry's Services, and for the mutual benefit of both the Customer and My Laundry, the Customer agrees to the following terms and conditions as follows: ",
  TH: "ข้อกำหนดเหล่านี้ใช้เฉพาะในส่วนที่เกี่ยวข้องกับความสัมพันธ์ระหว่างลูกค้ากับ My Laundry เท่านั้น และไม่ก่อให้เกิดหรือแสดงถึงความสัมพันธ์ใดๆ กับบุคคลอื่น ตามเงื่อนไขในการใช้บริการใดๆ ของ My Laundry และเพื่อประโยชน์ร่วมกันของทั้งลูกค้าและ My Laundry ลูกค้าตกลงตามข้อกำหนดและเงื่อนไขดังต่อไปนี้: ",
};

export const TEXT_CUSTOMER_ACCOUNT_TERM = {
  EN: "Customer Account",
  TH: "บัญชีลูกค้า",
};
export const TEXT_COLLECTION_AND_RETURN = {
  EN: "Collection and Return",
  TH: "การรับและจัดส่ง ",
};

export const TEXT_IN_ORDER_TERM = {
  EN: `In order to access the Services, the Customer must register and maintain an active personal user Services account`,
  TH: `ในการเข้าถึงบริการ ลูกค้าจะต้องลงทะเบียนและรักษาบัญชีบริการของผู้ใช้ส่วนบุคคลที่ใช้งานอยู่`,
};
export const TEXT_ACOUNT_BOLD_TERM = {
  EN: `Account`,
  TH: `บัญชี`,
};
export const TEXT_IN_ORDER_TERM_2 = {
  EN: "Account registration requires the Customer to submit her/his personal information, such as name, address, phone number and email.",
  TH: `ในการลงทะเบียนบัญชี ลูกค้าจะต้องส่งข้อมูลส่วนบุคคล เช่น ชื่อ ที่อยู่ หมายเลขโทรศัพท์ และอีเมล`,
};
export const TEXT_THE_CUSTOMER_AGREES_TERM = {
  EN: "The Customer agrees to maintain accurate, complete, and up-to-date information in her/his Account. Any failure to maintain accurate, complete, and up-to-date Account information, including having an invalid or expired debit or credit card on file, may result in an inability to access and use the Services or My Laundry's termination of this Agreement. The Customer is responsible for all activity under her/his Account and agrees to ",
  TH: "ลูกค้าตกลงที่จะให้ข้อมูลที่ถูกต้อง สมบูรณ์ และเป็นปัจจุบันในบัญชี หากไม่ให้ข้อมูลบัญชีที่ถูกต้อง สมบูรณ์ และเป็นปัจจุบัน รวมถึงการมีบัตรเดบิตหรือบัตรเครดิตที่ไม่ถูกต้องหรือหมดอายุ อาจส่งผลให้ไม่สามารถเข้าถึงและใช้บริการ หรือทำให้ข้อตกลงกับ My Laundry สิ้นสุดลง ลูกค้ามีหน้าที่รับผิดชอบต่อการดำเนินงานทั้งหมดในบัญชีของตนเอง ",
};
export const TEXT_THE_MAINTAIN_TERM = {
  EN: "maintain the security and secrecy of her/his Account username and password at all times.",
  TH: "และตกลงที่จะรักษาความปลอดภัยและความลับของชื่อผู้ใช้และรหัสผ่านของบัญชีของตนเองตลอดเวลา",
};
export const TEXT_THE_CUSTOMER_SHALL_TERM = {
  EN: " The Customer shall register one Account only unless given written permission from My Laundry to do otherwise.",
  TH: " ลูกค้าจะต้องลงทะเบียนเพียงบัญชีเดียวเท่านั้น เว้นแต่จะได้รับอนุญาตเป็นลายลักษณ์อักษรจาก My Laundry เป็นอย่างอื่น",
};
export const TEXT_TERM_1_3 = {
  EN: `My Laundry respects the privacy of our Customers and shall comply with the Persona Data Protection Act B.E. 2562 (2019) including the regulations and announcements thereof (“Laws”). My Laundry has provided a Privacy Notice for our Customers regarding the legal requirements and our compliance therewith to ensure that`,
  TH: `My Laundry เคารพความเป็นส่วนตัวของลูกค้า และจะปฏิบัติตามพระราชบัญญัติคุ้มครองข้อมูลส่วนบุคคล พ.ศ. 2562 รวมถึงระเบียบและประกาศดังกล่าว (“กฎหมาย”) My Laundry ได้จัดทำประกาศความเป็นส่วนตัวสำหรับลูกค้าเกี่ยวกับข้อกำหนดและการปฏิบัติตามกฎหมาย เพื่อรับรองว่าข้อมูลส่วนบุคคลของลูกค้า`,
};
export const TEXT_ALLTHE_TERM = {
  EN: "all of",
  TH: "ทั้งหมด",
};
export const TEXT_TERM_1_3_1 = {
  EN: " the Customers’ personal data submitted to us as stated in Clause 1.1 above shall be protected by Laws. You can find more details of ",
  TH: " เพื่อรับรองว่าข้อมูลส่วนบุคคลของลูกค้าทั้งหมดที่ส่งให้เราตามที่ระบุไว้ในข้อ 1.1 ข้างต้นจะได้รับการคุ้มครองตามกฎหมาย ท่านสามารถดูรายละเอียดเพิ่มเติม",
};
export const TEXT_SUCH_TERM = {
  EN: "such",
  TH: "ของ",
};
export const TEXT_TERM_1_3_2 = {
  EN: "Privacy Notice in the document attached hereto.",
  TH: "ของประกาศความเป็นส่วนตัวดังกล่าวได้ในเอกสารที่แนบมาพร้อมกันนี้ ",
};
export const TEXT_SUITABILITY_TERM = {
  EN: "Suitability for Laundry Services",
  TH: "ความเหมาะสมในการใช้บริการซักรีด ",
};
export const TEXT_BY_USING_TERM = {
  EN: "By using our Services, you confirm that your clothes are suitable to be washed in water on a normal cycle, and dried using heat in a tumble dryer. My Laundry shall not be responsible for any damage to clothing resulting from its unsuitability for this standard laundering process. Similarly, we reserve the right to refuse to service items that we feel will be hazardous to our staff, such as items heavily soiled with human or animal waste.",
  TH: "เมื่อใช้บริการของเรา ท่านยืนยันว่าเสื้อผ้าของท่านเหมาะสมที่จะซักในน้ำตามรอบปกติ และอบแห้งโดยใช้ความร้อนในเครื่องอบผ้า My Laundry จะไม่รับผิดชอบต่อความเสียหายใดๆ ต่อเสื้อผ้าอันเป็นผลมาจากความไม่เหมาะสมในกระบวนการซักมาตรฐาน ในทำนองเดียวกัน เราขอสงวนสิทธิในการปฏิเสธที่จะให้บริการสิ่งที่อาจจะเป็นอันตรายต่อพนักงาน เช่น สิ่งที่เปรอะเปื้อนมากด้วยของเสียจากมนุษย์หรือสัตว์",
};
export const TEXT_ORDER_PROCESS_TERM = {
  EN: "Order Process",
  TH: "ขั้นตอนการสั่งบริการ ",
};
export const TEXT_TERM_3_1 = {
  EN: "My Laundry provides four types of services as follows:",
  TH: "My Laundry ให้บริการสี่ประเภทดังนี้:",
};
export const TEXT_TERM_3_3_1 = {
  EN: "Wash & Fold: The Wash & Fold Service includes the washing and folding of clothes, towels, pillowcases and more. The Customer can customize the service with various add-on options. Wash & Fold comes with five fixed-price packages for up to 20, 30, 40, 50 or 60 items per order.",
  TH: "ซัก-พับ: บริการซัก-พับประกอบด้วยการซักและพับเสื้อผ้า ผ้าเช็ดตัว ปลอกหมอน และอื่นๆ ลูกค้าสามารถปรับเปลี่ยนบริการด้วยตัวเลือกเสริมต่างๆ บริการซัก-พับมีแพ็คเกจห้าราคา สำหรับผ้ามากถึง 20, 30, 40, 50 หรือ 60 ชิ้น ต่อหนึ่งออเดอร์ ",
};
export const TEXT_TERM_3_3_2 = {
  EN: "Iron Only: The Iron Only Service includes the ironing of clothes, towels, pillowcases and more. The Customer can customize the service with various add-on options. Iron Only comes with five fixed-price packages for up to 15, 20, 30, 40 or 50 items per order.",
  TH: "รีดเท่านั้น: บริการรีดเท่านั้นประกอบด้วยการรีดเสื้อผ้า ผ้าเช็ดตัว ปลอกหมอน และอื่นๆ ลูกค้าสามารถปรับเปลี่ยนบริการด้วยตัวเลือกเสริมต่างๆ บริการรีดเท่านั้นมีแพ็คเกจห้าราคา: สำหรับผ้ามากถึง 15, 20, 30, 40 หรือ 50 ชิ้น ต่อหนึ่งออเดอร์",
};
export const TEXT_TERM_3_3_3 = {
  EN: "Shoe Cleaning: The Shoe Cleaning Service includes the cleaning of shoes of all colors and types, from sneakers to leather shoes. The Customer can customize the service with various add-on options. Shoe Cleaning comes with three fixed-price packages, for one, two or three pairs of shoes per order.",
  TH: "ซักรองเท้า: บริการซักรองเท้าประกอบด้วยการทำความสะอาดรองเท้าทุกสีและทุกประเภท ตั้งแต่รองเท้าผ้าใบจนถึงรองเท้าหนัง ลูกค้าสามารถปรับเปลี่ยนบริการด้วยตัวเลือกเสริมต่างๆ บริการซักรองเท้ามีแพ็คเกจสามราคา สำหรับรองเท้าหนึ่งคู่ สองคู่หรือสามคู่ต่อหนึ่งออเดอร์",
};
export const TEXT_TERM_3_3_4 = {
  EN: "Water Delivery: Each time you book our professional laundry service or shoe cleaning service, you now also have the option of ordering our family-owned Finn Drinking Water to be delivered to your doorstep when we pick up your order. Each order is limited to a total of 3 packs of one bottle size due to the capacity limitations of our delivery boxes.",
  TH: "บริการจัดส่งน้ำดื่ม: เมื่อท่านสั่งบริการซักรีดหรือบริการทำความสะอาดรองเท้าอย่างมืออาชีพของเรา ท่านสามารถสั่งน้ำดื่มฟินส่งตรงถึงหน้าประตูบ้านของท่านเมื่อส่งคืนออเดอร์ ซึ่งออเดอร์แต่ละครั้งจะจำกัดจำนวน 3 แพ็คโดยมีขวดขนาดเดียว เนื่องจากข้อจำกัดด้านความจุของกล่องจัดส่ง",
};
export const TEXT_CUSTOMER_SHALL = {
  EN: "The Customer shall select a service of choice.",
  TH: "ลูกค้าสามารถเลือกบริการตามความต้องการ",
};
export const TEXT_WHEN_MAKING_YOUR_FIRST_TERM = {
  EN: "When making your first order, you can submit your laundry in any suitable bag. After the first order, My Laundry will provide each Customer with a free laundry bag for their laundry items ",
  TH: "เมื่อทำการสั่งบริการครั้งแรก ท่านสามารถส่งผ้าของท่านใส่ในถุงที่เหมาะสม หลังจากการสั่งบริการครั้งแรก My Laundry จะมอบถุงใส่ผ้าฟรีเพื่อให้ลูกค้าใส่ผ้าซักรีดครั้งต่อไป  ",
};
export const TEXT_IF_OU_USE_TERM = {
  EN: " If you use a My Laundry Bag for your orders, the number of items is not counted. You can fill the bag to the top ",
  TH: " หากใช้ถุงซักรีดในการสั่งบริการ จะไม่มีการนับจำนวนชิ้น ",
};
export const TEXT_AS_LONG_AS = {
  EN: "as long as",
  TH: "ท่านสามารถบรรจุผ้าจนเต็มถุงใส่ผ้า",
};
export const TEXT_THE_BAG_CAN_STILL_BE_TERM = {
  EN: " the bag can still be closed properly. If you use any other bag for your laundry orders, you can put in no more than 20 pieces. Extra pieces will be charged accordingly (S, M and L packages allow up to 20, 40, and 60 pieces, respectively).",
  TH: " โดยที่สามารถปิดให้เรียบร้อย หากใช้ถุงอื่นในการสั่งซักรีด ท่านสามารถบรรจุได้ไม่เกิน 20 ชิ้น หากเกินจำนวนก็จะคิดค่าบริการตามจริง (แพ็คเกจ S, M และ L จำนวนสูงสุด 20, 40 และ 60 ชิ้น) ",
};
export const TEXT_TERM_3_3_3_1 = {
  EN: "Non-washable items,",
  TH: "สิ่งที่ไม่สามารถซักได้",
};

export const TEXT_TERM_3_3_3_2 = {
  EN: "Items that are labeled for hand washing and/or dry cleaning only and/or not for tumble drying,",
  TH: "สิ่งที่มีป้ายกำกับให้ซักมือและ/หรือซักแห้งเท่านั้น และ/หรือห้ามปั่นแห้ง",
};
export const TEXT_TERM_3_3_3_3 = {
  EN: "Any other items not suitable for laundering or ironing.",
  TH: "สิ่งใดๆ ที่ไม่เหมาะในการซักหรือรีด",
};

export const TEXT_TERM_3_3_3_4 = {
  EN: "Large-sized/formatted outer/winter jackets, coats and similar items.",
  TH: "เสื้อหรือผ้าขนาดใหญ่ เสื้อแจ็กเก็ตกันหนาว เสื้อโค้ท เสื้อขนสัตว์ เสื้อไหมพรม หรือสิ่งอื่นที่มีลักษณะเดียวกัน",
};

export const TEXT_TERM_3_3 = {
  EN: "You agree not to include any of the following items inside any laundry bags submitted to My Laundry as part of a service order:",
  TH: "ท่านจะต้องไม่บรรจุสิ่งใดๆ ต่อไปนี้ไว้ในถุงใส่ผ้าที่ส่งให้แก่ My Laundry เมื่อสั่งบริการ:",
};
export const TEXT_YOU_ARE_RESPONSIBLE_FOR = {
  EN: "You are responsible for any damage caused by any item (including, but not limited to, pens, tissues, coins, etc.) left in your laundry or in a My Laundry Bag that causes damage to your clothing, our cleaning machines, or any other property of My Laundry or its Customers. My Laundry shall not be responsible for, and shall bear no financial liability for, any loss, damage, or theft of items left unattended by the Customer during collection or delivery. Specifically, My Laundry shall not be liable for: (i) any damage to buttons, zips, plastic poppers, and other similar parts that become damaged during the My Laundry process; or (ii) any damage to garments that require repair before being put through the My Laundry process.",
  TH: "ท่านจะต้องรับผิดชอบต่อความเสียหายที่เกิดจากสิ่งใดๆ (รวมถึงแต่ไม่จำกัดเพียงปากกา ทิชชู่ เหรียญ ฯลฯ) ที่คงอยู่ในการซักผ้าของท่านหรือในถุงใส่ผ้า ซึ่งทำให้เกิดความเสียหายแก่เสื้อผ้าของท่าน เครื่องทำความสะอาดของเรา หรือทรัพย์สินอื่นใดของ My Laundry หรือของลูกค้า My Laundry จะไม่รับผิดชอบและไม่ต้องรับผิดทางการเงินต่อการสูญหาย ความเสียหาย หรือการลักทรัพย์สิ่งของที่ลูกค้าทิ้งไว้ในระหว่างการรับหรือจัดส่ง อีกทั้ง My Laundry จะไม่รับผิดชอบต่อ (1) ความเสียหายใดๆ ต่อกระดุม ซิป แป้นพลาสติก และชิ้นส่วนที่คล้ายคลึงกันอื่นๆ ที่ได้รับความเสียหายในระหว่างขั้นตอนการซักรีดของ My Laundry หรือ (2) ความเสียหายต่อเสื้อผ้าที่ต้องซ่อมแซมก่อนส่งเข้าขั้นตอนการซักรีดของ My Laundry",
};
export const TEXT_THE_CUSTOMER_CAN_PLACE = {
  EN: "The Customer can place an order through our website or application. We will collect your laundry and/or shoes at your designated address and return them to the same place within 24 hours or sooner if you choose our Same Day Express Service.",
  TH: "ลูกค้าสามารถสั่งบริการผ่านทางเว็บไซต์หรือแอปพลิเคชัน เราจะรับผ้าและ/หรือรองเท้าของท่านตามที่อยู่ที่ระบุและส่งคืนที่เดียวกันภายใน 24 ชั่วโมงหรือเร็วกว่านั้นหากเลือกบริการแบบวันเดียว",
};
export const TEXT_IRONING_TERM = {
  EN: "Ironing",
  TH: "การรีด ",
};
export const TEXT_TERM_5_5_1 = {
  EN: "The Customer must provide items in a washed state. Items that have not been washed will not be ironed.",
  TH: "ลูกค้าจะต้องจัดเตรียมสิ่งที่ต้องการให้ซักทำความสะอาด โดยจะไม่บริการรีดหากยังไม่ได้ซักสะอาด",
};
export const TEXT_TERM_5_5_2 = {
  EN: "The Customer agrees not to send (a) non-iron items, (b) items that are labeled for dry-cleaning only, or (c) any other items not suitable for ironing.",
  TH: "ลูกค้าตกลงว่าจะไม่ส่ง (ก) สิ่งที่รีดไม่ได้ (ข) สิ่งที่มีป้ายกำกับสำหรับซักแห้งเท่านั้น หรือ (ค) สิ่งอื่นๆ ที่ไม่เหมาะในการรีด",
};
export const TEXT_TERM_5_5_3 = {
  EN: "My Laundry does not accept any liability for damage caused by ironing items that do not come with care instructions according to Clause 5.2 or for items not treated per the care labels or other instructions provided. My Laundry reserves the right to refuse to iron any item.",
  TH: "My Laundry จะไม่รับผิดต่อความเสียหายที่เกิดจากการรีดผ้าที่ไม่มีคำแนะนำในการดูแลตามข้อ 5.2 หรือสิ่งที่ไม่ได้รับการดูแลตามป้ายกำกับหรือคำแนะนำที่ระบุอื่นๆ My Laundry ขอสงวนสิทธิในการปฏิเสธบริการรีดผ้าใดๆ ก็ได้",
};
export const TEXT_TERM_5_5_4 = {
  EN: "The Customer must provide clear instructions in writing via the Special Request box before placing the order if some garments or items require special care, for example, no creases in trousers, all items to be ironed on reverse, special folding required, no creases in shirt sleeves, etc. If no instructions are provided, My Laundry will complete the ironing in accordance with its normal practice.",
  TH: "ลูกค้าจะต้องระบุคำแนะนำที่ชัดเจนเป็นลายลักษณ์อักษรในช่องความต้องการพิเศษก่อนสั่งบริการ หากเสื้อผ้าหรือสิ่งนั้นต้องการให้ดูแลเป็นพิเศษ เช่น ไม่จับจีบกางเกง ผ้าทุกชิ้นต้องรีดจากด้านใน ต้องพับแบบพิเศษ ไม่จับจีบแขนเสื้อ ฯลฯ หากไม่ระบุคำแนะนำ My Laundry จะรีดผ้าตามวิธีปฏิบัติปกติ",
};
export const TEXT_SHOES_CLEANING_TERM = {
  EN: "Shoe cleaning",
  TH: "การทำความสะอาดรองเท้า ",
};
export const TEXT_TERM_6 = {
  EN: "My Laundry takes the utmost care to ensure all shoes are cleaned in accordance with standard practices and therefore does not accept any liability for any damage to shoes submitted for our shoe cleaning Service, such as the stiffening of shoe skins, skins becoming brittle, the forming of wrinkles during the drying process, and any other unforeseen occurrence in the course of the process.",
  TH: "My Laundry จะใช้ความระมัดระวังสูงสุดเพื่อให้รองเท้าทุกคู่ได้รับการทำความสะอาดตามวิธีมาตรฐาน และจะไม่รับผิดชอบต่อความเสียหายใดๆ ต่อรองเท้าที่ส่งเพื่อบริการทำความสะอาดรองเท้า เช่น หนังรองเท้าแข็ง หนังเปราะ การเกิดรอยย่นระหว่างขั้นตอนการทำให้แห้ง และเหตุการณ์ที่คาดไม่ถึงอื่นๆ ในระหว่างกระบวนการซัก",
};
export const TEXT_LIABILITY_TERM = {
  EN: "Liability limitation",
  TH: "ข้อจำกัดความรับผิด ",
};
export const TEXT_TERM_7_7_1 = {
  EN: "By purchasing our Services, the Customer agrees that there is a risk of loss or damage to their property at all times. Any claims and reimbursements must be made according to My Laundry's policies.",
  TH: "เมื่อสั่งซื้อบริการของเรา ลูกค้ายอมรับว่าอาจเกิดความเสี่ยงในการสูญหายหรือเสียหายต่อทรัพย์สินได้ตลอดเวลา การเรียกร้องและการชำระเงินคืนจะต้องเป็นไปตามนโยบายของ My Laundry",
};
export const TEXT_TERM_7_7_2_MY_LAUNDRY_TO_PROCESS = {
  EN: "My Laundry endeavors to process every item entrusted to us using the methods, chemicals, and temperatures that, in our professional opinion, are best suited to the nature and condition of each item. We will use all reasonable efforts to ensure that our cleaning Services maintain a",
  TH: "My Laundry มุ่งมั่นจะให้บริการทุกรายการตามที่ได้รับมอบหมายโดยใช้วิธีการ สารเคมี และอุณหภูมิที่เหมาะสมที่สุดตามลักษณะและสภาพของวัสดุตามความเห็นในวิชาชีพ เราจะใช้ความพยายามที่เหมาะสมอย่างเต็มที่เพื่อให้บริการทำความสะอาดของเรามีมาตรฐาน",
};
export const TEXT_HIGH_QULITY = {
  EN: " high quality ",
  TH: " คุณภาพสูง",
};
export const TEXT_TERM_7_7_2_STANDARDS = {
  EN: "standards. However, we shall not assume any responsibility for any color loss, color fade, color transfer, discoloration, or shrinkage (out of unpredictable shape) caused during the Service delivery process.",
  TH: "อย่างไรก็ตาม เราจะไม่รับผิดชอบใดๆ ต่อการที่สีซีด สีจาง สีตก สีเปลี่ยน หรือการหดตัว (รูปร่างที่ไม่ได้คาดการณ์) ที่เกิดขึ้นในระหว่างขั้นตอนการให้บริการ",
};
export const TEXT_TERM_7_7_3 = {
  EN: "My Laundry will not be liable for any damages incurred before our Service is rendered. The Customer must notify My Laundry or its employees about any defect.",
  TH: "My Laundry จะไม่รับผิดชอบต่อความเสียหายใดๆ ที่เกิดขึ้นก่อนการให้บริการของเรา ลูกค้าจะต้องแจ้ง My Laundry หรือพนักงานให้ทราบเกี่ยวกับข้อบกพร่องใดๆ",
};
export const TEXT_TERM_7_7_4 = {
  EN: "My Laundry does not guarantee the complete removal of all stains; however, upon special request, we can make every reasonable effort to remove the stain – which will be done at the Customer's own risk – and we will not be liable for any damages incurred ",
  TH: "My Laundry ไม่อาจรับประกันว่าจะขจัดคราบทั้งหมดได้อย่างสมบูรณ์ อย่างไรก็ตาม เมื่อมีการร้องขอเป็นพิเศษ เราจะพยายามทุกวิถีทางตามสมควรเพื่อขจัดคราบ ซึ่งจะดำเนินการโดยความเสี่ยงของลูกค้า และเราจะไม่รับผิดชอบต่อความเสียหายใดๆ ที่เกิดขึ้นอันเป็นผลมาจากความพยายามดังกล่าว",
};
export const TEXT_AS_A_RESULT_TERM = {
  EN: "as a result of",
  TH: "เป็นผลมาจาก",
};
export const TEXT_TERM_7_7_4_2 = {
  EN: " such efforts.",
  TH: " ความพยายามดังกล่าว",
};
export const TEXT_TERM_7_7_5 = {
  EN: "If My Laundry has any concerns regarding the colorfastness, age and/or weakness of an item, we will contact you to obtain your approval before caring for the item. If we are unable to get your authorization promptly, we may return the whole order (the full bag) without cleaning any items together with a full refund.",
  TH: "หาก My Laundry มีข้อกังวลใดๆ เกี่ยวกับความคงทนของสี อายุ และ/หรือจุดอ่อนของวัสดุ เราจะติดต่อท่านเพื่อขออนุมัติก่อนที่จะทำความสะอาด หากไม่สามารถขออนุมัติจากท่านได้ทันท่วงที เราอาจส่งคืนทั้งหมด (เต็มถุง) โดยไม่ทำความสะอาดใดๆ พร้อมคืนเงินเต็มจำนวน ",
};
export const TEXT_TERM_7_7_6 = {
  EN: "My Laundry limits our liability (including misplaced or damaged items) in all cases to the cost of the actual damage but not exceeding the paid service fee, except for damage incurred willfully or ",
  TH: "My Laundry จะจำกัดความรับผิด (รวมถึงรายการที่เสียหายหรือไม่พบ) ในทุกกรณีตามค่าเสียหายจริง แต่ไม่เกินค่าบริการที่ชำระ ยกเว้นความเสียหายที่เกิดขึ้นโดยจงใจหรือ",
};
export const TEXT_AS_A_RESULT_TERM_2 = {
  EN: "as a result of",
  TH: "เป็นผลจาก",
};
export const TEXT_TERM_7_7_6_2 = {
  EN: " gross negligence.",
  TH: "ความประมาทเลินเล่ออย่างร้ายแรง",
};
export const TEXT_TERM_7_7_7 = {
  EN: "My Laundry accepts no liability for any loss or damage of the articles or items arising due to an incident beyond My Laundry’s control, including but not limited to fire, burglary, or any other similar unforeseen causes, resulting in any loss, damage, or delay due to force majeure conditions.",
  TH: "My Laundry จะไม่รับผิดชอบต่อความสูญเสียหรือความเสียหายของสิ่งของหรือวัสดุใดๆ ที่เกิดขึ้นเนื่องจากเหตุการณ์ที่อยู่นอกเหนือการควบคุมของ My Laundry รวมถึงแต่ไม่จำกัดเฉพาะอัคคีภัย การลักทรัพย์ หรือเหตุไม่คาดคิดอื่นๆ ที่คล้ายคลึงกัน ซึ่งส่งผลให้เกิดการสูญหาย ความเสียหาย หรือความล่าช้าเนื่องจากเหตุสุดวิสัย",
};
export const TEXT_TERM_8 = {
  EN: "Damaged Items",
  TH: "รายการที่เสียหาย ",
};
export const TEXT_TERM_8_1 = {
  EN: "While we treat all garments with extreme care, we cannot guarantee against color loss, bleeding, or shrinkage of garments.",
  TH: "แม้ว่าเราจะดูแลรักษาผ้าทุกชิ้นด้วยความระมัดระวังเป็นพิเศษ แต่ไม่สามารถรับประกันได้ว่าจะไม่มีสีซีด สีตก หรือการหดตัวของเสื้อผ้า",
};
export const TEXT_TERM_8_2 = {
  EN: "My Laundry shall not be responsible for: a) normal wear and tear, ironing marks due to repeated ironing, etc.; b) any damage caused by the normal washing process (including but not limited to color runs, tears, etc.) to items such as curtain, sofa covers, shirts, blouses, dresses, suits, jackets, etc.; or c) any damage such as small holes or tears in garments which were already deteriorated or flawed. For any items deemed damaged, My Laundry will in appropriate cases reimburse the Customer for the actual damage but not exceeding the paid laundry service fee except for damage incurred willfully or ",
  TH: "My Laundry จะไม่รับผิดชอบต่อ ก) การสึกหรอตามปกติ รอยรีดเนื่องจากการรีดซ้ำ ฯลฯ ข) ความเสียหายใดๆ ที่เกิดจากกระบวนการซักปกติ (รวมถึงแต่ไม่จำกัดเฉพาะสีตก รอยขาด ฯลฯ) ต่อสิ่งต่างๆ เช่น ผ้าม่าน ผ้าคลุมโซฟา เสื้อเชิ้ต กระโปรง ชุดเดรส สูท แจ็กเก็ต ฯลฯ หรือ ค) ความเสียหายใดๆ เช่น รูหรือรอยขาดขนาดเล็กในเสื้อผ้าที่เสื่อมสภาพหรือมีตำหนิ สำหรับเสื้อผ้าใดๆ ที่ถือว่าได้รับความเสียหาย My Laundry จะคืนเงินให้แก่ลูกค้าในกรณีที่เหมาะสมตามความเสียหายที่เกิดขึ้นจริง แต่ไม่เกินค่าบริการซักรีดที่ชำระแล้ว ยกเว้นความเสียหาย่เกิดขึ้นโดยจงใจหรือ ",
};
export const TEXT_TERM_8_2_2 = {
  EN: " gross negligence.",
  TH: " เป็นผลจากความประมาทเลินเล่ออย่างร้ายแรง",
};
export const TEXT_TERM_8_3 = {
  EN: "Any compensation or reimbursement owed to the Customer by My Laundry will be paid by wire transfer. My Laundry does not provide any other refund services such as buying alternative items. Any damaged items must be reported to us within 24 hours of their return date and time, and inspected by My Laundry through digital photos or in-person. After compensation is made to the Customer, My Laundry shall reserve the right to keep such items.",
  TH: "การชดเชยหรือการชำระเงินคืนใดๆ ที่ My Laundry ต้องชำระให้แก่ลูกค้าจะชำระโดยการโอนเงินผ่านธนาคาร My Laundry ไม่มีบริการคืนเงินอื่นใด เช่น การซื้อสิ่งของอื่นทดแทน ลูกค้าจะต้องแจ้งสิ่งของที่เสียหายภายใน 24 ชั่วโมงหลังจากวันที่และเวลาที่ส่งคืน ซึ่งจะตรวจสอบโดย My Laundry ผ่านภาพถ่ายดิจิทัลหรือโดยเจ้าหน้าที่ หลังจากทำการชดเชยให้กับลูกค้าแล้ว My Laundry ขอสงวนสิทธิในการเก็บสิ่งของดังกล่าว",
};
export const TEXT_TERM_9 = {
  EN: "Lost Items",
  TH: "รายการที่สูญหาย",
};
export const TEXT_TERM_9_1 = {
  EN: "The Customer must check and confirm the number of items received at the time return. Any lost item must be reported immediately to My Laundry. All claims will be reviewed on a case-by-case basis. Items are considered lost Thirty (30) days after the initial claim has been made. My Laundry limits our liability to the Customer for any lost item reported by the Customer to the actual cost of the lost item but not exceeding the paid service fee except for damage incurred willfully or as a result of gross negligence.",
  TH: "ลูกค้าจะต้องตรวจสอบและยืนยันจำนวนที่ได้รับเมื่อส่งคืน สิ่งที่สูญหายจะต้องแจ้งให้ My Laundry ทราบทันที ซึ่งจะตรวจสอบข้อเรียกร้องเป็นกรณีไป สิ่งของจะถือว่าสูญหายเมื่อครบสามสิบ (30) วันหลังจากแจ้งข้อเรียกร้อง My Laundry จะจำกัดความรับผิดต่อลูกค้าสำหรับสิ่งของสูญหายที่ลูกค้าแจ้งตามราคาจริงของสิ่งของที่สูญหาย แต่ไม่เกินค่าบริการที่ชำระแล้ว ยกเว้นความเสียหายที่เกิดขึ้นโดยจงใจหรือเป็นผลจากความประมาทเลินเล่ออย่างร้ายแรง",
};
export const TEXT_TERM_9_2 = {
  EN: "My Laundry shall not take responsibility for the loss of any loose item, such as watches, jewelry, detachable belts, or cufflinks.",
  TH: "My Laundry จะไม่รับผิดชอบต่อการสูญหายของสิ่งที่ไม่ยึดติดแน่น เช่น นาฬิกา เครื่องประดับ เข็มขัดแบบถอดออกได้ หรือกระดุมข้อมือ",
};
export const TEXT_TERM_10 = {
  EN: "Unclaimed orders",
  TH: "คำสั่งบริการที่ไม่มีผู้รับ ",
};
export const TEXT_ANY_ORDER_UNCLAIMED = {
  EN: "Any order unclaimed within one (1) month from the date of the bill will be donated to charity. We may attempt to contact the Customer to remind and notify you that your property is being scheduled for donation, but My Laundry does not guarantee that this will be done, nor that our attempts to contact you will be successful. ",
  TH: "คำสั่งบริการที่ไม่มีผู้รับเป็นเวลาหนึ่ง (1) เดือนนับจากวันที่เรียกเก็บเงินจะถูกบริจาคให้กับองค์กรการกุศล เราอาจติดต่อลูกค้าเพื่อแจ้งและบอกกล่าวให้ทราบถึงกำหนดการบริจาคทรัพย์สินของท่าน แต่ My Laundry ไม่อาจรับประกันว่าจะดำเนินการดังกล่าว หรือความพยายามในการติดต่อท่านจะประสบผลสำเร็จ ",
};
export const TEXT_TERM_11 = {
  EN: "Price and Payment",
  TH: "ค่าบริการและการชำระเงิน",
};

export const TEXT_TERM_11_1 = {
  EN: "The prices of our Services are displayed on our website and in our application and will be shown when you place your order. Our prices may change at any time, but this will not affect payments made for orders that we have already confirmed.",
  TH: "ค่าบริการของเราจะระบุบนเว็บไซต์และในแอปพลิเคชัน และจะแสดงเมื่อสั่งบริการ ค่าบริการอาจเปลี่ยนแปลงได้ตลอดเวลา แต่จะไม่ส่งผลต่อการชำระเงินสำหรับคำสั่งบริการที่ได้รับการยืนยันแล้ว",
};
export const TEXT_TERM_11_2 = {
  EN: "Payment is due at the time the Customer places an order. If for any reason My Laundry is unable to receive the payment, the Customer will be liable to My Laundry for the due payment plus interest at the rate of 3 percent per year above the local base lending rate. Interest will accrue ",
  TH: "ลูกค้าจะต้องชำระเงินเมื่อทำการสั่งบริการ หาก My Laundry ไม่ได้รับชำระเงินไม่ว่าด้วยเหตุผลใดก็ตาม ลูกค้าจะต้องรับผิดชอบต่อ My Laundry ในการชำระเงินที่ครบกำหนดพร้อมดอกเบี้ยในอัตราร้อยละ 3 ต่อปีจากอัตราสินเชื่อฐานท้องถิ่น ",
};
export const ON_DAILY_BASIS = {
  EN: "on a daily basis",
  TH: "ดอกเบี้ยจะพอกพูนทุกวัน",
};
export const TEXT_TERM_11_2_2 = {
  EN: " from the due date until payment is made. The Customer is obliged to pay the interest together with the overdue amount.",
  TH: " นับจากวันครบกำหนดจนกว่าจะชำระเงิน ลูกค้ามีหน้าที่ต้องชำระดอกเบี้ยพร้อมกับจำนวนเงินที่ค้างชำระ",
};
export const TEXT_TERM_12 = {
  EN: "Termination",
  TH: "การยุติบริการ",
};
export const TEXT_TERM_12_1 = {
  EN: "Notwithstanding any other legal rights to terminate or to rescind a contract, My Laundry shall retain the right to terminate the service agreement including these Terms at any time.",
  TH: "โดยไม่คำนึงถึงสิทธิตามกฎหมายอื่นใดในการบอกเลิกหรือยกเลิกสัญญา My Laundry จะมีสิทธิในการยุติข้อตกลงการบริการรวมถึงข้อกำหนดเหล่านี้ได้ตลอดเวลา ",
};
export const TEXT_TERM_12_2 = {
  EN: "In case of a termination according to clause 12.1, only the services performed up to that point, completed in themselves and evidenced according to the service agreement or these Terms, ",
  TH: "ในกรณีการยุติบริการตามข้อ 12.1 เฉพาะบริการที่ดำเนินการจนถึงจุดนั้น ซึ่งเสร็จสิ้นและมีหลักฐานตามข้อตกลงการบริการหรือข้อกำหนดเหล่านี้ ",
};
export const TEXT_HAVE_TO = {
  EN: "have to",
  TH: "จะต้อง",
};
export const TEXT_TERM_12_2_2 = {
  EN: " be remunerated, ",
  TH: " ได้รับค่าตอบแทน ",
};
export const TEXT_PROVIDED_THAT = {
  EN: "provided that",
  TH: "โดยมีเงื่อนไข",
};
export const TEXT_TERM_12_2_3 = {
  EN: " they are utilizable for us. Our claims for damages shall remain unaffected thereby.",
  TH: " ว่าจะต้องเหมาะสมกับเรา การเรียกร้องค่าเสียหายของเราจะไม่ได้รับผลกระทบใดๆ",
};
export const TEXT_TERM_13 = {
  EN: "Miscellaneous",
  TH: "ข้อกำหนดอื่นๆ",
};
export const TEXT_TERM_13_1 = {
  EN: "As our business changes, we may decide to modify some of the terms in this Agreement. Therefore, we encourage you to check back frequently to familiarize yourself with any changes.",
  TH: "เมื่อธุรกิจของเรามีการเปลี่ยนแปลง เราอาจตัดสินใจแก้ไขข้อกำหนดบางประการในข้อตกลงนี้ ดังนั้น เราจึงใคร่ขอให้ท่านกลับมาตรวจสอบเป็นครั้งคราว เพื่อรับทราบการเปลี่ยนแปลงใดๆ",
};
export const TEXT_TERM_13_2 = {
  EN: "These Terms are governed by Thai law and will be subject to the exclusive jurisdiction of the Thai courts.",
  TH: "ข้อกำหนดเหล่านี้อยู่ภายใต้กฎหมายไทยและจะอยู่ภายใต้เขตอำนาจศาลไทยแต่เพียงผู้เดียว",
};
export const TEXT_TERM_13_3 = {
  EN: "All related Parties (We/My Laundry and You/the Customer) agree that these Terms shall not violate any concerned laws. The unenforceability or invalidity of any provisions of these Terms shall be severed therefrom and not affect the force and validity of the remaining provisions which shall continue to be valid and enforceable to the extent permitted by laws.",
  TH: "บรรดาฝ่ายที่เกี่ยวข้องทั้งหมด (เรา/My Laundry และท่าน/ลูกค้า) ตกลงว่าข้อกำหนดเหล่านี้จะไม่ละเมิดกฎหมายที่เกี่ยวข้องใดๆ การไม่มีผลบังคับหรือการเป็นโมฆะของข้อความใดๆ ของข้อกำหนดเหล่านี้จะถูกแยกส่วนจากข้อกำหนดดังกล่าว และจะไม่ส่งผลกระทบต่อผลบังคับและความสมบูรณ์ของข้อกำหนดส่วนที่เหลือ ซึ่งจะยังคงสมบูรณ์และมีผลบังคับใช้ตามขอบเขตที่กฎหมายอนุญาต",
};

export const TEXT_PRIVACY_POLICY_TITLE = {
  EN: `My Laundry (“we,” “us,” “our”) provides professional laundry, ironing, shoe cleaning, and water delivery services (“Services”) for the customers.`,
  TH: `My Laundry (“เรา”) ให้บริการซักรีด รีดผ้า ทำความสะอาดรองเท้า และบริการจัดส่งน้ำอย่างมืออาชีพ (“บริการ”) ให้แก่ลูกค้า`,
};
export const TEXT_PRIVACY_POLICY_TITLE_1_2 = {
  EN: "This document (“Privacy Notice”) serves to provide information on the collection, use, disclosure, management, and handling of Personal Data by My Laundry, a Sole Proprietorship under Sharunthal Vorakarnpreechavuth, registered on 9 March 2022 through Commercial Registration at Pom Prab Sattru Phai District, operating with the Commercial name of “My Laundry” and registration number 1100800732810, and having its registered address at 128/71 Soi Maensri, Khlong Maha Nak, Pomprab Sattru Phai, Bangkok, 10100. My Laundry collects, uses, discloses, manages, and handles Personal Data subject to the Personal Data Protection Act B.E. 2562 (“PDPA”). By accessing our website, using any services provided by My Laundry, submitting any information to us, or otherwise showing your agreement thereon, you will be deemed to have agreed and consented to the terms of this Privacy Notice. When accessing our website, you can click on a link to access the details of our privacy notice and you will be requested to provide your consent by clicking on a button.",
  TH: "เอกสารนี้ (“ประกาศความเป็นส่วนตัว”) ทำหน้าที่ให้ข้อมูลเกี่ยวกับการรวบรวม การใช้ การเปิดเผย การบริหาร และการจัดการข้อมูลส่วนบุคคลของ My Laundry ซึ่งเป็นกิจการเจ้าของคนเดียวโดยฌรัลย์ธาร วรการปรีชาวุฒิ ได้จดทะเบียนการค้าเมื่อวันที่ 9 มีนาคม 2565 ที่เขตป้อมปราบศัตรูพ่าย ซึ่งดำเนินธุรกิจโดยใช้ชื่อทางการค้าว่า “My Laundry” เลขทะเบียนที่ 1100800732810 และที่อยู่จดทะเบียน 128/71 ซอยแม้นศรี แขวงคลองมหานาค เขตป้อมปราบศัตรูพ่าย กรุงเทพฯ 10100 My Laundry ทำการรวบรวม ใช้ เปิดเผย บริหารและจัดการข้อมูลส่วนบุคคลตามพระราชบัญญัติคุ้มครองข้อมูลส่วนบุคคล พ.ศ. 2562 (“พรบ. คุ้มครองข้อมูลส่วนบุคคล”) เมื่อมีการเข้าถึงเว็บไซต์ของเรา มีการใช้บริการใดๆ ของ My Laundry มีการจัดส่งข้อมูลใดๆ ให้เรา หรือแสดงข้อตกลงของท่าน จะถือว่าท่านได้ตกลงและยินยอมตามข้อกำหนดของประกาศความเป็นส่วนตัวนี้ เมื่อมีการเข้าถึงเว็บไซต์ของเรา ท่านสามารถคลิกที่ลิงก์เพื่อเข้าถึงรายละเอียดของประกาศความเป็นส่วนตัว และท่านจะได้รับการร้องขอให้แสดงความยินยอมโดยคลิกที่ปุ่ม",
};

export const TEXT_PRIVACY_POLICY_TITLE_2 = {
  EN: `My Laundry reserves the right to amend, alter, change, or modify this Privacy Notice at any time without prior notice. Any amendments, alterations, changes, or modifications to this Privacy Notice will be posted on our website from time to time. Subject to your rights under Thai law, you agree or shall be deemed to agree to be bound by any such amendments, alterations, changes, or modifications to the Privacy Notice by continuing to access our website, using our application, or availing yourself of any services provided by My Laundry, submitting information to us, or otherwise showing your agreement thereon.`,
  TH: "My Laundry ขอสงวนสิทธิในการแก้ไข ปรับปรุง เปลี่ยนแปลง หรือปรับเปลี่ยนประกาศความเป็นส่วนตัวได้ตลอดเวลาโดยไม่ต้องแจ้งให้ทราบล่วงหน้า การแก้ไข ปรับปรุง เปลี่ยนแปลง หรือปรับเปลี่ยนประกาศความเป็นส่วนตัวนี้จะถูกประกาศบนเว็บไซต์ของเราเป็นครั้งคราว ภายใต้สิทธิของท่านตามกฎหมายไทย ท่านตกลงหรือจะถือว่าตกลงที่จะผูกพันตามการแก้ไข ปรับปรุง เปลี่ยนแปลง หรือปรับเปลี่ยนประกาศความเป็นส่วนตัวดังกล่าวโดยการเข้าถึงเว็บไซต์ของเราต่อเนื่อง การใช้แอปพลิเคชันของเรา หรือการใช้ประโยชน์จากบริการใดๆ ที่จัดหาโดย My Laundry การส่งข้อมูลให้แก่เรา หรือการแสดงข้อตกลงของท่าน",
};
export const TEXT_PRIVACY_POLICY_TITLE_3 = {
  EN: "I. Contact Information",
  TH: "I. ข้อมูลการติดต่อ ",
};
export const TEXT_PRIVACY_NOTICE_1 = {
  EN: "1. Data Controller",
  TH: "1. ผู้ควบคุมข้อมูล",
};
export const TEXT_PRIVACY_NOTICE_1_1 = {
  EN: "128/71 Soi Maensri, Khlong Maha Nak, Pom Prab Sattru Phai, Bangkok, 10100, Thailand",
  TH: "128/71 ซอยแม้นศรี แขวงคลองมหานาค เขตป้อมปราบศัตรูพ่าย กรุงเทพฯ 10100 ประเทศไทย ",
};
export const TEXT_TEL = {
  EN: "Tel:",
  TH: "โทร.",
};
export const TEXT_PRIVACY_NOTICE_2 = {
  EN: "If you have any questions, comments, complaints, or suggestions in relation to data protection or this Privacy Notice or any other concerns about the way in which we process information about you, please contact:",
  TH: "หากมีคำถาม ข้อคิดเห็น ข้อร้องเรียน หรือคำแนะนำเกี่ยวกับการคุ้มครองข้อมูล ประกาศความเป็นส่วนตัว หรือข้อสงสัยอื่นใดเกี่ยวกับวิธีการประมวลผลข้อมูลเกี่ยวกับท่าน โปรดติดต่อ: ",
};

export const TEXT_PRIVACY_NOTICE_2_1 = {
  EN: "contact@mylaundrythai.com Subject: “Data Protection,” or",
  TH: "contact@mylaundrythai.com เรื่อง: “การคุ้มครองข้อมูล” หรือ ",
};
export const TEXT_PRIVACY_NOTICE_2_2 = {
  EN: "My Laundry – Data Protection, 128/71 Soi Maensri, Khlong Maha Nak,",
  TH: "My Laundry – การคุ้มครองข้อมูล 128/71 ซอยแม้นศรี แขวงคลองมหานาค",
};
export const TEXT_PRIVACY_NOTICE_2_3 = {
  EN: " Pom Prab Sattru Phai, Bangkok, 10100, Thailand",
  TH: "เขตป้อมปราบศัตรูพ่าย กรุงเทพฯ 10100 ประเทศไทย ",
};
export const TEXT_PRIVACY_NOTICE_II = {
  EN: "II. General information on data processing ",
  TH: "II. ข้อมูลทั่วไปในการประมวลผลข้อมูล ",
};
export const TEXT_PRIVACY_NOTICE_II_1 = {
  EN: "Scope, purpose, and legal basis of Personal Data processing",
  TH: "ขอบเขต วัตถุประสงค์ และพื้นฐานทางกฎหมายในการประมวลผลข้อมูลส่วนบุคคล ",
};
export const TEXT_PRIVACY_NOTICE_II_1_GENERAL = {
  EN: "Generally, we collect, use, and disclose your Personal Data only as it is necessary to provide a functioning website, to offer our services to you, and to provide you with information about us. For example, we need to know your name, address and similar information to provide our delivery and pick-up services. Furthermore, ",
  TH: "โดยทั่วไปแล้ว เราจะรวบรวม ใช้ และเปิดเผยข้อมูลส่วนบุคคลของท่านเฉพาะที่จำเป็นในการจัดหาเว็บไซต์ที่ดำเนินงาน เพื่อให้บริการของเราแก่ท่าน และเพื่อให้ข้อมูลของเราแก่ท่าน เช่น เราจำเป็นจะต้องทราบชื่อ ที่อยู่ และข้อมูลในลักษณะเดียวกันเพื่อให้บริการจัดส่งและรับสินค้า ",
};
export const TEXT_IN_ORDER_TO = {
  EN: "in order to",
  TH: "นอกจากนี้",
};
export const TEXT_PRIVACY_NOTICE_II_1_OPERATE = {
  EN: " operate this application and create a user-friendly service, we need to record your log-in and device data. To enhance the user experience, we also use tracking data such as cookies and similar technologies, so that the application can record prior orders and activities. Note that we only use Personal Data for these purposes. In this respect, the following Personal Data may be stored:",
  TH: " เพื่อใช้งานแอปพลิเคชันนี้และสร้างบริการที่เป็นมิตรต่อผู้ใช้ เราจำเป็นต้องบันทึกข้อมูลการเข้าสู่ระบบและข้อมูลอุปกรณ์ของท่าน เพื่อปรับปรุงประสบการณ์ของผู้ใช้ เราจึงใช้ข้อมูลในการติดตาม เช่น คุกกี้และเทคโนโลยีที่คล้ายคลึงกัน เพื่อให้แอปพลิเคชันสามารถบันทึกคำสั่งและกิจกรรมก่อนหน้า โปรดทราบว่าเราใช้ข้อมูลส่วนบุคคลเพื่อวัตถุประสงค์เหล่านี้เท่านั้น ด้วยเหตุนี้จึงอาจมีการจัดเก็บข้อมูลส่วนบุคคลดังต่อไปนี้:",
};
export const TEXT_PRIVACY_NOTICE_II_1_1 = {
  EN: "Basic Personal Data and contact data,",
  TH: "ข้อมูลส่วนบุคคลพื้นฐานและข้อมูลติดต่อ",
};
export const TEXT_PRIVACY_NOTICE_II_1_1_1 = {
  EN: " such as first and last name, e-mail address, postal address, phone number, and other similar contact data;",
  TH: " เช่น ชื่อและนามสกุล ที่อยู่อีเมล ที่อยู่ไปรษณีย์ หมายเลขโทรศัพท์ และข้อมูลติดต่ออื่นๆ ที่คล้ายคลึงกัน ",
};
export const TEXT_PRIVACY_NOTICE_II_1_2 = {
  EN: "User content,",
  TH: "เนื้อหาของผู้ใช้",
};
export const TEXT_PRIVACY_NOTICE_II_1_2_2 = {
  EN: " such as communications and files provided by you in relation to your use of the Services. ",
  TH: " เช่น การสื่อสารและไฟล์ที่ท่านให้ไว้เกี่ยวกับการใช้บริการของท่าน ",
};
export const TEXT_PRIVACY_NOTICE_II_1_3 = {
  EN: "Log data and device data,",
  TH: "ข้อมูลในการเข้าสู่ระบบและข้อมูลอุปกรณ์",
};
export const TEXT_PRIVACY_NOTICE_II_1_3_3 = {
  EN: " such as IP address and cookies;",
  TH: " เช่น ที่อยู่ IP และคุกกี้",
};
export const TEXT_PRIVACY_NOTICE_II_1_4 = {
  EN: "Tracking data,",
  TH: "ข้อมูลในการติดตาม",
};
export const TEXT_PRIVACY_NOTICE_II_1_4_4 = {
  EN: " cookies, and similar technologies.",
  TH: " คุกกี้ และเทคโนโลยีที่คล้ายคลึงกัน",
};
export const TEXT_PRIVACY_NOTICE_II_1_5 = {
  EN: "One-Time-Password (OTP)",
  TH: "รหัสผ่านแบบใช้ครั้งเดียว [One-Time-Password: (OTP)]",
};
export const TEXT_WHEN_YOU_MAKE_A_PAYMENT = {
  EN: "When you make a payment through any of the My Laundry channels, your payment data, such as payment card number (credit or debit card), and the security code associated with your payment instrument, may be stored by our payment gateway provider (paysolutions.asia). ",
  TH: "เมื่อชำระเงินผ่านช่องทางใดๆ ของ My Laundry ข้อมูลการชำระเงินของท่าน เช่น หมายเลขบัตรที่ชำระเงิน (บัตรเครดิตหรือเดบิต) และรหัสความปลอดภัยที่เกี่ยวข้องกับเครื่องมือการชำระเงินอาจถูกจัดเก็บโดยผู้ให้บริการเกตเวย์การชำระเงินของเรา (ข้อตกลงและเงื่อนไข (paysolutions.asia)",
};
export const TEXT_WE_PROCESS_PROVICY = {
  EN: "We process Personal Data about you for lawful reasons only; that means we process Personal Data only when it is:",
  TH: "เราประมวลผลข้อมูลส่วนบุคคลของท่านตามเหตุผลทางกฎหมายเท่านั้น ซึ่งหมายความว่าเราจะประมวลผลข้อมูลส่วนบุคคลก็ต่อเมื่อ: ",
};
export const TEXT_PRIVACY_NOTICE_II_1_6 = {
  EN: "necessary for the performance of an agreement:",
  TH: "มีความจำเป็นเพื่อการปฏิบัติตามข้อตกลง:",
};
export const TEXT_PRIVACY_NOTICE_II_1_6_1 = {
  EN: " where we have an agreement with you, including the terms and conditions of our Services, we will process your personal information in order to fulfill that agreement and/or terms and conditions (i.e., to provide you with Services);",
  TH: " ในกรณีที่มีข้อตกลงกับท่าน รวมถึงข้อกำหนดและเงื่อนไขในการบริการของเรา เราจะประมวลผลข้อมูลส่วนบุคคลของท่าน เพื่อปฏิบัติตาม ข้อตกลงและ/หรือข้อกำหนดและเงื่อนไขนั้น (เช่น เพื่อให้บริการแก่ท่าน)",
};
export const TEXT_IN_ORDER_TO_2 = {
  EN: "in order to",
  TH: "เพื่อปฏิบัติตาม",
};
export const TEXT_PRIVACY_NOTICE_II_1_6_2 = {
  EN: " fulfill that agreement and/or terms and conditions (i.e., to provide you with Services);",
  TH: " ข้อตกลงและ/หรือข้อกำหนดและเงื่อนไขนั้น (เช่น เพื่อให้บริการแก่ท่าน) ",
};
export const TEXT_PRIVACY_NOTICE_II_1_7 = {
  EN: "where you give us your consent:",
  TH: "เมื่อท่านให้ความยินยอมแก่เรา:",
};
export const TEXT_PRIVACY_NOTICE_II_1_7_1 = {
  EN: " we ask for your consent in relation to the use of personal information only where we need it in order to provide our Services; in such cases, we will collect such personal information separately and make it clear that we are asking for consent;",
  TH: " เราจะขอความยินยอมจากท่านในการใช้ข้อมูลส่วนบุคคลเฉพาะในกรณีที่จำเป็นเพื่อให้บริการของเรา ในกรณีดังกล่าว เราจะรวบรวมข้อมูลส่วนบุคคลโดยแยกส่วนจากข้อความอื่น และจะระบุชัดเจนว่าขอความยินยอม ",
};
export const TEXT_PRIVACY_NOTICE_II_1_8 = {
  EN: "for compliance with a legal obligation",
  TH: "เพื่อปฏิบัติตามข้อผูกพันทางกฎหมาย",
};
export const TEXT_PRIVACY_NOTICE_II_1_8_1 = {
  EN: " (e.g., to respond to a court order or a regulator). ",
  TH: " (เช่น เพื่อปฏิบัติตามคำสั่งศาลหรือหน่วยงานกำกับดูแล) ",
};
export const TEXT_NOTE_THAT_YOU_PROVICY = {
  EN: "Note that you can withdraw or limit your consent at any time. By your doing so, however, we will not be able to provide the Services of My Laundry anymore. In such a case, we reserve the right to close your account in accordance with our terms and conditions. You will be notified accordingly.",
  TH: "โปรดทราบว่าท่านสามารถเพิกถอนหรือจำกัดความยินยอมของท่านได้ตลอดเวลา อย่างไรก็ตาม การที่ท่านทำเช่นนั้น เราจะไม่สามารถให้บริการ My Laundry ได้อีกต่อไป ในกรณีดังกล่าว เราขอสงวนสิทธิในการปิดบัญชีของท่านตามข้อกำหนดและเงื่อนไขของเรา โดยท่านจะได้รับการแจ้งให้ทราบ ",
};
export const TEXT_YOUR_RIGHTS = {
  EN: "Your rights",
  TH: "สิทธิของท่าน",
};
export const TEXT_WE_WOULD_LIKE_PROVICY = {
  EN: "We would like to make sure that you are fully aware of ",
  TH: "เราต้องการให้แน่ใจว่าท่านรับทราบสิทธิในการปกป้องข้อมูล ",
};
export const TEXT_ALL_OF = {
  EN: "all of",
  TH: "ทั้งหมดของท่าน",
};
export const TEXT_WE_WOULD_LIKE_PROVICY_2 = {
  EN: " data protection rights. Every user is entitled to the following rights: ",
  TH: " ผู้ใช้ทุกคนมีสิทธิดังต่อไปนี้:",
};

export const TEXT_THE_RIGHTS_1 = {
  EN: "right to withdraw consent:",
  TH: "สิทธิในการเพิกถอนความยินยอม:",
};
export const TEXT_LEGALLY = {
  EN: "legally",
  TH: "ความยินยอมตามกฎหมายแล้ว",
};
export const TEXT_THE_RIGHTS_1_2 = {
  EN: " You have the right to withdraw the consent given to My Laundry for the collection, use, or disclosure of your Personal Data at any time unless there is a restriction of the withdrawal of consent by law or in the contract which gives benefits to you. The withdrawal of consent shall not affect the collection, use, or disclosure of Personal Data to which you have already given legally consent. As mentioned above, withdrawing your consent will require us to discontinue the services provided to you by My Laundry. You will be notified accordingly.",
  TH: " ท่านมีสิทธิในการเพิกถอนความยินยอมที่ให้ไว้กับ My Laundry ในการรวบรวม ใช้ หรือเปิดเผยข้อมูลส่วนบุคคลได้ตลอดเวลา เว้นแต่จะมีข้อจำกัดในการเพิกถอนความยินยอมตามกฎหมายหรือในสัญญาซึ่งให้ประโยชน์แก่ท่าน การเพิกถอนความยินยอมจะไม่ส่งผลกระทบต่อการรวบรวม ใช้ หรือเปิดเผยข้อมูลส่วนบุคคลซึ่งท่านได้ให้ความยินยอมตามกฎหมายแล้ว ดังที่กล่าวไว้ข้างต้น การเพิกถอนความยินยอมจะทำให้เราต้องหยุดให้บริการ My Laundry แก่ท่าน โดยท่านจะได้รับการแจ้งให้ทราบ ",
};
export const TEXT_THE_RIGHTS_2 = {
  EN: "right to access:",
  TH: "สิทธิในการเข้าถึง:",
};
export const TEXT_THE_RIGHT_2_2 = {
  EN: " You have the right to access your Personal Data which is under the responsibility of My Laundry and request that My Laundry provide copies of such data, or request that My Laundry disclose any information which is obtained without consent.",
  TH: " ท่านมีสิทธิในการเข้าถึงข้อมูลส่วนบุคคลของท่านซึ่งอยู่ภายใต้ความรับผิดชอบของ My Laundry และขอให้ My Laundry จัดทำสำเนาข้อมูลดังกล่าว หรือขอให้ My Laundry เปิดเผยข้อมูลใดๆ ที่ได้มาโดยไม่ได้รับความยินยอม ",
};
export const TEXT_THE_RIGHTS_3 = {
  EN: "right to know which Personal Data is collected and how it is used:",
  TH: "สิทธิในการรับทราบว่าข้อมูลส่วนบุคคลใดถูกรวบรวมและนำไปใช้อย่างไร:",
};
export const TEXT_THE_RIGHTS_3_3 = {
  EN: " You have the right to receive information on your Personal Data as a customer of My Laundry. The requested Personal Data will be in a format which is readable or commonly used (in accordance with your right to data portability and right to be informed of Personal Data). ",
  TH: " ท่านมีสิทธิในการได้รับทราบข้อมูลส่วนบุคคลของท่านในฐานะลูกค้าของ My Laundry ข้อมูลส่วนบุคคลที่ร้องขอจะอยู่ในรูปแบบที่สามารถอ่านได้หรือใช้โดยทั่วไป (ตามสิทธิของท่านในการขอให้โอนข้อมูลส่วนบุคคลและสิทธิในการรับทราบข้อมูลส่วนบุคคล) ",
};
export const TEXT_THE_RIGHTS_4 = {
  EN: "right to object to collection:",
  TH: "สิทธิในการคัดค้านการเก็บรวบรวม:",
};
export const TEXT_THE_RIGHTS_4_4 = {
  EN: " You have the right to object to the collection, use, or disclosure of your Personal Data at any time, as it is collected, used or disclosed for the purposes of direct marketing, research, or statistics, except where it is necessary for the operation of the Services.",
  TH: " ท่านมีสิทธิในการคัดค้านการเก็บรวบรวม ใช้ หรือเปิดเผยข้อมูลส่วนบุคคลของท่านได้ตลอดเวลา เนื่องจากข้อมูลดังกล่าวถูกรวบรวม ใช้ หรือเปิดเผยเพื่อวัตถุประสงค์ของการตลาดทางตรง การวิจัย หรือสถิติ เว้นแต่ในกรณีที่จำเป็นเพื่อการดำเนินงานบริการ ",
};
export const TEXT_THE_RIGHTS_5 = {
  EN: "right to erase, destroy, or anonymize Personal Data:",
  TH: "สิทธิในการลบ ทำลาย หรือทำให้ข้อมูลส่วนบุคคลไม่สามารถระบุตัวบุคคลได้:",
};

export const TEXT_THE_RIGHT_5_5 = {
  EN: " Under certain conditions, you have the right to request that My Laundry erase or destroy your Personal Data or anonymize your Personal Data so that it cannot identify you. The aforementioned conditions are for example when My Laundry no longer has a need to retain your data in relation to the purpose of collection or if you have withdrawn your consent or if you have objected against the collection or use of your Personal Data and we did not reject the objection, or your Personal Data has been unlawfully disclosed.",
  TH: " ภายใต้เงื่อนไขบางประการ ท่านมีสิทธิในการขอให้ My Laundry ลบหรือทำลายข้อมูลส่วนบุคคลของท่าน หรือทำให้ข้อมูลส่วนบุคคลของท่านไม่สามารถระบุตัวบุคคลเพื่อไม่ให้ระบุตัวตนของท่าน เงื่อนไขดังกล่าวข้างต้น ได้แก่ เมื่อ My Laundry ไม่จำเป็นต้องเก็บรักษาข้อมูลที่เกี่ยวข้องกับวัตถุประสงค์ในการเก็บรวบรวมอีกต่อไป หรือหากท่านเพิกถอนความยินยอม หรือหากท่านคัดค้านการรวบรวมหรือการใช้ข้อมูลส่วนบุคคลของท่านและเราไม่ได้ปฏิเสธการคัดค้าน หรือข้อมูลส่วนบุคคลของท่านถูกเปิดเผยโดยมิชอบด้วยกฎหมาย ",
};
export const TEXT_THE_RIGHTS_6 = {
  EN: "Right to restrict the use:",
  TH: "สิทธิในการจำกัดการใช้:",
};
export const TEXT_THE_RIGHTS_6_6 = {
  EN: " You have the right to request that My Laundry restrict the use of your Personal Data under certain conditions. The aforementioned conditions are, for example, when you could request the erasure or destruction of your Personal Data or when the lawful purpose of collection is no longer relevant but My Laundry needs to retain the data for compliance with or to defend legal claims, or pending an examination of Personal Data requested by you or pending an objection request.",
  TH: " ท่านมีสิทธิในการร้องขอให้ My Laundry จำกัดการใช้ข้อมูลส่วนบุคคลของท่านภายใต้เงื่อนไขบางประการ เงื่อนไขดังกล่าวข้างต้น ได้แก่ เมื่อท่านร้องขอให้ลบหรือทำลายข้อมูลส่วนบุคคลของท่าน หรือเมื่อวัตถุประสงค์ตามกฎหมายในการรวบรวมข้อมูลนั้นไม่เกี่ยวข้องแล้ว แต่ My Laundry จำเป็นจะต้องเก็บรักษาข้อมูลเพื่อให้สอดคล้องหรือป้องกันการเรียกร้องทางกฎหมาย หรืออยู่ระหว่างดำเนินการตรวจสอบข้อมูลส่วนบุคคลที่ท่านร้องขอหรืออยู่ระหว่างการร้องขอคัดค้าน ",
};

export const TEXT_THE_RIGHTS_7 = {
  EN: "Right to rectification:",
  TH: "สิทธิในการแก้ไข:",
};
export const TEXT_THE_RIGHTS_7_7 = {
  EN: " You have the right to request that My Laundry correct and change any information to make it complete, accurate, not misleading, and up to date, as well as the right to request that My Laundry complete any information you believe is incomplete. If My Laundry does not take action regarding your request, My Laundry shall record such a claim along with our reason. ",
  TH: " ท่านมีสิทธิในการร้องขอให้ My Laundry แก้ไขและเปลี่ยนแปลงข้อมูลใดๆ เพื่อความสมบูรณ์ ถูกต้อง ไม่สร้างความเข้าใจผิด และเป็นปัจจุบัน ตลอดจนสิทธิในการร้องขอให้ My Laundry ทำให้ข้อมูลใดๆ ที่ท่านเชื่อว่าไม่สมบูรณ์ครบถ้วนนั้นมีความสมบูรณ์ครบถ้วน หาก My Laundry ไม่ดำเนินการตามคำขอของท่าน My Laundry จะบันทึกข้อเรียกร้องดังกล่าวพร้อมเหตุผล ",
};
export const TEXT_THE_RIGHTS_8 = {
  EN: "right to complain:",
  TH: "สิทธิในการร้องเรียน:",
};
export const TEXT_THE_RIGHTS_8_8 = {
  EN: " You have the right to file a complaint if My Laundry, including our employees or service providers, violates or does not comply with the PDPA or notifications issued in accordance with the PDPA. ",
  TH: " ท่านมีสิทธิในการยื่นข้อร้องเรียนหาก My Laundry รวมถึงพนักงานหรือผู้ให้บริการของเรานั้นละเมิดหรือไม่ปฏิบัติตาม พรบ. คุ้มครองข้อมูลส่วนบุคคลหรือประกาศที่ออกตาม พรบ. คุ้มครองข้อมูลส่วนบุคคล ",
};
export const TEXT_IN_CASE_PRIVACY_1 = {
  EN: "In case you make a request, we will respond to you within thirty (30) days. Our contact details are shown in",
  TH: "ในกรณีที่ท่านมีคำร้องขอ เราจะตอบกลับภายในสามสิบ (30) วัน รายละเอียดการติดต่อของเราแสดงอยู่ใน",
};
export const TEXT_CLAUSE_I = {
  EN: " Clause I ",
  TH: " หมวด 1 ",
};
export const TEXT_IN_CASE_PRIVACY_2 = {
  EN: "of this Privacy Notice.",
  TH: "ของประกาศความเป็นส่วนตัว",
};
export const TEXT_IN_CASE_PRIVACY_3 = {
  EN: "In case you withdraw your consent to any or all use of your Personal Data, depending on the nature of your request, My Laundry may not be able to continue to provide its Services to you. ",
  TH: "ในกรณีที่ท่านเพิกถอนความยินยอมในการใช้ข้อมูลส่วนบุคคลของท่านไม่ว่าส่วนใดหรือทั้งหมด ทั้งนี้ขึ้นอยู่กับลักษณะของคำร้องขอของท่าน My Laundry อาจไม่สามารถให้บริการแก่ท่านต่อไปได้ ",
};
export const TEXT_PROVIDING_YOUR_PERSONAL_DATA = {
  EN: "When is it mandatory to provide data to us?",
  TH: "ท่านจำเป็นต้องให้ข้อมูลแก่เราเมื่อใด",
};
export const TEXT_PROVIDING_YOUR_PERSONAL_DATA_TO_OTHERS = {
  EN: "Providing your Personal Data to others",
  TH: "การให้ข้อมูลส่วนบุคคลของท่านแก่ผู้อื่น",
};
export const TEXT_PROVIDING_1 = {
  EN: "My Laundry will take appropriate and commercially reasonable technical, physical, and administrative measures to protect any Personal Data it possesses or controls from misuse or accidental, unlawful, or unauthorized destruction, loss, alteration, disclosure, acquisition, or access in accordance with the PDPA. Subject to the provisions of any applicable law, your Personal Data may be disclosed, for the purposes listed above (where applicable), to the following: ",
  TH: "My Laundry จะใช้มาตรการทางเทคนิค กายภาพ และการบริหารจัดการที่เหมาะสมและสมเหตุสมผลในเชิงพาณิชย์ เพื่อปกป้องข้อมูลส่วนบุคคลใดๆ ที่ครอบครองหรือควบคุมจากการใช้ในทางที่ผิด หรือการทำลายโดยไม่คาดคิด ผิดกฎหมาย หรือไม่ได้รับอนุญาต การสูญหาย การเปลี่ยนแปลง การเปิดเผย การได้มา หรือการเข้าถึงตาม พรบ. คุ้มครองข้อมูลส่วนบุคคล ภายใต้บทบัญญัติของกฎหมายที่บังคับใช้ใดๆ ข้อมูลส่วนบุคคลของท่านอาจถูกเปิดเผยเพื่อวัตถุประสงค์ที่ระบุไว้ข้างต้น (หากมี) แก่บุคคลดังต่อไปนี้: ",
};
export const TEXT_PROVIDING_A = {
  EN: "a.",
  TH: "ก.",
};
export const TEXT_PROVIDING_A_1 = {
  EN: " agents, contractors, business partners, or third-party service providers who provide services to My Laundry. ",
  TH: " ตัวแทน ผู้รับจ้าง หุ้นส่วนธุรกิจ หรือผู้ให้บริการภายนอกซึ่งให้บริการแก่ My Laundry",
};
export const TEXT_PROVIDING_B = {
  EN: "b.",
  TH: "ข.",
};
export const TEXT_PROVIDING_B_2 = {
  EN: " our professional advisers such as auditors and lawyers.",
  TH: " ที่ปรึกษาของเรา เช่น ผู้สอบบัญชีและทนายความ",
};
export const TEXT_PROVIDING_C = {
  EN: "c.",
  TH: "ค.",
};
export const TEXT_PROVIDING_C_3 = {
  EN: " relevant government regulators, statutory boards or authorities, or law enforcement agencies to comply with any laws, rules, guidelines and regulations or schemes imposed by any governmental authority; and ",
  TH: " หน่วยงานกำกับดูแลของรัฐบาลที่เกี่ยวข้อง คณะกรรมการหรือหน่วยงานตามกฎหมาย หรือหน่วยงานบังคับใช้กฎหมายเพื่อให้ปฏิบัติตามกฎหมาย กฎ แนวทางปฏิบัติ และข้อบังคับหรือแผนงานที่กำหนดโดยหน่วยงานของรัฐ และ",
};
export const TEXT_PROVIDING_D = {
  EN: "d.",
  TH: "ง.",
};
export const TEXT_PROVIDING_D_3 = {
  EN: " any other party to whom you specifically authorize us to disclose your Personal Data. ",
  TH: " บุคคลอื่นใดที่ท่านอนุญาตให้เราเปิดเผยข้อมูลส่วนบุคคลของท่านเป็นการเฉพาะ",
};
export const TEXT_YOU_CONSENT_AND_AGREE = {
  EN: "You consent and agree to My Laundry transferring your Personal Data outside of Thailand for any of the purposes listed above. My Laundry will ensure that the destination country has appropriate and sufficient safeguards and confirm with a third party who has the right to access such data that it will be protected under the standards of Personal Data protection comparable to the law of Thailand or comply with the relevant rules and regulations for the protection of Personal Data. ",
  TH: "ท่านยินยอมและตกลงให้ My Laundry โอนข้อมูลส่วนบุคคลของท่านนอกประเทศไทยเพื่อวัตถุประสงค์ใดๆ ที่ระบุข้างต้น My Laundry จะตรวจสอบว่าประเทศปลายทางมีการป้องกันที่เหมาะสมและเพียงพอ และยืนยันกับบุคคลที่สามซึ่งมีสิทธิในการเข้าถึงข้อมูลดังกล่าวว่าจะได้รับการคุ้มครองภายใต้มาตรฐานการคุ้มครองข้อมูลส่วนบุคคลที่เทียบได้กับกฎหมายของประเทศไทย หรือมีการปฏิบัติตามกฎและข้อบังคับที่เกี่ยวข้องในการคุ้มครองข้อมูลส่วนบุคคล ",
};
export const TEXT_MY_LAUNDRY_WILL_NOT = {
  EN: "My Laundry will not disclose or transfer your Personal Data to any third party, within or outside the Kingdom of Thailand, unless it is necessary to do so in order to maintain or provide Services to you, or to comply with the law or an order of the government. In the case that failing to do so would violate the law, My Laundry shall first send the legal notice to you. For more details on this, you may refer to our server provider:",
  TH: "My Laundry จะไม่เปิดเผยหรือโอนข้อมูลส่วนบุคคลของท่านไปยังบุคคลที่สามใดๆ ไม่ว่าภายในหรือภายนอกราชอาณาจักรไทย เว้นแต่จะมีความจำเป็นเพื่อรักษาหรือให้บริการแก่ท่าน หรือเพื่อปฏิบัติตามกฎหมายหรือคำสั่งของรัฐบาล ในกรณีที่การไม่ดำเนินการดังกล่าวถือเป็นการละเมิดกฎหมาย My Laundry จะส่งประกาศทางกฎหมายให้ท่านก่อน ท่านสามารถอ่านข้อมูลเพิ่มเติมเกี่ยวกับเรื่องนี้จากผู้ให้บริการเซิร์ฟเวอร์ของเรา",
};
export const TEXT_MY_LAUNDRY_WILL_NOT_2 = {
  EN: "In this regard, we would like to inform you that your Personal Data will be stored on cloud solutions provided by our service provider. This means that your Personal Data is not stored physically on a hard-drive at our offices in Thailand. Our service provider operates servers all over the world and will store your Personal Data depending on the requirements and capacity of the servers at different locations, which may be outside of Thailand.",
  TH: "ทั้งนี้ เราขอแจ้งให้ทราบว่าข้อมูลส่วนบุคคลของท่านจะถูกจัดเก็บบนโซลูชันระบบคลาวด์โดยผู้ให้บริการของเรา ซึ่งหมายความว่าข้อมูลส่วนบุคคลของท่านจะไม่ถูกจัดเก็บทางกายภาพบนฮาร์ดไดรฟ์ที่สำนักงานของเราในประเทศไทย ผู้ให้บริการของเราดำเนินการเซิร์ฟเวอร์ทั่วโลก และจะจัดเก็บข้อมูลส่วนบุคคลของท่านโดยขึ้นอยู่กับข้อกำหนดและความจุของเซิร์ฟเวอร์ในสถานที่ต่างๆ ซึ่งอาจอยู่นอกประเทศไทย",
};

export const TEXT_WE_WILL_USE = {
  EN: "We will use your Personal Data in accordance with this Privacy Notice and your consent to such usage. We will ensure that there is an appropriate measure of protection in case of the collection and usage as well as the transfer of data (If any) to be in compliance with the relevant laws.",
  TH: "เราจะใช้ข้อมูลส่วนบุคคลของท่านตามประกาศความเป็นส่วนตัวและความยินยอมของท่านในการให้ใช้ข้อมูล เราจะตรวจสอบว่ามีมาตรการป้องกันที่เหมาะสมในกรณีที่มีการรวบรวมและการใช้ข้อมูล ตลอดจนการโอนข้อมูล (หากมี) เพื่อให้เป็นไปตามกฎหมายที่เกี่ยวข้อง ",
};
export const TEXT_WHEN_IS_IT = {
  EN: "When is it mandatory to provide data to us?",
  TH: "ท่านจำเป็นต้องให้ข้อมูลแก่เราเมื่อใด",
};
export const TEXT_IT_IS_NECESSARY = {
  EN: "It is necessary to provide us with your Personal Data in order for us to provide you with our Services that you request. Otherwise, we will not be able to deliver our full Services to you without the data.",
  TH: "ท่านจำเป็นต้องให้ข้อมูลส่วนบุคคลของท่านเพื่อที่เราจะได้ให้บริการตามที่ท่านร้องขอ มิฉะนั้น เราจะไม่สามารถให้บริการเต็มรูปแบบแก่ท่านโดยปราศจากข้อมูล ",
};
export const TEXT_DATA_RETENTION = {
  EN: "Data retention",
  TH: "การเก็บรักษาข้อมูล",
};
export const TEXT_INGENERAL_PROVICY = {
  EN: "In general, we will retain our users’ Personal Data as long as it is required for the respective purpose of processing the data and complying with applicable law and any applicable recordkeeping provisions for approximately ten (10) years. Our users’ Personal Data may also be contained in backup files, which we keep for information security purposes and which we regularly delete when the backup period is over. ",
  TH: "โดยทั่วไปแล้วเราจะเก็บรักษาข้อมูลส่วนบุคคลของผู้ใช้ตราบเท่าที่จำเป็นเพื่อวัตถุประสงค์ในการประมวลผลข้อมูลที่เกี่ยวข้อง และเพื่อปฏิบัติตามกฎหมายที่บังคับใช้และข้อกำหนดการเก็บบันทึกใดๆ ที่เกี่ยวข้องเป็นระยะเวลาประมาณสิบ (10) ปี ข้อมูลส่วนบุคคลของผู้ใช้อาจอยู่ในไฟล์สำรองข้อมูล ซึ่งเก็บไว้เพื่อจุดประสงค์ด้านความปลอดภัยของข้อมูล และจะลบเป็นประจำเมื่อระยะเวลาสำรองข้อมูลสิ้นสุดลง ",
};
export const TEXT_WHERE_WE_PROCESS_PROVICY = {
  EN: "Where we process your Personal Data for marketing purposes with your consent, we shall process the data until you request us to stop. The request shall be complied with by My Laundry within thirty (30) days and shall be kept as a record that you will no longer be allowing us to process your data.",
  TH: "เมื่อเราประมวลผลข้อมูลส่วนบุคคลของท่านเพื่อวัตถุประสงค์ทางการตลาดโดยได้รับความยินยอมจากท่าน เราจะประมวลผลข้อมูลจนกว่าท่านจะร้องขอให้เรายุติ โดย Laundry จะปฏิบัติตามคำร้องขอภายในสามสิบ (30) วัน และจะถูกเก็บไว้ในบันทึกว่าท่านไม่อนุญาตให้เราประมวลผลข้อมูลของท่านอีกต่อไป ",
};
export const TEXT_PRIVACY_NOTICE_III = {
  EN: "III. How we use your Personal Data ",
  TH: "III. เราใช้ข้อมูลส่วนบุคคลของท่านอย่างไร ",
};
export const TEXT_PRIVACY_NOTICE_III_1 = {
  EN: "1. Provision of the website (www.mylaundrythai.com) ",
  TH: "1. ข้อกำหนดของเว็บไซต์ (www.mylaundrythai.com) ",
};
export const TEXT_EACH_TIME_III = {
  EN: "Each time our website is accessed, our system automatically collects data and information from the computer system of the calling computer. The following data are collected: ",
  TH: "ทุกครั้งที่มีการเข้าถึงเว็บไซต์ของเรา ระบบจะเก็บรวบรวมข้อมูล รวมทั้งข้อมูลจากระบบคอมพิวเตอร์ของคอมพิวเตอร์ที่ใช้ติดต่อโดยอัตโนมัติ โดยจะมีการรวบรวมข้อมูลต่อไปนี้:",
};
export const TEXT_PRIVACY_NOTICE_III_1_1 = {
  EN: "Browser type information and version used; ",
  TH: "ข้อมูลประเภทเบราว์เซอร์และเวอร์ชั่นที่ใช้ ",
};
export const TEXT_PRIVACY_NOTICE_III_1_2 = {
  EN: "The operating system of the user;",
  TH: "ระบบปฏิบัติการของผู้ใช้",
};
export const TEXT_PRIVACY_NOTICE_III_1_3 = {
  EN: "Internet service provider of the user; ",
  TH: "ผู้ให้บริการอินเทอร์เน็ตของผู้ใช้ ",
};
export const TEXT_PRIVACY_NOTICE_III_1_4 = {
  EN: "IP address; ",
  TH: "ที่อยู่ IP",
};
export const TEXT_PRIVACY_NOTICE_III_1_5 = {
  EN: "Date and time of access; ",
  TH: "วันที่และเวลาในการเข้าถึง",
};
export const TEXT_PRIVACY_NOTICE_III_1_6 = {
  EN: "Websites from which the user accesses the website;",
  TH: "เว็บไซต์ที่ผู้ใช้เข้าถึงเว็บไซต์",
};
export const TEXT_PRIVACY_NOTICE_III_1_7 = {
  EN: "Content that is accessed by the user.",
  TH: "เนื้อหาที่ผู้ใช้เข้าถึง",
};
export const TEXT_THE_TEMPORALY = {
  EN: "The temporary storage of the IP address is necessary to deliver the website to the computer of the user. The user’s IP address must be kept for the duration of the session. The collection of the data for the provision of the website is mandatory for the operation of the website. The user is not entitled to revocation. ",
  TH: "การจัดเก็บที่อยู่ IP ชั่วคราวเป็นสิ่งที่ต้องทำในการส่งเว็บไซต์ไปยังคอมพิวเตอร์ของผู้ใช้ โดยจะต้องเก็บที่อยู่ IP ของผู้ใช้ไว้ตลอดระยะเวลาในการใช้งาน การเก็บรวบรวมข้อมูลตามข้อกำหนดเว็บไซต์เป็นสิ่งจำเป็นในการดำเนินงานของเว็บไซต์ ผู้ใช้ไม่มีสิทธิในการเพิกถอน ",
};
export const TEXT_COOKIES = {
  EN: " Cookies",
  TH: " คุกกี้",
};
export const TEXT_COOKIES_1 = {
  TH: "คุกกี้คือข้อมูลขนาดเล็กที่เว็บไซต์จัดเก็บบนอุปกรณ์ของท่านเมื่อเข้าชมเว็บไซต์ และจากนั้นจะถูกอ่านเมื่อท่านเข้าชมเว็บไซต์อีกครั้ง เราอาจใช้คุกกี้เพื่อตรวจสอบบัญชีของท่าน ปรับปรุงประสบการณ์การใช้งานเว็บไซต์ และให้บริการของเราอย่างมีประสิทธิภาพ ท่านสามารถควบคุมการใช้คุกกี้และเลือกที่จะปิดใช้งานหรือจำกัดการส่งคุกกี้โดยเปลี่ยนการตั้งค่าเบราว์เซอร์ของท่าน การปิดใช้งานคุกกี้อาจก่อให้เกิดการจำกัดการทำงานและบริการของเรา และในบางกรณีอาจหมายความว่าเราไม่สามารถให้บริการแก่ท่านได้ทั้งหมดหรือบางส่วน ",
  EN: "A cookie is a small piece of data that a website stores on your device when you visit it and which is then read when you revisit the site. We may use cookies to verify your account, improve your experience of a website, and provide our Services efficiently. You can control the use of cookies and choose to disable or restrict the transmission of cookies by changing your browser settings. Disabling cookies may result in a limited experience of our functionality and Services and, in some cases, may mean that we are fully or partially unable to provide you with the Services. ",
};
export const TEXT_GOOGLE_PRODUCT = {
  EN: " Google products",
  TH: " ผลิตภัณฑ์ของ Google",
};
export const TEXT_GOOGLE_PRODUCT_1 = {
  EN: "My Laundry uses Google products including Google Analytics, Google Tag Manager",
  TH: "My Laundry ใช้ผลิตภัณฑ์ของ Google เช่น Google Analytics, Google Tag Manager",
};
export const TEXT_GOOGLE_PRODUCT_2 = {
  EN: " and Google Search Console",
  TH: " และ Google Search Console",
};

export const TEXT_GOOGLE_PRODUCT_3 = {
  TH: " โปรดดูนโยบายความเป็นส่วนตัวของ Google ได้ที่นี่:",
  EN: ". Google’s privacy policies can be found here:",
};
export const TEXT_GOOGLE_PRODUCT_4 = {
  EN: "More information about how My Laundry uses Google Analytics can be found",
  TH: "โปรดดูข้อมูลเพิ่มเติมเกี่ยวกับการใช้ Google Analytics ของ My Laundry ได้ที่นี่:",
};
export const TEXT_GOOGLE_PRODUCT_5 = {
  EN: "To provide website visitors with more choices on how Google Analytics collects their data, Google has developed the Google Analytics Opt-out Browser Add-on. The Google Analytics Opt-out Browser Add-on does not prevent information from being sent to the website itself or other web analytics services. Learn more about the",
  TH: "เพื่อให้ผู้เข้าชมเว็บไซต์มีทางเลือกมากขึ้นเกี่ยวกับวิธีที่ Google Analytics รวบรวมข้อมูล Google จึงได้พัฒนา Google Analytics Opt-out Browser Add-on ซึ่งไม่ได้ป้องกันการส่งข้อมูลไปยังเว็บไซต์หรือบริการวิเคราะห์เว็บอื่นๆ โปรดดูข้อมูลเพิ่มเติมเกี่ยวกับ",
};
export const TEXT_SOCIAL_MEDIA_PROVICY = {
  EN: " Social media and messengers",
  TH: " โซเชียลมีเดียและ messengers",
};
export const TEXT_SOCIAL_MEDIA_PROVICY_1 = {
  EN: "My Laundry uses social media and messenger applications to enhance our service provision. In particular, we have a Facebook page, Instagram account, Twitter account, YouTube channel, TikTok account, Pinterest account, Telegram account, Line account, WhatsApp account, and WeChat account.",
  TH: "My Laundry ใช้โซเชียลมีเดียและแอปพลิเคชั่น Messenger เพื่อปรับปรุงการให้บริการของเรา เรามีเพจ Facebook บัญชี Instagram บัญชี Twitter ช่อง YouTube บัญชี TikTok บัญชี Pinterest บัญชี Telegram บัญชี Line บัญชี WhatsApp และบัญชี WeChat ",
};
export const TEXT_SOCIAL_MEDIA_1 = {
  EN: "Our Facebook page is administered by Facebook, in accordance with Facebook's Data Policy",
  TH: "เพจ Facebook บริหารจัดการโดย Facebook ตามนโยบายข้อมูลของ Facebook",
};
export const TEXT_HERE = {
  EN: "here",
  TH: "ที่นี่",
};
export const TEXT_SOCIAL_MEDIA_1_2 = {
  EN: ", and is accessible by Facebook users who have already consented to Facebook's Data Policy.",
  TH: " และผู้ใช้ Facebook ซึ่งยอมรับนโยบายข้อมูลของ Facebook แล้วจะสามารถเข้าถึงได้",
};
export const TEXT_SOCIAL_MEDIA_2 = {
  EN: "Our Instagram account is administered by Instagram, in accordance with their privacy policy",
  TH: "บัญชี Instagram บริหารจัดการโดย Instagram ตามนโยบายความเป็นส่วนตัว",
};
export const TEXT_SOCIAL_MEDIA_3 = {
  EN: "Our Twitter account is administered by Twitter, in accordance with their privacy policy",
  TH: "บัญชี Twitter account บริหารจัดการโดย Twitter ตามนโยบายความเป็นส่วนตัว",
};

export const TEXT_SOCIAL_MEDIA_4 = {
  EN: "Our YouTube channel is administered by YouTube, in accordance with their privacy policy",
  TH: "ช่อง YouTube บริหารจัดการโดย YouTube ตามนโยบายความเป็นส่วนตัว",
};
export const TEXT_SOCIAL_MEDIA_5 = {
  EN: "Our TikTok account is administered by TikTok, in accordance with their privacy policy",
  TH: "บัญชี TikTok บริหารจัดการโดย TikTok ตามนโยบายความเป็นส่วนตัว",
};

export const TEXT_SOCIAL_MEDIA_6 = {
  EN: "Our Pinterest account is administered by Pinterest, in accordance with their privacy policy",
  TH: "บัญชี Pinterest บริหารจัดการโดย Pinterest ตามนโยบายความเป็นส่วนตัว",
};
export const TEXT_SOCIAL_MEDIA_7 = {
  EN: "Our Telegram account is administered by Telegram, in accordance with their privacy policy",
  TH: "บัญชี Telegram บริหารจัดการโดย Telegram ตามนโยบายความเป็นส่วนตัว",
};
export const TEXT_SOCIAL_MEDIA_8 = {
  EN: "Our Line account is administered by Line, in accordance with their privacy policy",
  TH: "บัญชี Line บริหารจัดการโดย Line ตามนโยบายความเป็นส่วนตัว",
};

export const TEXT_SOCIAL_MEDIA_9 = {
  EN: "Our Whatsapp account is administered by Whatsapp, in accordance with their privacy policy",
  TH: "บัญชี Whatsapp บริหารจัดการโดย Whatsapp ตามนโยบายความเป็นส่วนตัว",
};

export const TEXT_SOCIAL_MEDIA_10 = {
  EN: "Our Viber account is administered by Viber Signal, in accordance with their privacy policy",
  TH: "บัญชี Viber บริหารจัดการโดย Viber Signal ตามนโยบายความเป็นส่วนตัว",
};

export const TEXT_SOCIAL_MEDIA_11 = {
  EN: "Our KakaoTalk account is administered by KakaoTalk, in accordance with their privacy policy",
  TH: "บัญชี KakaoTalk บริหารจัดการโดย KakaoTalk ตามนโยบายความเป็นส่วนตัว",
};

export const TEXT_SOCIAL_MEDIA_12 = {
  TH: "เราใช้การส่งข้อความโดยตรงทางโซเชียลมีเดียและแอปพลิเคชัน messenger อื่นๆ ในการสื่อสารกับลูกค้า",
  EN: "We use direct messaging over social media and other messenger applications to communicate with our customers. ",
};

export const TEXT_SOCIAL_MEDIA_13 = {
  EN: "Our WeChat account is administered by WeChat, in accordance with their privacy policy",
  TH: "บัญชี WeChat บริหารจัดการโดย WeChat ตามนโยบายความเป็นส่วนตัว",
};
export const TEXT_SOCIAL_MEDIA_14 = {
  EN: "Our Signal account is administered by Signal, in accordance with their privacy policy",
  TH: "บัญชี Signal บริหารจัดการโดย Signal ตามนโยบายความเป็นส่วนตัว",
};

export const TEXT_SECURYTY_IV = {
  EN: "IV. Security Measures ",
  TH: "IV. มาตรการความปลอดภัย ",
};

export const TEXT_SECURYTY_1 = {
  EN: "My Laundry considers the importance of data security as one of our priorities. We have issued measures to provide and maintain appropriate security and protection for the Personal Data which is collected by My Laundry and stored in My Laundry’s data storage as prescribed by law. ",
  TH: "My Laundry ตระหนักถึงความสำคัญของความปลอดภัยของข้อมูลเป็นหนึ่งในลำดับความสำคัญของเรา เราได้ออกมาตรการเพื่อจัดหาและรักษาความปลอดภัยและการป้องกันอย่างเหมาะสมซึ่งข้อมูลส่วนบุคคลที่ My Laundry รวบรวมและจัดเก็บไว้ในที่จัดเก็บข้อมูลของ My Laundry ตามที่กฎหมายกำหนด ",
};

export const TEXT_SECURYTY_2 = {
  EN: "Any Personal Data we receive or obtain from you as in",
  TH: "ข้อมูลส่วนบุคคลใดๆ ที่เรารับหรือได้รับจากท่านตาม",
};
export const TEXT_CLAUSE_II = {
  EN: " Clause II ",
  TH: " หมวด 2 ",
};
export const TEXT_SECURYTY_2_2 = {
  EN: "will be in compliance with this Privacy Notice and the PDPA.",
  TH: "จะเป็นไปตามประกาศความเป็นส่วนตัวและ พรบ. คุ้มครองข้อมูลส่วนบุคคล",
};
export const TEXT_MYLAUNDRY_BAG = {
  EN: "My Laundry Bag",
  TH: "ถุงใส่ผ้ามายลอนดรี้",
};
